var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "312",
      "height": "166",
      "viewBox": "0 0 312 166",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M212.243 52.1954L212.512 52.5377L211.991 52.6898L211.56 52.8989L210.501 53.0511L209.549 53.2983L209.118 53.8307L209.46 54.3441L209.711 54.9526L209.352 55.466L209.495 55.9414L209.334 56.3787L208.4 56.3407L208.957 57.1393L208.4 57.4626L208.149 58.1852L208.346 58.9268L208.023 59.269L207.646 59.155L206.928 59.3261L206.892 59.6494H206.156L205.743 60.3529L205.886 61.3797L204.701 61.8932L204.001 61.7791L203.839 62.0453L203.229 61.8932L202.277 62.0833L200.553 61.4558L201.253 60.3529L201.056 59.5733L200.284 59.3641L200.068 58.5845L199.583 57.6147L199.871 56.9492L199.422 56.759L199.512 55.8653L199.619 54.3441L200.679 54.8195L201.379 54.6483L201.451 54.0969L202.169 53.9258L202.636 53.5455L202.6 52.5757L203.354 52.3285L203.408 51.9102L203.929 52.2334L204.216 52.2714H204.755L205.527 52.5377L205.85 52.6708L206.461 52.2905L206.838 52.5186L206.999 51.9672L207.574 51.9862L207.682 51.8151L207.646 51.3207L207.951 50.9023L208.544 51.1686L208.526 51.5489L208.831 51.6059L208.993 52.6327L209.477 53.0321L209.747 52.7658L210.142 52.6517L210.591 52.1003L211.273 52.1954H212.243Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M165.234 111.223L165.342 111.603L165.216 112.193L165.378 112.763L165.216 113.22L165.288 113.638L163.187 113.619L163.044 117.517L163.69 118.506L164.337 119.266L162.469 119.761L160.045 119.59L159.363 119.019L155.287 119.057L155.143 119.152L154.55 118.601L153.904 118.563L153.293 118.772L152.809 119L152.719 118.24L152.88 117.156L153.239 116.034L153.293 115.52L153.635 114.417L153.886 113.923L154.478 113.124L154.82 112.573L154.927 111.679L154.874 110.976L154.586 110.538L154.317 109.797L154.083 109.074L154.137 108.808L154.443 108.333L154.155 107.154L153.94 106.336L153.437 105.556L153.545 105.328L153.958 105.157L154.263 105.176L154.622 105.043L157.621 105.062L157.854 105.956L158.142 106.697L158.375 107.097L158.752 107.724L159.434 107.629L159.758 107.458L160.314 107.629L160.476 107.325L160.745 106.621L161.374 106.564L161.428 106.355H161.948L161.859 106.792L163.08 106.773L163.098 107.553L163.295 108.009L163.133 108.751L163.205 109.512L163.529 109.968L163.457 111.413L163.708 111.299L164.139 111.337L164.768 111.147L165.234 111.223Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M153.402 104.943L153.133 104.031L153.546 103.498L153.851 103.289L154.228 103.707L153.869 103.974L153.689 104.278L153.654 104.81L153.402 104.943Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M159.277 45.8047L159.349 46.0329L159.6 45.9188L159.815 46.242L160.049 46.3751L160.157 46.8125L160.067 47.2308L160.246 47.7442L160.659 48.0295L160.677 48.3527L160.372 48.5239L160.354 48.9232L159.959 49.5127L159.797 49.4366L159.762 49.1704L159.205 48.752L159.079 48.1816L159.097 47.3449L159.187 46.9836L159.025 46.7935L158.936 46.3942L159.277 45.8047Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M196.656 66.4769L196.89 67.4467H196.387V68.2453L196.584 68.4165L196.154 68.6637L196.189 69.1581L195.956 69.6525V70.1469L195.776 70.4131L192.742 69.8046L192.257 68.5496L192.203 68.2834L192.365 68.2073L192.437 68.5496L193.191 68.3594L194.017 68.3975L194.627 68.4355L195.22 67.5988L195.884 66.8192L196.423 66.0586L196.656 66.4769Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M84.051 164.401L83.5123 164.363H82.6145L81.5371 161.777L82.0938 162.31L82.8659 163.184L84.2665 163.888L85.5773 164.173L85.4337 164.744L84.6436 164.801L84.051 164.401Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M78.5758 125.049L80.6049 127.026L81.4309 127.216L82.7417 128.129L83.8011 128.604L83.9987 129.137L83.2445 131L84.286 131.324L85.4172 131.514L86.1714 131.324L86.9435 130.373L86.9974 129.308L87.4643 129.061L88.0389 129.783L88.1107 130.753L87.3565 131.419L86.764 131.913L85.8123 133.111L84.7349 134.765L84.6451 135.754L84.5733 137.009L84.7888 138.226L84.6271 138.492L84.699 139.272L84.7528 139.918L86.1534 140.964L86.1894 141.801L86.8897 142.333L86.9435 142.923L86.351 144.482L85.094 145.148L83.2625 145.395L82.1851 145.262L82.5622 146.003L82.5801 146.897L82.9033 147.506L82.4544 147.943L81.5386 148.114L80.5331 147.658L80.2637 147.981L80.7126 149.179L81.4309 149.54L81.8439 149.16L82.2928 149.787L81.5386 150.168L81.0179 150.928L81.2334 152.126L81.2154 152.773H80.3535L79.8148 153.381L79.8328 154.294L80.9999 155.169L81.9337 155.397L81.9696 156.481L81.1436 157.146L81.0359 158.534L80.4074 158.991L80.2458 159.542L80.9999 160.778L81.8259 161.444L81.4489 161.387L80.569 161.197L78.3963 161.044L77.7678 160.36L77.4266 159.485L76.87 159.561L76.4031 159.124L75.8465 157.888L76.3313 157.355L76.3492 156.614L76.026 156.005L76.1517 154.979L75.9542 153.4L75.631 152.697L75.9542 152.469L75.7028 152.012L75.2 151.784L75.3437 151.271L74.787 150.814L74.1226 149.426L74.4279 149.179L73.8353 147.696L73.6917 146.46L73.6558 145.376L74.1047 144.939L73.5121 143.741L73.2248 142.638L73.7635 141.839L73.5121 140.812L73.7994 139.633L73.548 138.511L73.2607 138.283L72.3809 136.172L72.758 134.917L72.4527 133.739L72.6143 132.617L73.0812 131.476L73.6737 130.715L73.3146 130.24L73.4582 129.84L73.1709 127.806L74.1765 127.216L74.392 125.942L74.2304 125.638L74.9486 124.535L76.2954 124.839L76.9597 125.714L77.2471 124.725L78.3963 124.782L78.5758 125.049Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M184.912 50.563L184.589 50.601L184.086 49.8975L184.05 49.7073H183.637L183.296 49.3841L183.116 49.4031L182.685 49.0608L181.931 48.7566L181.913 48.1671L181.68 47.7487L182.937 47.5586L183.188 47.8628L183.583 48.072L183.457 48.3762L184.032 48.7946L183.834 49.1939L184.301 49.5172L184.75 49.7073L184.912 50.563Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M276.886 147.653L277.55 148.071L278.143 147.9L279.023 147.672L279.526 147.748L278.718 149.193L278.125 149.593L277.407 150.582L277.299 150.239L276.114 151.076L275.97 151.019L275.432 150.981L275.521 149.954L275.881 149.155L275.988 148.091L276.347 147.539L276.886 147.653Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M285.95 114.682L286.166 115.633L286.884 115.177L287.135 115.69L287.548 116.166L287.351 116.717L287.387 117.763L287.423 118.371L287.656 118.524L287.728 119.569L287.513 120.197L287.656 121.015L288.626 121.661L289.2 122.232L289.775 122.764L289.578 123.068L289.991 123.829L290.08 125.16L290.547 124.894L290.817 125.407L291.104 125.236L290.978 126.529L291.499 127.271L291.84 127.727L292.343 128.716V129.705L292.163 130.408L291.84 131.15L291.966 132.196L291.517 133.279L291.14 133.85L290.457 134.934L290.188 135.637L289.631 136.512L288.734 137.615L287.746 138.223L286.956 139.155L286.363 139.764L285.573 140.809L284.909 141.418L284.209 142.331L283.652 143.167L283.508 143.567L282.736 143.985L281.641 144.023L280.51 144.536L279.827 144.993L278.965 145.525L278.481 144.974L278.014 144.765L278.481 144.137L277.852 144.365L276.559 145.24L275.913 144.917L275.482 144.727L274.979 144.631L274.243 144.289L274.009 143.529L274.279 142.616L274.351 141.988L274.099 141.494L273.255 141.361L273.83 140.752L273.991 139.859L273.147 140.695L272.196 140.924L273.004 140.258L273.453 139.554L274.081 138.946L274.368 138.052L273.147 139.079L272.375 139.497L271.603 140.467L271.064 139.973L271.37 139.326L271.118 138.433L270.795 137.976L271.082 137.691L270.131 136.949L269.448 136.93L268.73 136.322L266.952 136.436L265.534 136.873L264.295 137.292L263.397 137.216L262.14 137.843L261.188 138.109L260.775 138.756L260.237 139.25L259.393 139.288L258.746 139.383L257.992 139.174L257.238 139.307L256.556 139.364L255.748 140.011L255.478 139.954L254.868 140.296L254.257 140.676L253.575 140.638H252.946L252.21 139.859L251.779 139.63L252.049 138.927L252.569 138.756L252.839 138.49L252.946 138.052L253.359 137.197L253.485 136.474L253.359 135.238L253.395 134.534L253.647 133.85L253.485 133.051L253.539 132.69L253.234 132.196L253.359 131.245L253.018 130.275L253 129.762L253.324 130.294L253.234 129.153L253.647 129.514L253.844 129.99L253.952 129.362L253.665 128.392L253.647 128.012L253.503 127.651L253.737 126.947L254.006 126.643L254.239 126.035L254.257 125.312L254.814 124.437L254.742 125.369L255.299 124.532L256.179 124.114L256.753 123.601L257.597 123.144L258.064 123.049L258.315 123.201L259.177 122.745L259.806 122.612L260.003 122.346L260.273 122.232L260.829 122.27L261.943 121.908L262.571 121.357L262.93 120.71L263.631 120.102L263.756 119.607L263.882 118.942L264.762 117.896L265.013 118.961L265.48 118.714L265.211 118.143L265.624 117.554L266.019 117.82L266.288 116.888L266.917 116.28L267.24 115.804L267.761 115.595L267.832 115.253L268.245 115.386L268.317 115.082L268.784 114.911L269.287 114.74L269.951 115.31L270.418 116.033H271.047L271.675 116.147L271.549 115.481L272.178 114.511L272.663 114.188L272.555 113.884L273.076 113.18L273.74 112.743L274.225 112.895L275.105 112.667L275.159 112.039L274.458 111.64L275.015 111.469L275.661 111.773L276.146 112.268L276.954 112.572L277.259 112.458L277.852 112.838L278.481 112.477L278.84 112.591L279.109 112.344L279.504 112.952L279.145 113.618L278.696 114.112L278.355 114.15L278.409 114.625L278.014 115.234L277.565 115.842L277.601 116.185L278.283 116.869L279.001 117.25L279.45 117.668L280.043 118.39H280.33L280.797 118.714L280.887 119.094L281.767 119.493L282.503 119.075L282.826 118.428L283.131 117.877L283.365 117.211L283.832 116.242L283.796 115.652L283.921 115.291L283.903 114.606L284.155 113.675L284.388 113.427L284.28 113.028L284.604 112.382L284.873 111.716L284.945 111.355L285.358 110.898L285.591 111.507L285.573 112.268L285.807 112.42L285.789 112.933L286.076 113.542L286.058 114.245L285.95 114.682Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M156.149 38.7316L156.095 38.8838L156.22 39.2831L156.185 39.7775H155.682L155.879 40.0437L155.646 40.8043L155.484 41.0135L154.694 41.0325L154.263 41.3177L153.509 41.2226L152.198 40.8994L151.965 40.5001L151.085 40.7092L150.995 40.9374L150.438 40.7663L149.972 40.7282L149.559 40.5001L149.684 40.2148L149.648 40.0057L149.9 39.9486L150.385 40.2719L150.492 39.9486L151.282 40.0057L151.911 39.7965L152.342 39.8345L152.647 40.0817L152.719 39.8726L152.539 39.0929L152.845 38.9408L153.132 38.3894L153.814 38.7887L154.281 38.2943L154.586 38.1992L155.305 38.5605L155.718 38.5035L156.149 38.7316Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M184.584 50.592L183.901 50.4208L183.327 49.8694L183.111 49.394L183.291 49.375L183.632 49.6983H184.045L184.081 49.8884L184.584 50.592Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M185.719 47.3639L186.168 46.8695L186.796 47.497L187.443 48.3717L187.892 48.4288L188.233 48.7521L187.479 48.8471L187.496 49.7979L187.425 50.2162L187.119 50.5015L187.263 51.0909L187.03 51.167L186.329 50.5205L186.545 49.931L186.204 49.5697L185.862 49.6648L184.911 50.5585L184.749 49.7028L184.3 49.5127L183.833 49.1894L184.031 48.7901L183.456 48.3717L183.582 48.0675L183.187 47.8583L182.936 47.5541L183.133 47.3449L183.887 47.7062L184.408 47.7633L184.516 47.6302L183.923 46.9646L184.139 46.8125L184.408 46.8505L185.18 47.5731L185.611 47.6682L185.719 47.3639Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M171.281 103.305L171.173 103.324V103.267L170.814 102.107L170.812 102.096L170.796 101.898L170.545 101.347L171.173 101.442L171.479 100.738L172.035 100.814L172.089 101.29L172.305 101.575V101.974L172.053 102.221L171.64 102.868L171.281 103.305Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M146.433 36.1307L146.361 36.9293L146.128 36.9673L146.056 37.6329L145.266 37.0814L144.817 37.1765L144.188 36.6251L143.757 36.1497L143.362 36.1307L143.219 35.7123L143.919 35.4842L144.565 35.5792L145.374 35.332L145.93 35.8454L146.433 36.1307Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M144.674 83.6411L144.638 84.0404L144.871 84.763L144.674 85.2574L144.782 85.5806L144.279 86.3412L143.974 86.7215L143.776 87.4821L143.812 88.2618L143.758 90.2203L142.914 90.3725L142.663 89.5358L142.717 86.7215L142.501 86.4743L142.465 85.8659L142.106 85.4475L141.801 85.0862L141.926 84.4397L142.286 84.3066L142.483 83.7742L142.986 83.6601L143.201 83.2988L143.543 82.9375H143.902L144.674 83.6411Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M141.406 79.6501L141.316 80.2395L141.46 80.791L142.017 81.5896L142.053 82.1791L143.22 82.4643L143.202 83.301L142.986 83.6623L142.483 83.7764L142.286 84.3088L141.927 84.4419L141.047 84.4229L140.58 84.3278L140.257 84.518L139.808 84.4229L138.048 84.4799L138.012 85.1835L138.156 86.0962L137.456 85.792L136.989 85.83L136.63 86.1343L136.181 85.8871L136.001 85.4687L135.552 85.2025L135.48 84.4989L135.768 83.9855L135.732 83.5672L136.54 82.5594L136.702 81.7227L136.971 81.4185L137.456 81.5896L137.887 81.3424L138.03 81.0192L138.802 80.4867L139 80.1064L139.952 79.593L140.508 79.4219L140.76 79.6501H141.406Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M233.358 70.9712L233.466 71.8459L233.088 71.6557L233.286 72.6445L232.909 72.017L232.765 71.3895L232.496 70.8L231.993 70.0965L231.059 70.0394L231.221 70.5528L231.006 71.2184L230.539 70.9712L230.431 71.1993L230.126 71.0662L229.731 70.9521L229.443 69.9443L228.976 69.0316L229.03 68.29L228.366 67.9667L228.528 67.5294L229.066 67.073L228.24 66.4265L228.456 65.5898L229.336 66.1223L229.82 66.1793L230.036 67.035L231.006 67.2061L231.921 67.1871L232.532 67.3963L232.245 68.4231L231.814 68.4992L231.598 69.1837L232.245 69.8302L232.298 69.0316H232.568L233.358 70.9712Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M167.282 44.5918L166.869 45.0862L166.636 45.9419L167.013 46.6265L166.187 46.4743L165.289 46.8546L165.343 47.4631L164.517 47.5772L163.816 47.1399L163.098 47.4821L162.416 47.4441L162.272 46.6455L161.769 46.2462L161.895 46.094L161.787 45.9419L161.895 45.5616L162.218 45.1813L161.716 44.6679L161.59 44.2115L161.787 43.9453L162.111 44.4397L162.452 44.3636L163.17 44.5348L164.535 44.6108L164.948 44.3066L166.007 44.0214L166.725 44.4587L167.282 44.5918Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M158.373 43.2064L158.714 43.1874L158.517 43.7198L159.001 44.1952L158.912 44.7466L158.714 44.8036L158.553 44.9177L158.265 45.203L158.193 45.8685L157.331 45.4121L156.954 44.8987L156.577 44.6325L156.128 44.1761L155.895 43.8149L155.41 43.2444L155.554 42.75L155.913 43.0352L156.093 42.769L156.505 42.75L157.314 42.9592L157.942 42.9402L158.373 43.2064Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M168.898 33.3972L168.197 33.3592L168.054 33.4733L168.323 33.8536L168.682 34.6142L167.946 34.6713L167.713 34.9375L167.767 35.5269L167.389 35.4129L166.617 35.4699L166.348 35.1847L166.043 35.3938L165.702 35.2227L165.001 35.2037L163.978 34.9185L163.098 34.8234L162.416 34.8614L161.985 35.1657L161.572 35.2227L161.482 34.6903L161.141 34.1579L161.643 33.9107L161.572 33.4543L161.266 33.0169L161.159 32.5035H162.003L162.864 32.0662L162.954 31.4197L163.601 31.0394L163.421 30.5259L163.906 30.3358L164.732 29.8984L165.684 30.1837L165.845 30.4689L166.276 30.3358L167.138 30.602L167.336 31.1534L167.21 31.4577L167.892 32.2183L168.269 32.4275V32.6366L168.88 32.8458L169.185 33.15L168.898 33.3972Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M51.4967 78.4719H51.1914L51.4248 77.1028L51.5505 76.133L51.5685 75.9429L51.6942 75.8858L51.8558 76.038L52.3047 75.2964L52.5022 75.2773L52.4843 75.4675H52.6638L52.61 75.8098L52.3765 76.3232L52.4484 76.5133L52.2867 76.9507L52.3406 77.0648L52.1611 77.6923L51.9276 78.0155L51.7301 78.0536L51.4967 78.4719Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M82.8674 122.514L82.8135 122.134L81.8439 121.506L80.9101 121.487L79.1863 121.849L78.8092 122.913L78.8451 123.579L78.5758 125.043L78.3962 124.777L77.247 124.72L76.9597 125.709L76.2953 124.834L74.9486 124.53L74.2303 125.633L73.53 125.804L72.9734 124.111L72.309 122.742L72.5065 121.563L71.9319 121.05L71.7164 120.175L71.1418 119.339L71.6626 118.027L71.1418 117L71.3394 116.581L71.1239 116.125L71.465 115.517L71.4112 114.49V113.615L71.6087 113.216L70.6211 111.238L71.3753 111.352L71.896 111.314L72.0935 110.953L72.9554 110.459L73.4762 110.002L74.787 109.793L74.7152 110.706L74.8768 111.181L74.8229 111.999L75.9901 113.083L77.1393 113.292L77.5523 113.748L78.2526 113.995L78.7015 114.338H79.33L79.9405 114.699L80.0303 115.402L80.2457 115.764L80.2996 116.277L79.9943 116.296L80.4971 117.722L82.4185 117.779L82.3287 118.483L82.4723 118.958L83.0469 119.301L83.3522 120.061L83.2445 121.031L83.011 121.563L83.1547 122.248L82.8674 122.514Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M83.4618 95.5536L84.0184 95.6677L84.1262 95.4015L83.9466 95.1733L84.0543 94.812L84.4673 94.9261L84.9521 94.793L85.5268 95.0592L85.9757 95.3064L86.2809 94.9832L86.5144 95.0212L86.658 95.3635L87.1428 95.2874L87.5379 94.812L87.8611 93.9183L88.4716 92.7964L88.8307 92.7394L89.0642 93.4239L89.6029 95.5536L90.1595 95.7628L90.1775 96.5995L89.4053 97.6073L89.7106 97.9686L91.5242 98.1587L91.5601 99.3947L92.3322 98.5961L93.6071 99.0334L95.313 99.775L95.8158 100.479L95.6542 101.163L96.8393 100.783L98.8145 101.429L100.341 101.391L101.849 102.399L103.178 103.768L103.968 104.11L104.83 104.168L105.207 104.548L105.566 106.107L105.764 106.849L105.387 108.864L104.902 109.663L103.519 111.355L102.909 112.743L102.19 113.789L101.939 113.827L101.705 114.721L101.867 117.003L101.67 118.885L101.616 119.684L101.328 120.178L101.239 121.814L100.305 123.392L100.215 124.666L99.443 125.179L99.2455 125.921H98.1681L96.6418 126.377L95.9774 126.929L94.9 127.29L93.8047 128.26L93.0685 129.477L93.0146 130.39L93.248 131.055L93.1941 132.291L93.0505 132.881L92.44 133.565L91.6319 135.714L90.9137 136.665L90.3391 137.254L90.0697 138.414L89.549 139.099L89.1719 138.414L89.4951 137.825L88.8128 137.007L87.9509 136.322L86.8196 135.543L86.4784 135.581L85.3472 134.63L84.7367 134.763L85.8141 133.109L86.7658 131.911L87.3583 131.416L88.1125 130.751L88.0407 129.781L87.466 129.058L86.9992 129.306L87.1249 128.602L87.1787 127.88L87.1249 127.195L86.7478 126.986L86.3887 127.176L86.0116 127.119L85.8679 126.663L85.6704 125.541L85.4549 125.179L84.7546 124.837L84.3596 125.084L83.3002 124.837L83.2283 123.183L82.8692 122.517L83.1565 122.251L83.0129 121.566L83.2463 121.034L83.354 120.064L83.0488 119.304L82.4742 118.961L82.3305 118.486L82.4203 117.782L80.499 117.725L79.9962 116.299L80.3014 116.28L80.2476 115.767L80.0321 115.406L79.9423 114.702L79.3318 114.341H78.7033L78.2544 113.998L77.5541 113.751L77.1411 113.295L75.9919 113.086L74.8247 112.002L74.8786 111.184L74.717 110.709L74.7888 109.796L73.478 110.005L72.9573 110.462L72.0954 110.956L71.8978 111.317L71.3771 111.355L70.6229 111.241L70.0483 111.45L69.5815 111.317L69.5635 109.473L68.7734 110.176L67.8756 110.157L67.4626 109.492L66.7803 109.435L66.9598 108.902L66.3673 108.161L65.9004 107.058L66.1697 106.849L66.1338 106.316L66.7443 105.974L66.6186 105.308L66.87 104.89L66.9239 104.32L68.0552 103.483L68.8812 103.255L69.0248 103.065L69.9406 103.122L70.3356 99.775L70.3536 99.2426L70.192 98.558L69.7251 98.1017L69.7431 97.208L70.3177 97.0178L70.5152 97.1509L70.5511 96.6755L69.9585 96.5424V95.7818L71.9337 95.8198L72.2749 95.3825L72.5622 95.7818L72.7418 96.5044L72.9393 96.3523L73.496 96.9988L74.286 96.9227L74.4836 96.5424L75.2377 96.2572L75.6687 96.048L75.7944 95.5346L76.5306 95.1923L76.4767 94.9261L75.6148 94.8311L75.4891 94.0514L75.543 93.2338L75.0941 92.9295L75.2916 92.8154L76.0278 92.9676L76.8359 93.2718L77.1411 92.9866L77.8773 92.7964L79.0265 92.3401L79.4036 91.8647L79.2779 91.5224L79.8166 91.4844L80.0321 91.7506L79.8884 92.302L80.2476 92.4732L80.463 93.0436L80.1757 93.481L79.9962 94.5078L80.2476 95.1353L80.3014 95.7058L80.9299 96.2762L81.4327 96.3333L81.5404 96.0861L81.8637 96.029L82.3305 95.8198L82.6537 95.4966L83.2283 95.6107L83.4618 95.5536Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M257.15 92.3558L257.545 91.8994L258.371 91.2148L258.353 91.8233L258.336 92.603L257.851 92.5649L257.653 92.9833L257.15 92.3558Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M231.241 63.9595L231.708 64.3589L231.798 65.1004L230.99 65.1385L230.146 65.0624L229.571 65.2526L228.584 64.7772L228.512 64.549L228.979 63.6363L229.445 63.332L230.218 63.5982L230.738 63.6363L231.241 63.9595Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M166.382 119.529L166.724 120.498L166.921 120.727L167.208 121.43L168.304 122.761L168.717 122.894L168.699 123.332L168.968 124.111L169.74 124.301L170.351 124.853L168.896 125.747L167.963 126.659L167.604 127.477L167.28 127.933L166.742 128.028L166.526 128.618L166.418 128.998L165.772 129.264L164.964 129.207L164.515 128.865L164.102 128.732L163.599 128.998L163.33 129.588L162.845 129.949L162.342 130.5L161.624 130.634L161.426 130.196L161.534 129.455L160.996 128.295L160.744 128.105L160.852 124.549L161.839 124.511L161.983 120.156L162.737 120.118L164.3 119.681L164.659 120.194L165.323 119.719H165.628L166.203 119.434L166.382 119.529Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M165.248 87.3539L165.948 87.8293L166.505 88.3237L166.523 88.723L167.223 89.3505L167.654 89.8829L167.905 90.6055L168.677 91.0999L168.839 91.4802L168.516 91.6133L167.851 91.5943L167.097 91.4612L166.72 91.5563L166.559 91.8605L166.235 91.8986L165.84 91.6323L164.709 92.2408L164.242 92.1267L164.099 92.2218L163.811 92.9634L163.039 92.7162L162.303 92.6021L161.656 92.1458L160.813 91.7274L160.274 92.1267L159.879 92.7352L159.789 93.5909L159.143 93.5339L158.442 93.3247L157.85 93.9712L157.311 95.1121L157.203 94.7508L157.149 94.1994L156.683 93.8001L156.305 93.1726L156.216 92.7352L155.731 92.0887L155.821 91.7274L155.713 91.214L155.785 90.2632L156.036 90.0541L156.539 88.8181L157.365 88.723L157.544 88.3997L157.724 88.4378L157.975 88.704L159.25 88.2476L159.681 87.7722L160.202 87.3349L160.094 86.9166L160.382 86.8025L161.369 86.8785L162.303 86.3081L163.021 84.977L163.524 84.4826L164.17 84.2734L164.296 84.7869L164.889 85.5475V86.0609L164.745 86.5553L164.817 86.9356L165.158 87.2969L165.248 87.3539Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M83.4734 41.1681L84.0839 41.3392L84.9279 41.3012L84.3353 41.7956L83.9762 41.8717L82.9886 41.3583L82.8809 40.9589L83.3298 40.5977L83.4734 41.1681Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M86.0599 38.125L85.6289 38.144L84.5875 37.7827L83.959 37.2123L84.3002 37.1172L85.3596 37.4214L86.1138 37.9158L86.0599 38.125Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M30.7765 38.8301L30.2199 39.0012L29.0886 38.4688V38.0505L28.5679 37.6321L28.6217 37.2899L27.8496 37.0807L27.9573 36.4342L28.2267 36.168L28.9629 36.4152L29.3939 36.6053L30.1301 36.7194L30.166 37.1377L30.2378 37.6892L30.8124 38.1836L30.7765 38.8301Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M91.6661 36.2669L90.7683 37.2938L91.4686 36.8945L91.9893 37.1607L91.5583 37.56L92.2407 37.8832L92.7435 37.598L93.5156 37.9593L93.0128 38.834L93.6951 38.6248L93.6413 39.2523L93.7311 39.9939L93.0846 41.0588L92.6537 41.0968L92.1329 40.8686L92.5818 39.8989L92.3664 39.7467L91.0556 40.7736L90.5169 40.7355L91.3069 40.1651L90.5169 39.8798L89.5293 39.9559L87.8054 39.9179L87.7695 39.5756L88.4519 39.1382L88.1466 38.834L89.1163 38.1114L90.5887 36.2289L91.3429 35.5634L92.2407 35.1641L92.6178 35.2021L92.3484 35.5254L91.6661 36.2669Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M27.0242 32.1875L27.2935 32.3396L28.1914 32.2445L26.8985 33.5566L26.9524 34.5074H26.6112L26.4855 33.9749L26.5753 33.4235L26.4316 33.0622L26.6651 32.5488L27.0242 32.1875Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M77.9111 23.1613L77.2646 23.7317L76.9594 23.6366L76.9414 23.3134L77.0132 23.2373L77.516 22.9141L77.8213 22.9331L77.9111 23.1613Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M76.1675 22.5485L74.8746 23.157L74.3359 23.119V22.8337L75.2338 22.3203L76.3111 22.3393L76.1675 22.5485Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M75.608 19.3612L75.4464 19.8366L75.9313 19.6655L76.2006 19.9507L76.8291 20.331L77.5114 20.6543L77.26 21.1677L77.8885 21.0916L78.2297 21.4529L77.3318 21.7952L76.2724 21.529L76.1288 21.0346L74.9975 21.624L73.5251 22.1755L73.6508 21.548L72.5195 21.643L73.543 21.1106L74.1895 20.2549L75.1052 19.2852L75.608 19.3612Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M83.6709 17.7727L82.791 17.8297L82.9167 17.3163L83.5991 16.7269L84.3712 16.5938L84.7842 16.879L84.5148 17.3163L84.3532 17.4685L83.6709 17.7727Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M70.2973 15.7406L69.5611 16.1019L68.8069 15.7977L68.1066 15.8928L67.4961 15.4364L68.3939 15.1131L69.2738 14.6758L69.8125 14.961L70.0998 15.1512L70.1716 15.3413L70.2973 15.7406Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M79.8139 42.8587L79.4189 42.1741L79.9396 40.5578L79.6523 40.2155L78.9879 40.4057L78.7904 40.1014L77.8028 40.9952L77.2282 41.9269L76.7254 42.4783L76.2765 42.6685L75.9713 42.7255L75.7737 43.0108H74.1038L72.7032 43.0298L72.2184 43.239L70.9973 44.0756V44.0566L70.8357 43.9805L70.4766 44.1517L70.1354 44.3989L69.8122 44.1897L68.9683 44.3418L68.268 44.513L67.9268 44.6651L67.5138 45.0644L67.837 45.1975L68.1423 45.1215H68.1961L68.1423 45.4827L67.2804 45.6159L66.7776 45.768L66.4723 45.9581L66.0054 45.844L65.7181 45.9011L65.1974 46.2434L64.3714 46.6237L63.8866 46.5476L64.2457 46.1293L64.9101 45.4637L65.6463 45.0644L65.8438 44.7221L66.0054 44.1517L66.6878 43.4862L66.8494 42.7255L67.0469 43.4671L67.7293 43.6383L68.1602 43.239L67.9088 42.3262L67.7472 41.9459L67.029 41.7177L66.3466 41.5846H65.6463L65.0358 41.4325L64.964 41.1663L64.7126 41.3374L64.4971 41.2994L64.8383 40.9001L64.5151 40.748L64.8562 40.2916L64.6408 39.9493L64.946 39.607L64.0123 39.4359L63.9943 38.7514L63.8507 38.5992L63.2581 38.5612L62.5219 38.333L62.2526 38.4851L61.9293 38.7704L61.3368 38.9605L60.7801 39.4359L59.8105 39.1126L59.0204 39.2648L58.3201 38.9035L57.4941 38.7133L56.9015 38.6373L56.722 38.4471L56.8836 37.8006H56.5783L56.3449 38.257H54.5133H51.4608H48.4441H45.7686H43.111H40.4714H37.76H36.8981H34.2585H31.7266H31.6009L30.6313 37.097L30.344 36.5836L29.087 36.0892L29.3205 35.0434L29.9669 34.3398L29.2307 33.8264L29.7873 32.8947L29.4103 32.058L29.8592 31.4495L30.7749 30.8981L31.3496 30.1755L30.5236 29.4529L30.7749 28.1409L30.9725 27.3422L30.6852 26.8288L30.5415 26.3724L30.6493 25.783L29.4821 26.1442L28.1174 26.7718L28.0635 26.0492L27.9737 25.5548L27.471 25.2505L26.7168 25.2125L33.1093 18.9945L37.5266 15.1154L38.604 15.3626L39.1965 15.857L39.8609 15.9521L40.9922 15.5337L42.2491 15.2105L43.2008 15.3246L44.7989 14.8872L46.2713 14.64L46.3073 15.0584L47.1153 14.8112L47.8156 14.3358L48.1927 14.4499L48.4441 15.3626L50.1499 14.659L49.4496 15.4387L50.527 15.2675L51.1016 14.9823L51.9276 15.0393L52.6279 15.4577L53.9746 15.838L54.8186 16.0091L55.6087 15.9521L56.1294 16.4845L54.6031 16.9979L55.7523 17.2071L57.8892 17.093L58.6792 16.9028L58.9306 17.5303L60.2055 17.0169L59.8284 16.5606L60.6365 16.2183L61.5702 16.1612L62.2705 16.0662L62.6476 16.3134L62.917 16.8648L63.8148 16.7887L64.7665 17.2641L66.0593 17.093L67.1367 17.112L67.5677 16.4655L68.3757 16.2944L69.2556 16.6366L68.4834 17.6254L69.5967 16.7887L70.1713 16.8268L71.3206 15.7809L71.0332 15.1534L70.5125 14.7351L71.5001 13.6132L72.9725 12.8906L73.7806 13.0618L74.1397 13.4991L74.2115 14.64L73.1701 15.1344L74.3731 15.3436L73.5831 16.3894L75.1812 15.5908L75.5762 16.2563L74.8041 17.0169L75.0375 17.7205L76.3484 16.9789L77.5155 16.0662L78.3595 14.9443L79.3471 15.0203L80.3167 15.1725L80.9632 15.6859L80.6579 16.1993L79.7421 16.7507L79.9037 17.3022L79.4728 17.8156L77.5155 18.5572L76.3484 18.7283L75.7737 18.405L75.1812 18.9375L73.8524 19.8312L73.3137 20.3066L71.9311 21.0291L70.7639 21.1052L69.8481 21.5616L69.3274 22.2842L68.3039 22.4173L66.7417 23.311L65.0538 24.547L64.1559 25.4217L63.2761 26.7337L64.3535 26.9239L64.0841 27.9697L63.9405 28.8444L65.2513 28.6162L66.5082 29.1106L67.1008 29.548L67.4061 30.0804L68.2859 30.4037L68.9324 30.879L70.297 30.9551L71.1589 31.0692L70.5125 32.058L70.2073 33.2179L70.2252 34.53L71.0153 35.6519L71.8592 35.2716L72.8648 34.0546L73.2778 32.2291L72.9725 31.6206L74.5886 31.0692L75.9354 30.2706L76.7973 29.4719L77.1025 28.7113L77.0307 27.7415L76.4561 26.8858L78.0542 25.7069L78.2338 24.6991L78.9341 22.9877L79.6164 22.7215L80.8195 23.0257L81.5737 23.1398L82.3817 22.8356L82.9384 23.2159L83.5848 23.8624L83.6207 24.2808L85.0033 24.3758L84.5365 25.3076L84.1235 26.7147L84.8058 26.9049L85.0931 27.5704L86.5656 26.9429L87.9123 25.6879L88.6665 25.1745L88.864 26.1823L89.3308 27.6084L89.69 28.9775L89.0794 29.7001L89.9414 30.3466L90.4621 30.9931L91.7011 31.2974L92.132 31.6587V32.6475L92.7426 32.7996L92.9401 33.2369L92.5809 34.549L91.8088 34.9863L91.0547 35.4047L89.4745 35.823L88.0559 36.7738L86.5117 36.9829L84.6981 36.7167H83.3873L82.4356 36.7928L81.4121 37.6485L80.0833 38.1809L78.2697 39.7402L76.8511 40.843L77.6951 40.6529L79.6523 39.0746L81.861 38.0858L83.2257 37.9717L83.8182 38.5612L82.7229 39.3598L82.6151 40.6339L82.6331 41.5466L83.6387 42.1361L85.1829 41.9649L86.4758 40.6148L86.2962 41.4895L86.7451 41.9269L85.4163 42.7065L83.1897 43.4291L82.1483 43.9045L80.8554 44.7792L80.191 44.6841L80.4604 43.6763L82.3278 42.6685L80.8734 42.7065L79.8139 42.8587Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M60.6934 11.7058L59.8495 12.1621L61.7349 11.8769L62.2018 12.3713L63.5126 11.8579L63.8358 12.1812L63.4408 13.1509L64.2129 12.7516L64.7157 11.7438L65.4878 11.5917L66.0265 11.7438L66.4215 12.1431L65.9367 13.1129L65.5058 13.8165L66.2599 14.3109L67.1578 14.8053L66.6909 15.2426L65.416 15.3377L65.5596 15.718L64.985 16.0983L63.7819 15.9462L62.7584 15.6609L61.8427 15.718L60.1368 16.0793L58.1077 16.2314L56.6892 16.3265L56.743 15.8321L56.0068 15.5659L55.2347 15.68L55.127 14.8623L55.7195 14.7482L57.0303 14.5771L58.0179 14.6341L59.1312 14.444L57.9641 14.2158L56.33 14.2919L55.3065 14.2728V13.9115L57.4074 13.4932L56.2762 13.5122L55.3065 13.246L56.7071 12.5044L57.6409 12.1051L60.1907 11.5156L60.6934 11.7058Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M67.7793 11.4274L66.5224 12.0739L66.1094 11.3894L66.4865 11.2372L67.4741 11.1992L67.7793 11.4274Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M87.2862 11.7246L87.1605 11.9909L86.4243 11.9718L85.6881 11.9528L84.8082 12.0859L84.6466 12.0099L84.2695 11.4965L84.5748 11.1542L84.9698 11.0781L86.4782 11.1922L87.2862 11.7246Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M80.1355 11.6744L80.1894 12.2829L81.4822 11.5032L83.5831 11.1039L83.9961 12.1117L83.4215 12.7582L85.0376 12.473L85.9893 12.0737L87.2103 12.5681L87.8747 13.0435L87.6772 13.4808L89.1496 13.2526L89.4908 13.8992L90.9991 14.2985L91.3942 14.6978L91.5558 15.6676L89.9218 16.143L91.3044 16.8275L92.3638 17.0557L92.9564 18.0065L94.1236 18.0825L93.531 18.8241L91.5738 20.0601L90.8555 19.6037L90.1732 18.5769L89.1137 18.71L88.7007 19.3375L89.1856 19.946L89.9936 20.4404L90.1732 20.7256L90.1552 21.8095L89.5088 22.5891L88.6648 22.2849L87.1206 21.4292L87.767 22.3609L88.2698 23.0265L88.2159 23.4068L86.2587 22.9694L84.894 22.3229L84.2116 21.8095L84.6426 21.4862L83.7807 20.9348L82.9367 20.4214L82.7751 20.7256L80.4228 20.8968L79.9919 20.5355L80.9615 19.7368L82.416 19.7178L84.0859 19.5847L84.05 19.2044L84.6067 18.672L86.1868 17.6452L86.2587 17.1698L86.1689 16.8275L85.3249 16.3141L84.05 15.9718L84.6785 15.7056L84.3194 15.0591L83.7088 15.002L83.3677 14.6598L82.7751 14.964L81.3565 15.0971L78.8426 14.8689L77.5139 14.5647L76.4544 14.4126L76.1133 14.0513L77.2445 13.5949H76.221L76.8136 12.5871L78.0885 11.7124L79.1659 11.3131L81.177 11.0469L80.1355 11.6744Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M71.0876 11.0078L71.734 11.217L73.0987 11.0839L73.0089 11.3691L71.9136 11.8445L72.5959 12.2628L71.6622 13.1565L70.1538 13.5368L69.5433 13.4608L69.3817 13.0805L68.3223 12.3199L68.6275 11.9966L69.9563 12.1107L69.7947 11.4832L71.0876 11.0078Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M75.1438 12.0576L73.7432 12.7992L72.9531 12.7612L73.2763 11.8865L73.7432 11.4111L74.4974 10.9928L75.4311 10.7266L76.8497 10.7646L77.963 10.9928L76.1494 11.8675L75.1438 12.0576Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M54.3488 13.4224L51.9247 13.9168L52.0325 13.4794L50.9551 12.947L51.7452 12.5287L53.0919 11.8061L54.4566 11.1596L54.5284 10.5701L57.0423 10.418L57.7965 10.6271L59.5023 10.6842L59.8435 10.9504L60.1308 11.3687L58.9636 11.6159L56.4677 12.3005L54.8157 13.004L54.3488 13.4224Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M76.8324 9.92386L76.0962 10.2852L75.1625 10.2091L74.5879 9.96189L75.3959 9.54356L76.6349 9.27734L76.8863 9.61962L76.8324 9.92386Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M75.2501 8.26953L75.286 8.70688L74.7832 9.18226L73.7417 9.90484L72.5027 9.99992L71.9281 9.8478L72.5386 9.29635L71.3535 9.3534L72.1256 8.63082L72.808 8.66885L74.1906 8.34559L75.0705 8.40264L75.2501 8.26953Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M68.1772 8.76238L68.0515 9.08564L68.8416 8.93352L69.488 8.97155L69.075 9.44693L68.1593 9.88428L65.6633 10.0364L63.4547 10.4547L62.3773 10.4738L62.6466 10.1695L64.568 9.73216L61.3538 9.84625L60.5996 9.67511L62.7005 8.76238L63.6702 8.49617L65.1605 8.81943L65.6813 9.37087L66.7766 9.44693L66.9023 8.55321L67.9438 8.21094L68.5004 8.30601L68.1772 8.76238Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M78.1803 7.92814L78.5933 8.23238H79.922L80.1734 8.53663L79.6707 8.8789L80.2273 9.08807L80.4428 9.31625L81.3227 9.35428L82.2384 9.43034L83.5133 9.24019L84.9678 9.14512L86.0093 9.22118L86.4223 9.58247L86.2427 9.96277L85.5963 10.229L84.3932 10.4382L83.6211 10.305L81.5022 10.4572L80.0657 10.4762L79.0601 10.3621L77.5159 10.0578L77.8032 9.52542L78.1803 9.06905L77.9289 8.65072L76.6719 8.53663L76.2051 8.2514L76.8874 7.87109L78.1803 7.92814Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M64.5874 7.42969L63.546 8.13325L62.5943 8.45651L61.9119 8.49454L60.1342 8.89386L58.8593 9.04598L58.2129 8.83681L60.3138 8.13325L62.5045 7.54378L63.4921 7.56279L64.5874 7.42969Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M79.1626 7.54304L78.8394 7.56206L77.6543 7.50501L77.78 7.25781L79.0729 7.27683L79.3602 7.42895L79.1626 7.54304Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M68.6102 7.36807L67.0301 7.63428L66.4375 7.34905L67.3533 7.06383L68.4307 6.96875L69.1669 7.10186L68.6102 7.36807Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M70.0111 6.58026L68.9875 6.7514H67.9102L68.0897 6.61829L69.1132 6.37109L69.4185 6.40912L70.0111 6.58026Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M78.4138 7.04731L77.2287 7.23747L76.9414 7.0283L77.0491 6.70504L77.4442 6.34375L78.2343 6.38178L78.5395 6.43883L78.9525 6.74307L78.4138 7.04731Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M75.9321 6.82053L75.7346 7.18182L74.7829 7.08674L74.0647 6.80151L72.6641 6.76348L73.6158 6.51629L73.113 6.30712L73.508 5.96484L74.6034 6.07894L75.9501 6.40219L75.9321 6.82053Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M85.6476 5.66413L86.1325 5.94936L84.9653 6.19656L83.0619 6.86209L81.8409 6.91914L80.6198 6.80504L80.3325 6.44375L80.7096 6.13951L81.4817 5.91133H80.2966L79.9375 5.6261L80.0093 5.26481L80.8892 4.90352L81.6254 4.65632L82.3437 4.59928L82.2898 4.40912L83.7802 4.37109L84.0675 4.78943L84.9114 4.96057L85.7733 5.1317L85.6476 5.66413Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M99.8754 3.00184L101.438 3.05889L102.641 3.15396L103.574 3.34412L103.377 3.53427L101.617 3.85753L100.001 4.00965L99.2828 4.18079H100.63L98.7441 4.65617L97.5231 4.88435L95.8531 5.54989L94.3986 5.68299L93.842 5.87314L91.8129 5.94921L92.603 6.0633L92.0104 6.21542L92.1361 6.65277L91.2383 6.95701L89.9993 7.20421L89.3708 7.54649L88.1857 7.83171L88.0959 8.04088L89.2631 8.00285L89.0656 8.23103L86.7851 8.78248L85.2588 8.51626L83.1579 8.66839L82.2601 8.55429L81.0391 8.49725L81.4162 8.0599L82.8527 7.85073L83.2118 7.20421L83.6787 7.14717L85.0254 7.52747L84.7201 6.95701L83.8403 6.78588L84.7381 6.4436L86.1028 6.23443L86.6056 5.93019L86.0669 5.60693L86.2644 5.1886L87.9523 5.20761L88.3473 5.30269L89.6581 4.99844L88.3473 4.90337L86.0848 4.96041L85.2947 4.6942L85.1511 4.37094L84.7022 4.14276L84.8997 3.89556L85.9771 3.74344L86.7312 3.72442L88.06 3.61033L89.2811 3.3251L89.9814 3.36313L90.4123 3.5723L91.3101 3.19199L92.2439 3.0779L93.411 3.00184L95.2785 2.96381L95.5119 3.03987L97.3615 2.92578L98.6184 2.96381L99.8754 3.00184Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M149.647 40.0097L149.683 40.2189L149.557 40.5041L149.97 40.7323L150.437 40.7703L150.383 41.2457L150.006 41.4549L149.324 41.3028L149.144 41.7781L148.713 41.8162L148.552 41.626L148.067 42.0444L147.618 42.1014L147.223 41.8352L146.9 41.3218L146.469 41.5119V40.9605L147.115 40.295L147.079 39.9907L147.492 40.1048L147.726 39.8956H148.48L148.659 39.6484L149.647 40.0097Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M251.605 75.0624L250.833 75.6519L249.953 75.2716L249.773 74.2258L250.168 73.6743L251.21 73.332L251.803 73.351L252.09 73.8264L251.731 74.3589L251.605 75.0624Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M255.802 37.7275L257.418 38.5832L258.495 39.6861H259.86L260.327 39.2297L261.566 38.8684L261.799 39.9523L261.746 40.3896L262.248 41.6827L262.356 42.8616L261.117 42.6524L260.596 43.0708L261.44 44.0976L262.141 45.5237L261.692 45.5428L262.033 46.1703L261.045 45.4477V46.1322L259.896 46.6456L260.399 47.2922L259.573 47.2351L258.926 46.8548L258.729 47.7295L258.029 48.376L257.651 49.1557L256.52 49.4979L256.089 50.0684L255.227 50.4107L255.461 49.8402L255.048 49.3648L255.407 48.5472L254.599 47.9197L253.988 48.338L253.342 49.1937L253.109 49.9733L252.211 50.0304L251.977 50.6008L252.839 51.4185L253.701 51.6276L253.952 52.1601L254.868 52.5214L255.551 51.6467L256.61 52.122L257.238 52.1601L257.651 52.7876L256.448 53.1298L256.269 53.7954L255.586 54.4039L255.425 55.2596L256.7 55.9251L257.526 57.123L258.513 58.2449L259.501 59.1767L259.788 60.0894L259.286 60.4317L259.716 61.0782L260.417 61.4585L260.56 62.4473L260.578 63.4171L260.076 63.5312L259.699 64.8432L259.286 66.4595L258.675 67.9047L257.526 69.0266L256.341 70.0724L255.245 70.2055L254.725 70.738L254.312 70.3577L253.863 70.9471L252.57 71.5746L251.528 71.7458L251.403 73.0388L250.846 73.1149L250.451 72.2211L250.613 71.7648L249.212 71.3655L248.781 71.5746L247.722 71.2514L247.165 70.757L247.219 70.0534L246.267 69.8252L245.71 69.3689L244.974 70.0154L244.023 70.1675L243.232 70.1485L242.748 70.4527L242.263 70.6239L242.622 72.031L242.083 71.993L241.94 71.7077L241.85 71.1943L241.167 71.5556L240.701 71.3274L239.893 70.8711L240.036 69.8633L239.372 69.6161L238.941 68.4942L237.935 68.7033L237.81 67.2582L238.564 66.2313L238.402 65.2235L238.169 64.2918L237.684 64.0066L237.199 63.284L236.642 63.3791L235.547 63.1889L235.763 62.6755L235.116 61.9149L234.542 62.4283L233.662 62.1431L232.692 62.9037L231.992 63.8164L231.238 63.9685L230.735 63.6453L230.214 63.6072L229.442 63.341L228.975 63.6453L228.508 64.558L228.239 63.5882L227.682 63.8544L226.515 63.7213L225.348 63.4551L224.45 62.9037L223.642 62.6755L223.193 62.086L222.601 61.9149L221.451 61.1162L220.589 60.7359L220.248 61.0212L218.704 60.1655L217.591 59.4049L217.016 58.0548L217.752 58.2259L217.645 57.5984L217.106 56.9709L216.962 55.9821L215.58 54.537L213.874 54.0616L213.353 53.1108L212.509 52.5404L212.24 52.1981L211.916 51.5135L211.827 51.0382L211.162 50.7529L210.893 50.886L210.336 49.7451L210.534 49.4789L210.318 49.1937L211.055 48.6232L211.629 48.376L212.671 48.5472L212.778 47.7675L213.928 47.6344L214.107 47.14L215.346 46.4935L215.382 46.2273L215.077 45.5237L215.598 45.2195L214.017 43.1278L215.651 42.6524L216.011 42.3862L215.831 40.2375L217.77 40.6368L218.058 40.0854L217.609 38.9064L218.291 38.7924L218.632 37.9937L218.937 37.8986L219.53 38.7353L220.554 39.3628L222.026 39.8002L223.067 40.7699L223.319 42.1581L223.857 42.6905L225.025 42.8996L226.318 43.0518L227.754 43.8124L228.365 43.9455L229.262 45.0484L230.106 45.7709L231.112 45.7329L233.141 46.0181L234.29 45.847L235.296 46.0181L236.984 46.7597H238.097L238.69 47.121L239.48 46.4745L240.772 46.0562L242.137 46.0181L243.017 45.5998L243.376 44.9533L243.807 44.535L243.466 44.1356L242.945 43.6793L243.035 42.8996L243.61 43.0137L244.669 43.2609L245.244 42.6144L246.393 42.1581L246.626 41.3594L247.075 41.0171L248.296 40.865L249.086 40.9981L248.943 40.5798L247.65 39.7431L246.716 39.3628L246.267 39.8002L245.28 39.61L244.867 39.7621L244.364 39.2867L244.31 38.0888L244.202 37.1951L245.531 37.6514L246.321 36.9098L245.98 36.3774L245.944 35.1414L246.177 34.7611L245.728 34.1146L245.064 33.8484L245.369 33.2589L246.285 33.0497L247.398 33.0117L248.943 33.373L250.02 33.7913L251.403 34.9703L252.085 35.4837L252.893 36.2063L254.006 37.3472L255.802 37.7275Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M135.551 85.2063L136 85.4725L136.18 85.8908L136.629 86.138L136.988 85.8338L137.455 85.7958L138.155 86.1L138.424 87.8494L137.993 88.8572L137.724 90.2453L138.155 91.2912L138.119 91.7856H137.652L136.952 91.5574H136.287L135.084 91.7856L134.384 92.1278L133.379 92.5842L133.181 92.5462L133.253 91.5384L133.361 91.3863L133.325 90.9109L132.894 90.3975L132.571 90.3214L132.283 89.9791L132.499 89.4277L132.409 88.8382L132.445 88.4959H132.606L132.678 87.9635L132.606 87.7163L132.696 87.5452L133.073 87.4121L132.822 86.4233L132.588 85.9289L132.678 85.5105L132.876 85.4155L133.019 85.3014L133.289 85.4915H134.079L134.258 85.1492L134.438 85.1683L134.725 85.0352L134.887 85.5486L135.12 85.3965L135.551 85.2063Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M156.542 88.816L156.039 90.052L155.788 90.2612L155.716 91.2119L155.823 91.7253L155.734 92.0866L156.219 92.7331L156.308 93.1705L156.685 93.798L157.152 94.1973L157.206 94.7488L157.314 95.1101L157.242 95.7566L156.434 95.4713L155.608 95.1481L154.333 95.1101L154.207 95.034L153.597 95.1861L152.986 95.034L152.502 95.1101L150.832 95.091L150.993 94.1213L150.58 93.3036L150.113 93.1135L149.916 92.562L149.646 92.3909L149.664 92.0486L149.916 91.1739L150.401 89.995H150.688L151.298 89.2724L151.676 89.2534L152.25 89.7668L152.95 89.3484L153.04 88.835L153.274 88.3406L153.417 87.7321L153.956 87.2377L154.154 86.3821L154.369 86.0968L154.513 85.4693L154.764 84.6897L155.608 83.7389L155.662 83.3396L155.77 83.1114L155.357 82.6361L155.393 82.2367L155.662 82.1797L156.075 82.9593L156.165 83.758L156.129 84.5756L156.703 85.6785H156.129L155.841 85.7546L155.375 85.6405L155.159 86.2109L155.77 86.9335L156.219 87.1427L156.362 87.6371L156.685 88.4737L156.542 88.816Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M168.843 91.48L169.471 92.4878L169.938 92.6399L170.208 92.4307L170.674 92.5068L171.231 92.2596L171.482 92.773L172.398 93.5906L172.344 95.0168L172.757 95.1879L172.416 95.6063L172.039 95.9485L171.644 96.576L171.429 97.1465L171.375 98.1163L171.141 98.5917L171.123 99.5044L170.836 99.8467L170.8 100.569L170.657 100.664L170.549 101.349L170.8 101.9L170.818 102.09L170.603 104.049L170.872 104.734L170.692 105.247L171.016 106.122L171.626 106.787L171.752 107.453L172.039 107.776L171.985 107.985L171.824 107.928L170.441 108.137L170.172 108.289L169.866 109.069L170.082 109.601L169.884 111.047L169.723 112.264L169.992 112.492L170.692 112.967L170.98 112.739L171.016 114.051H170.244L169.848 113.386L169.489 112.853L168.717 112.682L168.502 112.054L167.873 112.435L167.083 112.264L166.742 111.712L166.114 111.598L165.629 111.617L165.575 111.237L165.234 111.218L164.767 111.142L164.138 111.332L163.707 111.294L163.456 111.408L163.528 109.963L163.205 109.506L163.133 108.746L163.294 108.004L163.097 107.548L163.079 106.768L161.858 106.787L161.948 106.35H161.427L161.373 106.559L160.745 106.616L160.475 107.32L160.314 107.624L159.757 107.453L159.434 107.624L158.751 107.719L158.374 107.091L158.141 106.692L157.854 105.951L157.62 105.057L154.621 105.038L154.262 105.171L153.957 105.152L153.544 105.323L153.4 104.943L153.652 104.81L153.688 104.277L153.867 103.973L154.226 103.707L154.496 103.84L154.855 103.364L155.412 103.383L155.465 103.726L155.842 103.935L156.453 103.174L157.046 102.585L157.297 102.186L157.279 101.178L157.728 99.9988L158.195 99.3713L158.859 98.7818L158.985 98.4015L159.003 97.9451L159.164 97.5268L159.111 96.8232L159.236 95.7394L159.434 94.9788L159.739 94.3322L159.793 93.5906L159.883 92.735L160.278 92.1265L160.816 91.7271L161.66 92.1455L162.307 92.6019L163.043 92.7159L163.815 92.9631L164.102 92.2215L164.246 92.1265L164.713 92.2406L165.844 91.6321L166.239 91.8983L166.562 91.8603L166.724 91.556L167.101 91.4609L167.855 91.594L168.52 91.6131L168.843 91.48Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M159.791 93.5904L159.737 94.332L159.431 94.9785L159.234 95.7392L159.108 96.823L159.162 97.5266L159 97.9449L158.983 98.4013L158.857 98.7816L158.192 99.3711L157.726 99.9986L157.277 101.178L157.295 102.185L157.043 102.585L156.451 103.174L155.84 103.935L155.463 103.726L155.409 103.383L154.853 103.364L154.493 103.84L154.224 103.707L153.847 103.288L153.542 103.497L153.129 104.03L152.303 102.737L153.075 102.052L152.698 101.254L153.057 100.949L153.739 100.797L153.811 100.246L154.368 100.835L155.266 100.892L155.571 100.322L155.697 99.5042L155.589 98.5534L155.104 97.8308L155.553 96.4047L155.301 96.1765L154.547 96.2716L154.26 95.6441L154.332 95.1117L155.607 95.1497L156.433 95.4729L157.241 95.7582L157.313 95.1117L157.851 93.9707L158.444 93.3242L159.144 93.5334L159.791 93.5904Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M68.8432 83.494L68.1788 83.7031L67.8915 84.3116L67.4785 84.6539L67.1553 85.1103L66.9937 85.9849L66.6705 86.7075L67.1912 86.7836L67.2989 87.335L67.5144 87.6203L67.5683 88.0956L67.4426 88.552L67.4605 88.8182L67.7119 88.9133L67.9274 89.3316L69.2382 89.2175L69.8308 89.3697L70.5131 90.4345L70.9261 90.3014L71.6623 90.3585L72.2369 90.2254L72.5961 90.4345L72.3806 91.081L72.1472 91.4994L72.0394 92.3741L72.2369 93.1917L72.5063 93.553L72.5422 93.8192L72.0215 94.4277L72.3806 94.6939L72.6499 95.1313L72.9373 96.3483L72.7397 96.5004L72.5602 95.7778L72.2729 95.3785L71.9317 95.8158L69.9565 95.7778V96.5384L70.5491 96.6715L70.5131 97.1469L70.3156 97.0138L69.741 97.2039L69.723 98.0977L70.1899 98.554L70.3515 99.2386L70.3336 99.771L69.9385 103.118L69.4178 102.471L69.1125 102.452L69.741 101.197L68.9509 100.627L68.3404 100.741L67.9633 100.532L67.4067 100.855L66.6525 100.684L66.024 99.4097L65.5572 99.1055L65.2339 98.516L64.5516 97.9455L64.2823 98.0596L63.8513 97.7744L63.3485 97.3751L63.0612 97.5652L62.1993 97.3941L61.9479 96.8617L61.7504 96.8807L60.7448 96.1961L60.6191 95.8158L60.9962 95.7208L60.9603 95.1123L61.2117 94.6559L61.7145 94.5798L62.1634 93.8192L62.5584 93.1727L62.1993 92.8875L62.4148 92.1839L62.2173 91.062L62.4507 90.7388L62.325 89.7119L61.93 89.0464L62.0916 88.4569L62.4148 88.552L62.6123 88.1907L62.4148 87.4681L62.5405 87.297L63.0612 87.335L63.8693 86.4793L64.3002 86.3462L64.3182 85.9469L64.5696 84.9011L65.1801 84.3496L65.8086 84.3116L65.9163 84.0644L66.7064 84.1595L67.5324 83.551L67.9454 83.2848L68.4661 82.6953L68.8252 82.7714L69.0587 83.0946L68.8432 83.494Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M56.3105 84.522L56.526 85.1875L56.8851 85.6819L57.334 86.1953L56.939 86.3094L56.921 86.8038L57.1186 86.9749L56.957 87.1271L56.9929 87.3362L56.8851 87.5834L56.8313 87.8306L56.2926 87.5644L56.095 87.2982L56.2207 87.089L56.2028 86.8228L55.9334 86.5376L55.5384 86.2904L55.2152 86.1383L55.1613 85.777L54.9099 85.5678L54.9458 85.9101L54.7303 86.2143L54.5149 85.872L54.2096 85.7389L54.0839 85.5108L54.1019 85.1304L54.2635 84.7501L53.9941 84.579L54.2455 84.3318L54.4071 84.1797L55.0536 84.5029L55.287 84.3508L55.6102 84.4459L55.7539 84.6931L56.0591 84.7882L56.3105 84.522Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M61.733 70.0871L62.0742 70.5245L63.0079 70.3914L63.3311 70.6766L64.0853 71.4372L64.6599 71.9886L64.9831 71.9696L65.5577 72.2168L65.45 72.5591L66.1682 72.6161L66.8685 73.1105L66.7249 73.3958L66.0425 73.5479L65.3602 73.6049L64.6958 73.5099L63.2413 73.6239L63.9955 72.9584L63.6184 72.6352L62.972 72.5591L62.6667 72.1978L62.5231 71.5133L61.9485 71.5513L61.0507 71.228L60.7813 70.9618L59.5064 70.7717L59.1832 70.5435L59.5962 70.2392L58.6265 70.1822L57.8365 70.8097L57.4235 70.8287L57.2439 71.133L56.7411 71.2661L56.3281 71.133L56.9027 70.7717L57.1721 70.3153L57.6569 70.0491L58.1956 69.8209L58.9677 69.7068L59.2191 69.5547L60.0631 69.6498L60.8531 69.6688L61.733 70.0871Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M154.193 35.7768L154.641 36.1571L155.306 36.2522L155.27 36.5755L155.773 36.8227L155.88 36.5184L156.491 36.6515L156.617 37.0318L157.281 37.0889L157.748 37.6784H157.479L157.353 37.8875L157.155 37.9446L157.119 38.2108L156.958 38.2678L156.94 38.3819L156.653 38.496L156.257 38.477L156.15 38.7432L155.719 38.515L155.306 38.5721L154.588 38.2108L154.282 38.3059L153.815 38.8003L153.133 38.4009L152.594 37.9065L152.128 37.6213L152.002 37.1079L151.822 36.7656L152.433 36.5184L152.738 36.2142L153.367 35.986L153.564 35.7578L153.797 35.8909L154.193 35.7768Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M153.146 32.6688L153.397 33.2583L153.182 33.5816L153.523 33.9809L153.792 34.6084L153.756 35.0267L154.187 35.7683L153.792 35.8824L153.559 35.7493L153.361 35.9775L152.733 36.2057L152.427 36.5099L151.817 36.7571L151.996 37.0994L152.122 37.6128L152.589 37.898L153.128 38.3924L152.84 38.9439L152.535 39.096L152.715 39.8756L152.643 40.0848L152.338 39.8376L151.907 39.7996L151.278 40.0087L150.488 39.9517L150.38 40.2749L149.896 39.9517L149.644 40.0087L148.657 39.6474L148.477 39.8946H147.723L147.795 39.0389L148.226 38.2403L146.933 38.0121L146.502 37.7079L146.538 37.1945L146.358 36.9283L146.43 36.1296L146.232 34.8936H146.753L146.969 34.4563L147.13 33.3914L146.969 32.9921L147.112 32.7449L147.831 32.6879L148.01 32.9351L148.567 32.3646L148.333 31.9273L148.261 31.2807L148.926 31.4329L149.447 31.2617L149.5 31.6991L150.38 31.9653L150.398 32.3836L151.242 32.1554L151.709 31.8512L152.715 32.3076L153.146 32.6688Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M184.68 83.8811L184.339 84.5466L184.106 84.3185L183.872 84.4135L183.298 84.3945L183.262 84.0142L183.172 83.6719L183.495 83.1015L183.836 82.5691L184.267 82.6832L184.572 82.3789L184.824 82.7592L184.806 83.2536L184.249 83.5579L184.68 83.8811Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M151.749 30.527L151.318 31.4587L150.384 30.7932L150.223 30.3178L151.444 29.9375L151.749 30.527Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M149.452 31.2581L148.932 31.4292L148.267 31.2771L147.89 30.6306L147.818 29.4707L147.926 29.1474L148.16 28.8051L148.878 28.7481L149.165 28.4248L149.812 28.1016V28.691L149.596 29.0713L149.722 29.3756L150.189 29.5467L150.009 29.9841L149.758 29.87L149.201 30.6876L149.452 31.2581Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M69.08 75.8493L69.1338 75.507L68.9004 75.1457L69.1697 74.9365L69.2954 74.4612L69.2775 73.8146L69.4211 73.6055H70.1933L70.7679 73.9097L71.0372 73.8907L71.1629 74.328L71.7196 74.29L71.6477 74.6513L72.0966 74.7084L72.5455 75.1457L72.1325 75.6401L71.6657 75.3739L71.1988 75.4309L70.8756 75.3739L70.6781 75.6021L70.283 75.6781L70.1573 75.3739L69.8162 75.545L69.3313 76.3817L69.0979 76.1915L69.08 75.8493Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M149.035 52.76L148.855 53.3875L149.035 54.5474L148.837 55.5552L148.263 56.2397L148.37 57.1525L149.178 57.8941L149.196 58.1793L149.807 58.6737L150.274 60.8604L150.615 61.9443L150.687 62.5148L150.543 63.5036L150.615 64.074L150.507 64.7396L150.615 65.5002L150.22 66.0136L150.83 66.9073L150.866 67.4207L151.243 68.1052L151.692 67.8771L152.5 68.4475L152.949 69.2081L149.573 71.547L146.7 73.9429L145.3 74.4754L144.186 74.6085L144.169 73.8288L143.702 73.6197L143.073 73.2774L142.84 72.7069L139.482 70.0448L136.142 67.3827L132.461 64.4163L132.479 64.1881L132.497 64.112L132.515 62.6669L134.113 61.7542L135.083 61.564L135.891 61.2408L136.268 60.6323L137.417 60.1569L137.471 59.2441L138.027 59.1301L138.476 58.6927L139.751 58.4835L139.931 58.0082L139.679 57.7419L139.338 56.4489L139.284 55.7073L138.943 54.9277L139.859 54.2622L140.9 54.053L141.493 53.5586L142.409 53.1783L144.025 52.9691L145.605 52.874L146.09 53.0452L146.97 52.5698L147.993 52.5508L148.388 52.836L149.035 52.76Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M64.2777 98.0627L64.4214 98.9945L64.1161 99.7741L63.0208 101.067L61.8177 101.542L61.2072 102.607L61.0456 103.425L60.4889 103.938L60.04 103.311L59.627 103.178L59.214 103.273L59.1602 102.836L59.4475 102.55L59.3218 102.037L59.8425 101.124L59.6091 100.592L59.232 101.162L58.6035 100.611L58.801 100.268L58.6215 99.1656L58.9806 98.9754L59.1602 98.2148L59.5372 97.4352L59.4834 96.9408L60.04 96.6746L60.7403 96.1992L61.7459 96.8838L61.9434 96.8648L62.1948 97.3972L63.0567 97.5683L63.344 97.3782L63.8468 97.7775L64.2777 98.0627Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M174.372 59.7571L175.072 61.5446L175.198 61.8488L174.964 62.3432L174.839 63.2559L174.623 63.9025L174.408 64.1116L174.049 63.7123L173.564 63.1799L172.72 61.4305L172.63 61.5446L173.133 62.8186L173.833 64.0546L174.713 65.9561L175.126 66.6216L175.485 67.3062L176.455 68.6563L176.275 68.8654L176.347 69.6641L177.568 70.767L177.766 71.0142H173.797H169.937H165.932L165.753 66.5076L165.519 62.1721L165.16 61.1833L165.358 60.4417L165.178 59.9093L165.483 59.3198L166.776 59.3008L167.746 59.624L168.733 59.9853L169.2 60.1755L169.919 59.7952L170.296 59.4529L171.14 59.3388L171.84 59.4909L172.163 60.0994L172.361 59.7001L173.151 59.9853L173.923 60.0614L174.372 59.7571Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M184.576 82.3714L184.27 82.6757L183.839 82.5616L183.48 82.1623L183.031 81.4587L182.565 81.0594L182.295 80.641L181.397 80.1467L180.697 80.1276L180.446 79.8804L179.871 80.1657L179.225 79.6142L178.955 80.527L177.77 80.2607L177.645 79.7854L178.004 77.9789L178.058 77.1803L178.363 76.8L179.081 76.5908L179.566 75.9062L180.212 77.3134L180.553 78.4353L181.128 79.0248L182.565 80.1847L183.157 80.8692L183.732 81.5918L184.055 82.0101L184.576 82.3714Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M163.886 26.1443L164.047 26.3345L163.58 26.981L164.011 28.0458L163.724 28.4071L163.042 28.3881L162.252 27.9698L161.875 27.8367L161.192 28.0268L161.174 27.3613L160.905 27.5134L160.312 27.1141L160.133 26.4676L161.12 26.1443L162.126 25.9922L163.042 26.1633L163.886 26.1443Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M180.69 80.1306L181.39 80.1496L182.288 80.644L182.557 81.0623L183.024 81.4617L183.473 82.1652L183.832 82.5645L183.491 83.097L183.168 83.6674L183.258 84.0097L183.294 84.39L183.868 84.409L184.102 84.314L184.335 84.5421L184.12 84.9605L184.515 85.645L184.91 86.2345L185.305 86.6718L188.663 88.117L189.524 88.098L186.723 91.7679L185.412 91.825L184.515 92.6807L183.868 92.6997L183.599 93.099H182.899L182.486 92.6807L181.552 93.1941L181.264 93.7075L180.582 93.5934L180.349 93.4603L180.115 93.4983L179.792 93.4793L178.499 92.4525H177.781L177.44 92.0532L177.422 91.3686L176.901 91.1594L176.273 89.8284L175.806 89.5431L175.626 89.0487L175.087 88.4593L174.459 88.3642L174.8 87.6797L175.339 87.6416L175.483 87.2803L175.447 86.3296V86.1774L175.716 84.9034L176.183 84.5612L176.273 84.0668L176.686 83.116L177.278 82.5265L177.637 81.3095L177.763 80.2637L178.948 80.5299L179.217 79.6172L179.864 80.1686L180.438 79.8834L180.69 80.1306Z",
      "fill": "#EBECED",
      "stroke": "#FCFCFD",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M162.159 15.7781L162.231 16.5007L163.542 17.2043L163.021 18.0029L164.188 19.2009L163.883 20.1136L164.763 20.9123L164.601 21.6348L165.93 22.3764L165.768 22.9279L165.158 23.5744L163.721 24.9815L162.285 25.0766L160.92 25.4759L159.645 25.7231L159.07 25.1146L158.226 24.7533L158.244 23.6505L157.706 22.6617L157.993 22.0151L158.586 21.3496L160.166 20.1707L160.633 19.9425L160.471 19.4861L159.304 18.9917L158.981 18.5734L158.657 16.9571L157.364 16.2535L156.287 15.7401L156.682 15.4739L157.598 16.0063L158.55 15.9683L159.394 16.2155L160.004 15.7591L160.202 14.9985L161.261 14.6562L162.303 15.0556L162.159 15.7781Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M154.33 95.1112L154.258 95.6436L154.546 96.2711L155.3 96.1761L155.551 96.4043L155.102 97.8304L155.587 98.553L155.695 99.5037L155.569 100.321L155.264 100.892L154.366 100.835L153.809 100.245L153.738 100.797L153.055 100.949L152.696 101.253L153.073 102.052L152.301 102.736L151.26 101.5L150.595 100.493L149.967 99.2375L150.003 98.8192L150.236 98.4389L150.47 97.5452L150.685 96.6324L151.026 96.5754H152.499V95.1112L152.983 95.0352L153.594 95.1873L154.205 95.0352L154.33 95.1112Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M135.693 32.5295L135.064 32.3014L134.525 32.3204L134.741 31.6929L134.579 31.0844L135.298 31.0273L136.177 31.7499L135.693 32.5295Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M138.552 27.0742L137.637 28.3102L138.481 28.1581H139.396L139.163 29.0898L138.391 30.1167L139.271 30.1737L139.325 30.3068L140.079 31.6569L140.653 31.847L141.174 33.1781L141.425 33.6345L142.485 33.8436L142.377 34.6043L141.946 34.9465L142.287 35.555L141.497 36.1635L140.33 36.1445L138.822 36.4868L138.427 36.2396L137.834 36.791L137.026 36.6579L136.38 37.1143L135.931 36.8861L137.242 35.6501L138.032 35.3839L136.667 35.1937L136.434 34.7183L137.349 34.3571L136.9 33.7296L137.08 32.9689L138.355 33.083L138.499 32.3985L137.942 31.6949L137.924 31.6759L136.9 31.4667L136.703 31.1625L137.026 30.6491L136.757 30.3258L136.29 30.8773L136.272 29.7554L135.877 29.1849L136.218 28.006L136.9 27.0932L137.547 27.1693L138.552 27.0742Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M182.2 45.7885L183.116 46.0357L183.493 46.5301L184.139 46.8154L183.924 46.9675L184.516 47.633L184.408 47.7661L183.888 47.7091L183.133 47.3478L182.936 47.557L181.679 47.7471L180.673 47.1386L179.686 47.1957L179.74 46.6823L179.363 45.8646L178.752 45.4082L178.213 45.2751L177.818 44.9138L177.89 44.7617L178.716 44.9709L180.099 45.161L181.463 45.7505L181.679 45.9787L182.2 45.7885Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M141.045 84.4232L140.973 84.8035L141.386 85.431V86.3247L141.494 87.2755L141.745 87.7319L141.511 88.8157L141.601 89.4242L141.871 90.2038L142.104 90.6412L140.506 91.3447L139.931 91.7631L139.016 92.1244L138.118 91.7821L138.154 91.2877L137.723 90.2419L137.992 88.8537L138.423 87.8459L138.154 86.0965L138.01 85.1838L138.046 84.4802L139.806 84.4232L140.255 84.5183L140.578 84.3281L141.045 84.4232Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M129.374 82.675L129.428 83.1314H129.59L129.859 82.9603L130.021 82.9983L130.308 83.3216L130.739 83.4166L131.008 83.1504L131.35 82.9793L131.583 82.8082L131.781 82.8462L132.014 83.1124L132.122 83.4547L132.535 83.9681L132.337 84.2723L132.283 84.6716L132.499 84.5576L132.625 84.6907L132.571 85.0519L132.876 85.4132L132.678 85.5083L132.589 85.9267L132.822 86.421L133.073 87.4098L132.696 87.5429L132.607 87.7141L132.678 87.9613L132.607 88.4937H132.445L132.158 88.4557L131.96 88.9501H131.673L131.475 88.6839L131.547 88.1895L131.116 87.4479L130.865 87.581L130.631 87.619L130.362 87.6761L130.38 87.2387L130.218 86.9154L130.254 86.5542L130.039 86.0407L129.752 85.6034H128.943L128.71 85.8316L128.423 85.8696L128.243 86.1358L128.135 86.4591L127.579 87.0105L127.148 86.2879L126.753 85.8126L126.501 85.6414L126.25 85.3942L126.142 84.8618L125.999 84.5956L125.693 84.3864L126.16 83.7969L126.465 83.816L126.735 83.6258L126.95 83.6068L127.112 83.4547L127.04 83.0553L127.148 82.9222L127.166 82.5039L127.651 82.5229L128.387 82.8082L128.602 82.7891L128.674 82.656L129.231 82.7511L129.374 82.675Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M124.004 81.8195L124.148 81.2681L125.243 81.249L125.476 80.9448L125.8 80.9258L126.195 81.23H126.5L126.841 81.0399L127.039 81.3821L126.59 81.6674L126.159 81.6293L125.728 81.3821L125.351 81.6674H125.171L124.92 81.8385L124.004 81.8195Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M127.163 82.5141L127.145 82.9324L127.037 83.0655L127.109 83.4648L126.948 83.617L126.732 83.636L126.463 83.8261L126.158 83.8071L125.691 84.3966L125.17 83.9022L124.739 83.8071L124.506 83.4648L124.524 83.2747L124.218 83.0275L124.146 82.7613L124.685 82.5711L125.026 82.6092L125.296 82.457L127.163 82.5141Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M152.505 95.1167V96.5808H151.033L150.692 96.6379L150.494 96.4668L150.835 95.0977L152.505 95.1167Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M163.71 54.2852L164.267 54.7035L165.003 54.6274L165.721 54.7035V54.9317L166.224 54.7796L166.134 55.1408L164.769 55.2359L164.752 55.0458L163.566 54.7986L163.71 54.2852Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M165.356 48.0685L164.781 48.0305L164.297 47.9164L163.183 48.2207L163.902 48.9052L163.453 49.1144H162.932L162.375 48.4869L162.214 48.7531L162.501 49.4757L163.022 50.0461L162.681 50.3123L163.255 50.8638L163.758 51.2251L163.83 51.9096L162.932 51.5864L163.255 52.2139L162.663 52.3279L163.111 53.4118L162.483 53.4308L161.657 52.8984L161.226 51.9286L160.993 51.111L160.58 50.5595L160.041 49.856L159.951 49.5137L160.346 48.9242L160.364 48.5249L160.669 48.3538L160.651 48.0305L161.262 47.9354L161.585 47.6692L162.088 47.6882L162.232 47.4791L162.411 47.441L163.094 47.4791L163.812 47.1368L164.512 47.5741L165.338 47.46L165.284 46.8516L165.769 47.1748L165.572 47.9354L165.356 48.0685Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M124.846 2.71278L128.42 3.28324L127.216 3.54945L124.882 3.58748L121.56 3.66354L121.812 3.79665L124.02 3.70157L125.762 3.96779L127.019 3.7396L127.45 4.00582L126.642 4.46218L128.294 4.15794L131.364 3.87271L133.16 4.02483L133.465 4.34809L130.808 4.89953L130.413 5.08968L128.366 5.24181L129.82 5.27984L128.94 5.88832L128.294 6.43977L128.078 7.42856L128.743 8.03705L127.683 8.05606L126.516 8.36031L127.647 8.8547L127.629 9.65334L126.875 9.74842L127.611 10.5661L126.049 10.6421L126.768 11.0224L126.48 11.3647L125.457 11.5168L124.469 11.5359L125.223 12.1824L125.133 12.6387L123.823 12.2204L123.392 12.4866L124.29 12.7338L125.116 13.3423L125.223 14.16L123.894 14.3501L123.41 13.9508L122.656 13.3803L122.745 14.0649L121.776 14.5973L123.697 14.6353L124.685 14.6924L122.548 15.5861L120.357 16.4038L118.077 16.746L117.251 16.765L116.371 17.1644L115.024 18.2672L113.192 19.0088L112.654 19.0659L111.558 19.3131L110.373 19.5793L109.511 20.2258L109.26 20.9864L108.649 21.709L107.105 22.5837L107.159 23.4394L106.513 24.3521L105.776 25.436L104.609 25.5121L103.711 24.5993L102.095 24.5803L101.521 23.9718L101.377 22.907L100.515 21.5379L100.39 20.8343L100.659 19.8645L99.9945 18.8947L100.587 18.1151L100.246 17.7348L101.503 16.5178L102.796 16.1185L103.263 15.7002L103.765 14.9015L102.778 15.2628L102.311 15.415L101.575 15.5481L100.82 15.2248L101.09 14.5212L101.629 13.9888L102.311 13.9698L103.676 14.255L102.724 13.6085L102.239 13.2662L101.449 13.3993L100.982 13.1521L102.239 12.2394L102.006 11.8591L101.808 11.1936L101.557 10.1668L100.91 9.80546L101.162 9.40614L99.7072 8.8547L98.3245 8.77864L96.511 8.81667L94.8051 8.89273L94.2485 8.58849L93.5661 7.99902L95.5413 7.71379L96.906 7.67576L94.2844 7.42856L93.1172 7.06727L93.5122 6.725L96.3314 6.30666L99.0249 5.88832L99.5276 5.58408L98.0732 5.27984L98.8992 4.95658L101.539 4.40514L102.508 4.32908L102.544 3.9868L104.16 3.77763L106.136 3.66354H108.003L108.506 3.89172L110.409 3.47339L111.684 3.75862L112.51 3.81566L113.623 4.06286L112.42 3.66354L112.708 3.34028L114.988 2.92195L117.071 2.95998L117.987 2.69376L120.124 2.63672L124.846 2.71278Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M51.5534 76.144L51.4277 77.1138L51.1943 78.4829H51.4995L51.8048 78.7111L51.9125 78.5209L52.1819 78.673L51.6791 79.1484L51.1584 79.4907L51.0686 79.7189L51.1225 79.9661L50.889 80.2703L50.6376 80.3464L50.6915 80.4985L50.476 80.6316L50.1169 80.9359L50.063 81.107L49.5603 80.8978L48.9318 80.8788L48.5008 80.6316L47.998 80.1372L48.0699 79.7759L48.2135 79.4907L48.0878 79.2625L48.6804 78.2737H49.9733L50.0451 77.8554L49.9014 77.7793L49.8116 77.5131L49.4705 77.2279L49.1473 76.8286L49.5962 76.8095L49.686 76.125H50.6197L51.5534 76.144Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M82.9408 90.5846L82.7612 91.6875L82.1327 91.9917L82.1866 92.277L81.9891 92.9235L82.42 93.7982H82.7433L82.869 94.4827L83.4615 95.5476L83.2281 95.6046L82.6535 95.4905L82.3303 95.8138L81.8634 96.023L81.5402 96.08L81.4324 96.3272L80.9297 96.2702L80.3012 95.6997L80.2473 95.1292L79.9959 94.5017L80.1755 93.4749L80.4628 93.0376L80.2473 92.4671L79.8882 92.296L80.0318 91.7445L79.8164 91.4783L79.2777 91.5163L78.6133 90.6036L78.9006 90.2613V89.6909L79.5291 89.5007L79.7804 89.2725L79.4572 88.8162L79.547 88.3788L80.391 87.6562L81.0374 88.1126L81.63 88.8922L81.6479 89.5388L82.025 89.5578L82.5637 90.1472L82.9408 90.5846Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M57.2093 79.5568L56.8682 79.5378L56.7066 79.7089L56.3474 79.8611H56.096L55.8626 80.0132L55.6651 79.9752L55.5035 79.785L55.3957 79.823L55.2341 80.1083L55.1443 80.0892L55.1084 80.3555L54.7313 80.6787L54.5159 80.8308L54.4081 80.983L54.1388 80.7358L53.8874 81.059H53.6719L53.4385 81.078L53.4026 81.6865H53.2589L53.1153 81.9718L52.7921 82.0288L52.6484 81.6485L52.3431 81.5344L52.4688 81.04L52.3431 80.9069L52.1277 80.8308L51.6788 80.9639L51.6608 80.8118L51.3735 80.6027L51.176 80.3745L50.8887 80.2604L51.1221 79.9561L51.0682 79.7089L51.158 79.4808L51.6788 79.1385L52.1815 78.6631L52.2893 78.7201L52.5227 78.511L52.81 78.492L52.8998 78.587L53.0614 78.53L53.5283 78.6441L53.9951 78.6061L54.3183 78.4729L54.462 78.3398L54.7673 78.3969L55.0007 78.4729L55.27 78.4539L55.4855 78.3398L55.9344 78.511L56.0781 78.549L56.3654 78.7772L56.6347 79.0434L56.9759 79.2336L57.2093 79.5568Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M158.103 41.9262L158.373 42.4016L158.678 42.7439L158.373 43.2002L157.942 42.934L157.313 42.953L156.505 42.7439L156.092 42.7629L155.913 43.0291L155.554 42.7439L155.41 43.2383L155.895 43.8087L156.128 44.17L156.577 44.6264L156.954 44.8926L157.331 45.406L158.193 45.8624L158.103 46.0525L157.206 45.6152L156.631 45.1778L155.769 44.8165L154.925 43.9418L155.105 43.8468L154.656 43.3333L154.602 42.934L154.009 42.7439L153.758 43.2573L153.471 42.858V42.4396L153.489 42.4206L154.135 42.4586L154.279 42.2685L154.602 42.4586L154.961 42.4777L154.943 42.1544L155.248 42.0213L155.302 41.5459L156.003 41.2227L156.29 41.3748L157.008 41.8882L157.78 42.1164L158.103 41.9262Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M69.2746 73.8136L69.2925 74.4601L69.1668 74.9355L68.8975 75.1447L69.1309 75.506L69.077 75.8482L68.4306 75.6391L67.9458 75.7151L67.3353 75.6391L66.8504 75.8673L66.3477 75.4869L66.4734 75.0876L67.3891 75.2588L68.1253 75.3538L68.5204 75.0876L68.1074 74.5552L68.1792 74.0798L67.5507 73.8897L67.8201 73.5664L68.4306 73.6044L69.2746 73.8136Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M160.742 38.9386L161.281 39.2619L161.371 39.5851L160.85 39.8323L160.509 40.631L160.042 41.4486L159.342 41.6768L158.767 41.6198L158.103 41.924L157.779 42.1141L157.007 41.886L156.289 41.3726L156.002 41.2204L155.786 40.8211L155.643 40.8021L155.876 40.0415L155.678 39.7753H156.181L156.217 39.2809L156.702 39.6041L157.043 39.7182L157.779 39.5851L157.833 39.3379L158.174 39.2999L158.587 39.1288L158.695 39.2048L159.108 39.0527L159.288 38.7675L159.575 38.6914L160.563 39.0527L160.742 38.9386Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M263.327 110.381L262.896 110.4L261.621 109.544L262.591 109.297L263.094 109.677L263.417 110.038L263.327 110.381Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M267.783 108.727L267.873 108.974L267.855 109.335L267.119 110.248L266.221 110.514L266.113 110.381L266.239 109.963L266.742 109.221L267.783 108.727Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M260.667 107.758L261.008 108.081L261.655 107.986L261.87 108.499L260.667 108.747L259.967 108.918L259.41 108.899L259.805 108.195H260.38L260.667 107.758Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M265.756 107.758L265.559 108.442L264.015 108.785L262.668 108.633L262.704 108.176L263.53 107.929L264.14 108.29L264.823 108.195L265.756 107.758Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M251.353 106.143L253.292 106.276L253.543 105.763L255.393 106.352L255.716 107.151L257.225 107.379L258.428 108.102L257.243 108.558L256.147 108.064L255.231 108.102L254.19 108.006L253.256 107.797L252.107 107.322L251.371 107.208L250.94 107.36L249.108 106.847L248.965 106.333L248.049 106.238L248.803 105.078L250.024 105.154L250.814 105.63L251.245 105.725L251.353 106.143Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M277.913 105.463L277.339 106.3L277.303 105.387L277.5 104.95L277.734 104.531L277.949 104.893L277.913 105.463Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M270.476 102.095L270.081 102.513L269.398 102.285L269.219 101.752L270.242 101.695L270.476 102.095Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M273.78 101.646L274.103 102.578L273.277 102.065L272.433 101.97L271.841 102.046L271.141 102.008L271.41 101.342L272.667 101.285L273.78 101.646Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M284.518 101.047L284.339 105.021L284.052 109.015L283.226 108.007L282.22 107.76L281.951 108.102L280.658 108.14L281.161 107.151L281.825 106.809L281.645 105.478L281.232 104.47L279.311 103.424L278.485 103.329L276.995 102.188L276.672 102.797L276.276 102.892L276.079 102.454L276.097 101.922L275.343 101.314L276.456 100.876L277.174 100.895L277.102 100.572H275.612L275.217 99.8493L274.319 99.6212L273.906 99.0127L275.271 98.7274L275.792 98.3281L277.426 98.8225L277.587 99.2789L277.821 101.256L278.844 101.979L279.742 100.686L280.927 99.9634H281.825L282.687 100.382L283.423 100.819L284.518 101.047Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M268.521 96.1373L267.713 97.3543L266.941 97.5825L265.971 97.3543L264.265 97.4113L263.385 97.5825L263.242 98.5142L264.139 99.5981L264.696 99.0466L266.599 98.6283L266.51 99.1798L266.061 99.0086L265.612 99.7312L264.696 100.207L265.612 101.766L265.414 102.184L266.276 103.591L266.222 104.39L265.666 104.751L265.289 104.314L265.827 103.325L264.804 103.8L264.57 103.458L264.714 102.983L264.014 102.26L264.139 101.081L263.439 101.443L263.475 102.869L263.439 104.618L262.775 104.789L262.362 104.447L262.703 103.325L262.595 102.146L262.164 102.127L261.877 101.29L262.326 100.492L262.487 99.522L263.026 97.6775L263.224 97.1832L264.086 96.2704L264.894 96.6317L266.169 96.8028L267.336 96.7458L268.341 95.8711L268.521 96.1373Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M272.037 96.5084L271.984 97.5733L271.463 97.4401L271.301 98.1817L271.714 98.8283L271.427 98.9804L271.032 98.2008L270.727 96.6415L270.906 95.6717L271.229 95.2344L271.319 95.8999L271.93 95.995L272.037 96.5084Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M252.644 95.4163L252.823 96.234L253.524 96.9376L254.188 96.6904L254.834 96.7664L255.427 96.1579L255.912 96.0438L256.881 96.3861L257.707 96.1199L258.174 94.4275L258.551 94.0092L258.857 92.6211H260.024L260.922 92.8303L260.383 93.9331L261.173 95.0741L261.011 95.6445L262.161 96.7664L260.957 96.9185L260.634 97.7552L260.67 98.8581L259.683 99.6948L259.611 100.912L259.162 102.775L259.036 102.338L257.851 102.889L257.474 102.148L256.756 102.072L256.253 101.672L255.032 102.129L254.691 101.52L254.008 101.596L253.182 101.463L253.075 99.8279L252.572 99.4856L252.087 98.4398L251.943 97.3749L252.051 96.234L252.644 95.4163Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M248.547 105.023L247.434 105.042L246.626 104.034L245.351 103.026L244.938 102.285L244.202 101.296L243.717 100.383L242.963 98.6717L242.083 97.6449L241.777 96.599L241.382 95.6483L240.449 94.8877L239.892 93.8418L239.102 93.1573L237.989 91.8072L237.881 91.1797L238.527 91.2367L240.125 91.4649L241.059 92.6629L241.885 93.4995L242.46 93.9939L243.447 95.306L244.489 95.325L245.351 96.1617L245.961 97.1885L246.733 97.759L246.32 98.7478L246.913 99.1661L247.272 99.2041L247.434 100.06L247.775 100.725L248.511 100.839L248.978 101.619L248.673 103.14L248.547 105.023Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M220.252 61.0233L219.749 61.5937L219.588 62.7346L220.629 63.191L221.671 63.7805L223.071 64.465L224.454 64.6362L225.136 65.2446L225.909 65.3587L227.148 65.644L227.974 65.625L227.991 65.1496L227.722 64.3699L227.686 63.8565L228.243 63.5903L228.512 64.5601L228.584 64.7883L229.572 65.2637L230.146 65.0735L230.99 65.1496L231.798 65.1115L231.708 64.3699L231.242 63.9706L231.996 63.8185L232.696 62.9058L233.666 62.1452L234.546 62.4304L235.12 61.917L235.767 62.6776L235.551 63.191L236.646 63.3811L236.826 63.8375L236.521 64.0657L236.772 64.8073L236.018 64.5981L234.905 65.4348L235.066 66.1384L234.707 67.1652L234.761 67.7547L234.474 68.7625L233.648 68.4772L233.809 69.7513L233.63 70.1696L233.809 70.683L233.36 70.9682L232.57 69.0287H232.301L232.247 69.8273L231.601 69.1808L231.816 68.4962L232.247 68.4202L232.534 67.3934L231.924 67.1842L231.008 67.2032L230.038 67.0321L229.823 66.1764L229.338 66.1193L228.458 65.5869L228.243 66.4236L229.069 67.0701L228.53 67.5265L228.369 67.9638L229.033 68.2871L228.979 69.0287L229.446 69.9414L229.733 70.9492L229.643 71.4056L228.961 71.3866L227.776 71.6338L227.938 72.5465L227.507 73.2691L226.16 74.1057L225.208 75.5319L224.526 76.3115L223.628 77.1102L223.682 77.6616L223.215 77.9658L222.353 78.4032L221.886 78.4602L221.671 79.392L222.012 80.9893L222.138 81.9971L221.796 83.157L221.922 85.2297L221.401 85.2867L220.988 86.2185L221.33 86.6368L220.414 86.9791L220.109 87.7967L219.714 88.158L218.708 87.0171L218.151 85.3057L217.702 84.0697L217.307 83.4993L216.697 82.3203L216.338 80.7991L216.086 80.0385L215.027 78.3652L214.398 75.9883L213.932 74.429L213.788 72.9458L213.483 71.8049L212.1 72.5465L211.382 72.3944L209.927 70.9112L210.358 70.4738L210.017 69.9985L208.742 68.9526L209.317 68.135H211.49L211.166 67.0891L210.538 66.4806L210.286 65.5299L209.568 64.9974L210.448 63.7044L211.615 63.7995L212.423 62.5255L212.818 61.2895L213.519 60.0535L213.339 59.1788L214.021 58.4752L213.106 57.8857L212.585 57.0491L211.992 55.9842L212.351 55.4518L213.878 55.756L214.901 55.5659L215.584 54.5391L216.966 55.9842L217.11 56.973L217.649 57.6005L217.756 58.228L217.02 58.0569L217.595 59.407L218.708 60.1676L220.252 61.0233Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M135.698 32.5311L135.824 33.3678L135.123 34.4136L133.543 35.0982L132.322 34.927L133.094 33.71L132.717 32.5311L133.92 31.6184L134.585 31.0859L134.746 31.6944L134.531 32.3219L135.07 32.3029L135.698 32.5311Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M184.592 50.5925L184.916 50.5545L185.867 49.6607L186.208 49.5657L186.55 49.927L186.334 50.5164L187.034 51.163L187.268 51.0869L187.717 51.9996L188.668 52.2468L189.441 52.8553L190.823 53.0645L192.26 52.7412L192.296 52.456L193.086 52.2278L193.624 51.5242L194.271 51.5623L194.63 51.3341L195.33 51.4482L196.515 52.0757L197.288 52.2088L198.598 53.2736L199.317 53.3307L199.622 54.3385L199.514 55.8597L199.424 56.7534L199.873 56.9436L199.586 57.6091L200.071 58.5789L200.286 59.3585L201.058 59.5677L201.256 60.3473L200.556 61.4502L201.13 62.0967L201.633 62.8383L202.656 63.3707L202.836 64.4356L203.321 64.6448L203.482 65.1962L202.136 65.8427L201.938 67.2498L200.035 66.8886L198.922 66.6033L197.79 66.4512L197.198 64.949L196.695 64.7398L195.959 64.949L195.043 65.5385L193.786 65.1392L192.691 64.1884L191.703 63.8461L190.913 62.6862L189.979 61.0699L189.476 61.26L188.812 60.8607L188.507 61.3361L187.878 60.6896L187.789 60.0431H187.483L187.519 59.1494L186.891 58.2366L185.616 57.5521L184.79 56.3921L184.88 55.4414L185.293 55.023L185.131 54.3195L184.449 53.9392L183.605 52.494L182.922 51.5242L183.048 51.1439L182.527 49.7558L183.12 49.3945L183.335 49.8699L183.91 50.4214L184.592 50.5925Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M183.604 52.4967L184.448 53.9418L185.13 54.3221L185.292 55.0257L184.879 55.444L184.789 56.3948L185.615 57.5547L186.89 58.2393L187.518 59.152L187.482 60.0457H187.788L187.878 60.6923L188.506 61.3388L187.913 61.2817L187.249 61.1676L186.656 62.3466L184.825 62.2515L181.808 59.7985L180.264 58.9429L179.043 58.6006L178.486 57.1174L180.462 55.8434L180.641 54.3792L180.426 53.4855L180.91 53.1812L181.288 52.4206L181.665 52.2305L182.796 52.4016L183.173 52.7058L183.604 52.4967Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M129.966 18.5136L129.714 19.1981L130.505 19.9207L129.409 20.7383L127.057 21.4799L126.357 21.6891L125.351 21.518L123.214 21.1757L124.076 20.7003L122.46 20.1869L123.879 19.9777L123.897 19.6545L122.316 19.4073L122.963 18.7037L124.148 18.5516L125.225 19.2742L126.482 18.7037L127.398 18.9889L128.709 18.4375L129.966 18.5136Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M175.628 57.2539L175.7 57.7483L175.592 57.9385H175.61L175.484 58.3188L175.107 58.1666L174.982 58.9653L175.251 59.0984L175.018 59.2695L175 59.5928L175.448 59.4407L175.52 59.916L175.197 61.8556L175.071 61.5513L174.371 59.7639L174.622 59.3646L174.551 59.2885L174.748 58.7181L174.856 57.8053L174.964 57.4821H174.982H175.305L175.377 57.2729L175.628 57.2539Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M155.715 51.2031L155.41 52.1729L155.572 52.5342L155.41 53.1617L154.656 52.7053L154.171 52.5722L152.824 51.9637L152.914 51.3362L154.027 51.4503L154.997 51.3172L155.715 51.2031Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M149.61 47.5938L150.203 48.4494L150.131 50.0657L149.7 49.9897L149.323 50.389L148.964 50.0657L148.874 48.6016L148.641 47.917L149.161 47.9741L149.61 47.5938Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M153.509 41.2265L153.437 41.816L153.688 42.3294L152.952 42.1392L152.252 42.5766L152.323 43.166L152.234 43.5083L152.575 44.1168L153.473 44.7253L153.993 45.7331L155.089 46.7029L155.807 46.6839L156.058 46.9501L155.807 47.1973L156.669 47.6346L157.387 47.9959L158.231 48.6424L158.339 48.8516L158.195 49.2889L157.639 48.7185L156.813 48.5283L156.471 49.308L157.172 49.7643L157.1 50.3918L156.723 50.4679L156.274 51.5137L155.879 51.6088L155.861 51.2285L156.022 50.582L156.22 50.3158L155.807 49.6122L155.484 49.0037L155.089 48.8516L154.765 48.3382L154.155 48.11L153.724 47.6156L153.042 47.5395L152.27 47.0071L151.39 46.2085L150.725 45.5239L150.384 44.326L149.917 44.1929L149.163 43.7935L148.75 43.9457L148.229 44.5161L147.852 44.5922L147.942 44.0788L147.439 43.9267L147.17 42.9949L147.475 42.6336L147.206 42.1772L147.224 41.835L147.619 42.1012L148.068 42.0441L148.553 41.6258L148.714 41.816L149.145 41.7779L149.325 41.3025L150.007 41.4547L150.384 41.2455L150.438 40.7701L150.995 40.9413L151.084 40.7131L151.964 40.5039L152.198 40.9032L153.509 41.2265Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M63.8319 76.0565L63.5087 76.2656L62.97 76.0565L62.4492 75.6191L62.5929 75.3339L63.0238 75.2578L63.2573 75.2958L63.9216 75.4099L64.4065 75.6952L64.5501 76.0374L63.8319 76.0565Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M179.042 58.6004L178.88 58.7905L177.013 59.399L178.09 60.635L177.803 60.8252L177.677 61.2435L176.941 61.4146L176.743 61.852L176.366 62.2323L175.253 62.0231L175.199 61.852L175.522 59.9124L175.451 59.437L175.558 59.0758L175.487 58.3151L175.612 57.9348L176.743 58.4292L178.485 57.1172L179.042 58.6004Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M270.689 56.1881L270.977 56.6064L270.743 57.348L270.187 56.9487L269.809 57.2339L269.827 57.9375L269.055 57.5952L268.84 57.0248L269.073 56.2832L269.684 56.4353L269.863 55.9219L270.689 56.1881Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M275.105 52.5398L275.212 53.5096L275.661 54.1181L275.554 54.9738L274.584 55.5443L272.932 55.6203L272.142 57.0274L271.298 56.5521L270.867 55.6393L269.323 55.9055L268.407 56.476L267.294 56.514L268.622 57.4078L268.766 59.4804L268.317 59.9938L267.671 59.5184L267.509 58.4156L266.773 58.0733L266.055 57.2366L266.827 56.8563L267.024 56.0767L267.725 55.4492L268.084 54.6125L269.826 54.2512L270.957 54.4984V52.3307L271.873 52.9202L272.681 51.7032L272.986 51.2278L272.806 49.7446L271.891 48.3755L271.855 47.6149L272.717 47.3867L274.189 49.0791L274.692 50.0489L274.458 51.2848L275.105 52.5398Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M272.968 44.0176L273.776 44.2648L274.099 43.7704L275.177 45.1205L274.027 45.4438L273.956 46.6417L271.998 45.8241L272.286 47.1361L271.262 47.1551L270.418 45.9572L270.31 45.0254L271.244 44.9684L270.454 43.295L270.131 42.3633L272.016 43.6183L272.968 44.0176Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M204.217 32.9758L205.007 32.9188L206.659 31.8159L206.516 32.1962L208.024 33.0899L211.31 36.0563L211.507 35.4478L213.016 36.1133L214.129 35.8091L214.722 36.0183L215.458 36.7028L216.176 36.931L216.769 37.4444L217.846 37.2733L218.636 37.9958L218.295 38.7945L217.613 38.9086L218.062 40.0875L217.774 40.639L215.835 40.2396L216.014 42.3884L215.655 42.6546L214.021 43.13L215.601 45.2216L215.081 45.5259L215.386 46.2294L214.758 46.0393L214.147 45.6019L212.728 45.4878L211.184 45.4498L210.897 45.5829L209.424 45.0695L208.976 45.3357L209.065 46.0393L207.413 45.621L206.857 45.7921L206.803 46.3245L206.336 46.5527L205.366 47.3894L205.205 48.2641H204.846L204.433 47.6936L203.23 47.6556L202.781 46.6668L202.314 46.6478L202.044 45.4308L200.68 44.5561L199.135 44.6512L198.112 44.8223L196.927 43.7384L196.065 43.2821L194.413 42.4264L194.215 42.3313L192.061 43.0349L193.174 47.4844L192.707 47.5415L191.845 46.5907L191.145 46.2485L190.139 46.4957L189.816 46.914L189.708 46.6097L189.816 46.1153L189.547 45.697L188.38 45.2787L187.715 44.1948L187.141 43.8906L187.033 43.4912L187.949 43.6053L187.769 42.7306L188.505 42.5405L189.349 42.7116L189.224 41.5517L188.882 40.8101L187.985 40.8671L187.141 40.5819L186.225 41.0953L185.435 41.3615L184.932 41.1524L184.896 40.5439L184.124 39.7452L183.477 39.7833L182.526 38.9846L182.831 38.0719L182.508 37.8437L182.903 36.5317L183.98 37.2162L183.872 36.3605L185.327 35.0865L186.692 35.0485L188.846 35.8661L190.032 36.3415L190.822 35.8471L192.204 35.8281L193.515 36.4366L193.659 36.0753L194.916 36.1323L194.952 35.5809L193.264 34.7632L193.892 34.1928L193.623 33.8885L194.341 33.5843L193.425 32.7857L193.677 32.3863L196.729 31.987L197.035 31.7018L198.992 31.2644L199.548 30.7891L201.182 31.0363L201.973 32.2342L202.745 31.949L204.02 32.3483L204.217 32.9758Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M183.602 93.0958L182.722 94.4649L182.758 98.9145L183.35 99.9223L182.632 100.417L182.381 100.93L181.986 101.006L181.842 101.881L181.501 102.375L181.303 103.174L180.89 103.573L179.436 102.356L179.382 101.653L175.701 99.1617L175.773 98.2679L175.521 97.7926V97.7355L175.809 97.2411L176.312 96.4425L176.689 95.5488L176.222 94.1416L176.096 93.5332L175.611 92.6775L176.222 91.9549L176.904 91.1562L177.425 91.3654L177.443 92.05L177.784 92.4493H178.502L179.795 93.4761L180.118 93.4951L180.352 93.4571L180.585 93.5902L181.268 93.7043L181.555 93.1909L182.489 92.6775L182.902 93.0958H183.602Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M215.386 46.2185L215.35 46.4847L214.111 47.1313L213.931 47.6257L212.782 47.7588L212.675 48.5384L211.633 48.3672L211.058 48.6144L210.322 49.1849L210.538 49.4701L210.34 49.7363L208.616 49.9265L207.341 49.5272L206.354 49.6223L206.246 48.9377L207.323 49.1279L207.575 48.7666L208.311 48.8807L209.263 48.006L207.97 47.3594L207.395 47.6637L206.569 47.2073L207.108 46.4277L206.803 46.3136L206.857 45.7812L207.413 45.61L209.065 46.0284L208.975 45.3248L209.424 45.0586L210.897 45.572L211.184 45.4389L212.728 45.4769L214.147 45.591L214.757 46.0284L215.386 46.2185Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M249.377 80.5272L249.7 81.3449L249.718 82.809L248.102 83.7598L248.605 84.4824L247.545 84.5774L246.719 85.0718L245.857 84.9007L245.39 84.2542L244.762 82.9992L244.385 81.516L244.941 80.5082L246.216 80.28L247.168 80.4511L248.066 80.9265L248.425 80.0898L249.377 80.5272Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M260.707 51.7919V51.6778L261.156 51.7159L261.264 51.1834L261.91 51.1074L262.269 51.0313V50.7461L263.76 52.1722L264.352 52.9709L264.963 54.378L264.873 55.0435L264.101 55.2717L263.544 55.7851L262.718 55.8802L262.341 55.2147L262.144 54.3019L261.192 53.0469L261.802 52.8378L260.707 51.7919Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M187.909 61.2899L188.179 61.8223L188.125 62.1075L188.556 63.0203L187.855 63.0583L187.55 62.4688L186.652 62.3547L187.245 61.1758L187.909 61.2899Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M249.378 80.5234L248.427 80.086L248.067 80.9227L247.17 80.4473L247.439 79.8959L247.367 78.8691L246.415 77.8042L246.182 76.5872L245.284 75.5984L244.512 75.5224L244.368 75.9407L243.794 75.9787L243.453 75.7696L242.501 76.4922L242.321 75.3893L242.393 74.1153L241.711 74.0582L241.549 73.3166L241.064 72.9363L241.208 72.499L241.944 71.7003L242.088 71.9855L242.627 72.0236L242.268 70.6164L242.752 70.4453L243.471 71.4151L244.099 72.518H245.32L245.859 73.5828L245.266 73.9061L245.051 74.3434L246.362 75.085L247.385 76.5302L248.175 77.595L249.055 78.4507L249.414 79.3064L249.378 80.5234Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M175.627 57.2515L175.376 57.2705L175.304 57.4796H174.98L175.214 56.4718L175.609 55.6162V55.5781L176.058 55.6352L176.273 56.1106L175.789 56.5859L175.627 57.2515Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M132.445 88.4951L132.409 88.8373L132.499 89.4268L132.284 89.9782L132.571 90.3205L132.894 90.3966L133.325 90.91L133.361 91.3854L133.253 91.5375L133.181 92.5453L132.912 92.5643L131.871 91.9748L130.937 91.0431L130.075 90.3776L129.393 89.5979L129.644 89.1986L129.698 88.8373L130.165 88.1908L130.632 87.6204L130.865 87.5823L131.116 87.4492L131.547 88.1908L131.476 88.6852L131.673 88.9514H131.96L132.158 88.457L132.445 88.4951Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M165.486 59.3273L165.18 59.9168L165.36 60.4492L165.162 61.1908L165.522 62.1796L165.755 66.5151L165.935 71.0217L166.024 73.4556H164.875V73.969L160.817 71.6302L156.777 69.2913L155.789 69.9568L155.107 70.4132L154.532 69.7477L152.952 69.2152L152.503 68.4546L151.695 67.8842L151.246 68.1123L150.869 67.4278L150.833 66.9144L150.223 66.0207L150.618 65.5073L150.51 64.7467L150.618 64.0811L150.546 63.5107L150.69 62.5219L150.618 61.9514L150.277 60.8675L150.743 60.6013L150.815 60.0689L150.707 59.5745L151.354 59.0991L151.641 58.6998L152.108 58.3575L152.126 57.4258L153.275 57.8441L153.688 57.73L154.496 57.9392L155.807 58.4906L156.31 59.5745L157.19 59.8027L158.59 60.3161L159.668 60.9246L160.117 60.6013L160.566 60.0499L160.278 59.1181L160.548 58.5096L161.212 57.9392L161.876 57.7871L163.205 58.0343L163.564 58.5667L163.923 58.5857L164.247 58.7949L165.216 58.928L165.486 59.3273Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M223.54 90.3022L222.678 90.5874L222.158 89.6176L221.906 87.8682L222.265 85.8906L223.002 86.5562L223.504 87.4118L224.061 88.6859L223.953 89.9599L223.54 90.3022Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M168.443 135.16L168.084 135.293L167.42 134.342L167.995 133.581L168.551 133.106L169.036 132.84L169.431 133.22L169.736 133.6L169.395 134.19L169.198 134.589L168.641 134.779L168.443 135.16Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M163.422 30.5197L163.602 31.0332L162.955 31.4135L162.866 32.06L162.004 32.4973H161.16L160.908 32.136L160.459 32.0029L160.352 31.7177L160.388 31.3944L159.993 31.2233L159.077 31.0141L158.771 30.0444L159.687 29.7021L161.106 29.7782L161.914 29.6641L162.075 29.8922L162.524 29.9683L163.422 30.5197Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M146.502 37.7093L146.25 37.7283L146.053 37.6333L146.125 36.9677L146.358 36.9297L146.538 37.1959L146.502 37.7093Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M163.725 28.4103L164.174 28.6575L164.354 29.2089L164.731 29.8935L163.905 30.3308L163.42 30.521L162.522 29.9696L162.073 29.8935L161.912 29.6653L161.104 29.7794L159.685 29.7033L158.769 30.0456L158.68 29.1899L158.985 28.4673L159.721 28.087L160.511 28.9427L161.176 28.9047L161.194 28.03L161.876 27.8398L162.253 27.9729L163.043 28.3913L163.725 28.4103Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M138.943 54.9257L139.284 55.7053L139.338 56.4469L139.679 57.74L139.93 58.0062L139.751 58.4816L138.476 58.6907L138.027 59.1281L137.47 59.2422L137.417 60.1549L136.267 60.6303L135.89 61.2388L135.082 61.562L134.113 61.7522L132.514 62.6649L132.497 64.1101H132.335L132.353 64.7566L131.742 64.7946L131.419 65.0798H130.97L130.611 64.9087L129.785 65.0418L129.444 65.9926L129.121 66.0876L128.636 67.6279L127.217 68.9399L126.858 70.6323L126.427 71.1837L126.302 71.6211L124.057 71.7162H124.039L124.093 71.1457L124.488 70.8224L124.829 70.1759L124.775 69.7576L125.134 68.9019L125.709 68.1223L126.05 67.9321L126.337 67.2286L126.373 66.563L126.75 65.8214L127.433 65.3651L128.079 64.1291L128.097 64.1101L128.618 63.6347L129.534 63.5016L130.324 62.6649L130.827 62.3416L131.671 61.3148L131.455 59.8126L131.85 58.7478L132.012 58.1012L132.658 57.2836L133.628 56.7321L134.364 56.2187L135.028 54.9637L135.352 54.2031L136.052 54.2221L136.609 54.7355L137.524 54.6595L138.512 54.9257H138.943Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M166.704 42.4426L166.47 41.8911L166.506 41.3777L166.399 40.8643L165.788 40.1417L165.429 39.6473L165.106 39.3051L164.818 39.1719L165.016 39.0008L165.59 38.8867L166.309 39.248L166.668 39.3051L167.135 39.6283L167.117 40.0276L167.476 40.2178L167.673 40.7122L168.033 41.0164L167.997 41.2066L168.176 41.3207L167.943 41.4157L167.404 41.3777L167.296 41.2066L167.117 41.3017L167.225 41.5108L167.027 41.9101L166.919 42.3095L166.704 42.4426Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M191.581 114.422L191.653 115.886L191.886 116.457L191.76 117.046L191.545 117.388L191.258 116.685L191.042 117.046L191.186 117.94L191.06 118.472L190.755 118.739L190.629 119.784L190.144 121.211L189.534 122.884L188.762 125.204L188.241 126.896L187.684 128.322L186.858 128.607L185.943 129.121L185.404 128.817L184.65 128.379L184.434 127.733V126.649L184.165 125.679L184.129 124.785L184.362 123.911L184.829 123.702L184.865 123.302L185.386 122.37L185.529 121.591L185.332 121.02L185.188 120.241L185.17 119.119L185.565 118.434L185.745 117.655L186.248 117.617L186.822 117.369L187.217 117.141L187.648 117.122L188.259 116.438L189.139 115.677L189.462 115.069L189.354 114.536L189.785 114.688L190.378 113.852L190.432 113.11L190.791 112.559L191.114 113.091L191.365 113.604L191.581 114.422Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M44.5859 66.3266L44.981 66.2886L44.4064 67.3724L44.0832 68.2472L43.76 69.8825L43.5624 70.4719L43.6343 71.1375L43.8677 71.746L43.9395 72.6777L44.4782 73.5904L44.6219 74.294L44.9271 74.8835L45.9506 75.2067L46.2918 75.7201L47.2255 75.3779L47.9977 75.2638L48.7877 75.0356L49.4342 74.8264L50.1345 74.332L50.4577 73.6285L50.6732 72.6016L50.8886 72.2404L51.6069 71.9171L52.7022 71.6319L53.5821 71.6889L54.1926 71.5748L54.4081 71.841L54.3004 72.4305L53.6719 73.1531L53.3487 73.8947L53.5103 74.1038L53.2948 74.6363L52.9177 75.587L52.7022 75.2638L52.5047 75.2828L52.3072 75.3018L51.8583 76.0434L51.6967 75.8913L51.571 75.9483L51.553 76.1385L50.6193 76.1195H49.6856L49.5958 76.804L49.1469 76.823L49.4701 77.2223L49.8113 77.5076L49.901 77.7738L50.0447 77.8498L49.9729 78.2682H48.68L48.0874 79.257L48.2131 79.4852L48.0695 79.7704L47.9977 80.1317L46.9921 78.8196L46.5252 78.4203L45.7352 78.097L45.1605 78.1921L44.2986 78.6485L43.7779 78.7626L43.1135 78.4393L42.3773 78.2111L41.5154 77.6597L40.7792 77.4886L39.7198 76.9181L38.9476 76.3286L38.7501 76.0054L38.1935 75.9293L37.2238 75.549L36.8826 74.9976L35.913 74.294L35.518 73.5334L35.3743 72.9249L35.7155 72.8108L35.6616 72.4685L35.9489 72.1453L36.0207 71.7269L35.7514 71.1755V70.7001L35.518 70.0726L34.8356 68.8556L34.0096 67.9049L33.6684 67.1443L32.9322 66.6499L32.8065 66.3456L33.1118 65.604L32.6808 65.3188L32.2319 64.7103L32.196 63.8736L31.6932 63.7596L31.2802 63.1321L30.975 62.5236L31.0288 62.1433L30.7595 61.2305L30.7056 60.2988L30.8493 59.8234L30.2926 59.329L29.9515 59.386L29.5205 59.0628L29.1973 59.5572L29.1793 60.1276L28.9998 61.0594L29.1793 61.5538L29.6821 62.3905L29.7539 62.6947L29.8796 62.7708L29.8976 63.1891L30.0772 63.1701V63.9687L30.3106 64.273L30.4004 64.7103L30.8852 65.3188L30.957 66.4597L31.1366 66.9921L31.2982 67.5626L31.2443 68.2091L31.7112 68.2472L31.9985 68.7986L32.2678 69.35L32.214 69.5782L31.7112 70.0156H31.5316L31.4059 69.274L30.8852 68.5704L30.2747 67.9809L29.8258 67.6767L30.0412 66.783L30.0233 66.1174L29.6462 65.7371L29.0896 65.2047L28.9279 65.3568L28.7484 65.0336L28.2097 64.7483L27.8146 64.0258L27.9044 63.9497L28.2815 64.0068L28.7663 63.5504L28.9459 62.9989L28.4252 62.1242L27.9583 61.801L27.8146 61.0404L27.7069 60.2227L27.5633 59.2529L27.5273 58.1501L28.6586 58.055L29.9335 57.9219L29.7719 58.1691L31.0288 58.7585L32.9861 59.6142H34.9254H35.6975L35.8412 59.1008H37.5291L37.7625 59.5382L38.1396 59.9375L38.5705 60.4699L38.7142 61.0974L38.786 61.782L39.199 62.1433L39.9173 62.5045L40.7792 61.5538L41.5872 61.5158L42.1618 62.0102L42.4491 62.8468L42.6107 63.5694L43.0417 64.2539L43.0776 65.1096L43.2392 65.6801L43.9395 66.0604L44.5859 66.3266Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M162.411 47.4362L162.231 47.4743L162.088 47.6834L161.585 47.6644L161.262 47.9306L160.651 48.0257L160.238 47.7405L160.059 47.2271L160.148 46.8087L160.274 46.8278L160.292 46.5806L160.813 46.3904L161.028 46.3334L161.333 46.2763L161.764 46.2383L162.267 46.6376L162.411 47.4362Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M145.298 74.4833L145.316 77.2976L144.759 78.1152L144.687 78.8758L143.79 79.066L142.407 79.1611L142.048 79.5984L141.401 79.6555H140.755L140.504 79.4273L139.947 79.5984L138.995 80.1118L138.798 80.4921L138.026 81.0246L137.882 81.3478L137.451 81.595L136.966 81.4239L136.697 81.7281L136.535 82.5648L135.727 83.5726L135.763 83.9909L135.476 84.5043L135.548 85.2079L135.117 85.3981L134.883 85.5502L134.722 85.0368L134.434 85.1699L134.255 85.1509L134.075 85.4931H133.285L133.016 85.303L132.872 85.4171L132.567 85.0558L132.621 84.6945L132.495 84.5614L132.28 84.6755L132.333 84.2762L132.531 83.9719L132.118 83.4585L132.01 83.1162L131.777 82.85L131.579 82.812L131.346 82.9831L131.005 83.1543L130.735 83.4205L130.304 83.3254L130.017 83.0021L129.855 82.9641L129.586 83.1352H129.425L129.371 82.6789L129.425 82.2986L129.335 81.8422L128.976 81.4999L128.778 80.7964L128.742 80.0358L129.083 79.8076L129.263 79.085L129.586 79.066L130.286 79.4083L130.861 79.1611L131.238 79.2371L131.4 78.9709L135.44 78.9519L135.673 78.0962L135.494 77.9441L135.045 72.6769L134.614 67.4096L136.14 67.3906L139.48 70.0528L142.838 72.7149L143.071 73.2853L143.7 73.6276L144.167 73.8368L144.185 74.6164L145.298 74.4833Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M241.942 71.7011L241.206 72.4997L241.062 72.9371L240.524 73.2223L240.021 73.7547L239.321 73.8118L239.051 75.1238L238.656 75.352L239.285 76.4169L240.021 77.3106L240.542 78.1282L240.29 79.1741L239.967 79.4023L240.29 80.0108L241.062 80.9805L241.242 81.6651L241.278 82.2355L241.763 83.3574L241.296 84.4984L240.901 85.7534L240.739 84.8406L240.973 83.9089L240.578 83.1863L240.542 81.8552L240.075 81.2087L239.59 79.7636L239.231 78.2233L238.674 77.1965L238.1 77.824L237.058 78.6797L236.466 78.5846L235.819 78.2994L235.981 76.7782L235.622 75.6372L234.67 74.2301L234.724 73.7928L234.113 73.6216L233.287 72.6328L233.09 71.644L233.467 71.8342L233.359 70.9595L233.808 70.6743L233.629 70.1609L233.808 69.7425L233.646 68.4685L234.473 68.7537L234.76 67.7459L234.706 67.1565L235.065 66.1296L234.903 65.4261L236.017 64.5894L236.771 64.7986L236.52 64.057L236.825 63.8288L236.645 63.3724L237.202 63.2773L237.687 63.9999L238.172 64.2852L238.405 65.2169L238.567 66.2247L237.812 67.2515L237.938 68.6967L238.944 68.4875L239.375 69.6094L240.039 69.8566L239.895 70.8644L240.703 71.3208L241.17 71.549L241.853 71.1877L241.942 71.7011Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M159.738 45.6487L159.594 45.9149L159.343 46.029L159.271 45.8008L158.93 46.3903L159.019 46.7896L158.822 46.6945L158.517 46.2952L158.104 46.048L158.193 45.8578L158.265 45.1923L158.552 44.9071L158.714 44.793L158.965 45.0021L159.127 45.1733L159.432 45.3064L159.809 45.5536L159.738 45.6487Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M232.566 36.9688L233.285 36.7406L234.308 36.5885L235.278 36.7596L236.463 37.3111L237.343 37.9196H238.169L239.39 38.1097L240.036 37.8055L241.096 37.6153L241.886 36.7787L242.496 36.9118L243.197 37.3111L244.202 37.197L244.31 38.0907L244.364 39.2887L244.867 39.7641L245.28 39.6119L246.267 39.8021L246.716 39.3647L247.65 39.745L248.943 40.5817L249.086 41L248.296 40.8669L247.075 41.0191L246.626 41.3613L246.393 42.16L245.244 42.6163L244.669 43.2629L243.61 43.0157L243.035 42.9016L242.945 43.6812L243.466 44.1376L243.807 44.5369L243.376 44.9552L243.017 45.6017L242.137 46.0201L240.773 46.0581L239.48 46.4764L238.69 47.123L238.097 46.7617H236.984L235.296 46.0201L234.29 45.8489L233.141 46.0201L231.112 45.7348L230.106 45.7729L229.262 45.0503L228.365 43.9474L227.754 43.8143L226.318 43.0537L225.025 42.9016L223.858 42.6924L223.319 42.16L223.067 40.7719L222.026 39.8021L220.554 39.3647L219.53 38.7372L218.938 37.9006L219.781 37.6914L220.985 36.6836L222.044 36.1321L222.996 36.4934L223.929 36.5124L224.791 37.0639L225.689 37.1019L227.126 37.4062L227.557 36.5695L226.838 35.8849L227.072 34.668L228.329 35.1433L229.191 35.2955L230.394 35.5997L231.04 36.4744L232.566 36.9688Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M173.403 130.519H172.666L172.612 129.967L172.505 129.416L172.433 128.978L172.684 127.628L172.487 126.754L172.092 125.042L173.205 123.654L173.51 122.779L173.654 122.665L173.816 121.943L173.672 121.581L173.744 120.669L173.977 119.832L174.049 118.273L173.546 117.893L173.061 117.797L172.864 117.493L172.397 117.246L171.553 117.265L171.517 116.809L171.445 115.934L174.534 114.926L175.108 115.516L175.378 115.402L175.773 115.706L175.809 116.2L175.575 116.771L175.611 117.626L176.24 118.387L176.581 117.531L177.03 117.284L177.012 115.706L176.617 114.831L176.276 114.432H176.204L176.096 113.044L176.365 111.884L176.76 111.846L177.963 112.188L178.233 112.036L178.933 111.998L179.31 111.636L179.921 111.656L181.034 111.18L181.86 110.477L182.022 111.009L181.932 112.226L182.022 113.31L181.986 115.211L182.129 115.801L181.788 116.676L181.357 117.531L180.693 118.292L179.741 118.748L178.574 119.338L177.389 120.65L176.994 120.878L176.24 121.753L175.827 122.019L175.683 122.894L176.114 123.825L176.276 124.529V124.909L176.455 124.833L176.365 126.031L176.168 126.601L176.383 126.811L176.204 127.324L175.773 127.761L174.929 128.161L173.69 128.826L173.241 129.283L173.295 129.796L173.528 129.872L173.403 130.519Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M136.145 67.3883L134.618 67.4073L135.049 72.6745L135.498 77.9417L135.678 78.0938L135.444 78.9495L131.404 78.9685L131.243 79.2347L130.866 79.1587L130.291 79.4059L129.591 79.0636L129.267 79.0826L129.088 79.8052L128.747 80.0334L128.1 79.1967L127.49 78.284L126.843 77.9607L126.359 77.6185H125.802L125.299 77.8847L124.814 77.7896L124.455 78.1699L124.383 77.5234L124.671 76.9149L124.814 75.774L124.742 74.557L124.635 73.9485L124.742 73.34L124.491 72.7696L123.988 72.2371L124.222 71.8378H128.118L127.957 70.0694L128.226 69.4419L129.16 69.3468L129.196 66.2093L132.428 66.2854L132.464 64.4219L136.145 67.3883Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M176.202 114.431H176.274L176.615 114.83L177.01 115.705L177.028 117.283L176.579 117.53L176.238 118.386L175.61 117.625L175.574 116.77L175.807 116.199L175.771 115.705L175.376 115.401L175.107 115.515L174.532 114.925L174.012 114.621L174.371 113.48L174.694 113.062L174.532 112.035L174.766 111.046L174.945 110.723L174.712 109.696L174.245 109.145L175.233 109.373L175.412 109.696L175.394 109.848L175.718 110.628L175.754 112.092L175.43 112.776L175.718 113.67L175.682 114.203L175.897 114.564L175.879 115.02L176.041 115.286L176.22 114.982L176.562 115.458L176.597 115.305L176.418 114.659L176.22 114.602L176.202 114.431Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M244.796 90.279L245.048 90.3931L245.676 91.1347L246.125 91.9524L246.233 92.77L246.143 93.3215L246.251 93.7398L246.34 94.4624L246.718 94.8047L247.131 95.8885V96.2879L246.412 96.3829L245.425 95.4702L244.204 94.5004L244.06 93.8729L243.449 93.0553L243.27 92.0475L242.875 91.3819L242.947 90.4882L242.695 89.9748L242.857 89.7656L243.719 90.298L243.827 90.9255L244.491 90.7734L244.796 90.279Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M260.92 92.8329L260.023 92.6237H258.855L258.55 94.0118L258.173 94.4302L257.706 96.1225L256.88 96.3888L255.911 96.0465L255.426 96.1606L254.833 96.7691L254.187 96.693L253.522 96.9402L252.822 96.2366L252.643 95.419L253.397 95.8373L254.169 95.6091L254.348 94.5823L254.779 94.3541L256 94.0879L256.683 93.1181L257.15 92.3575L257.652 92.985L257.85 92.5667L258.335 92.6047L258.353 91.8251L258.371 91.2166L259.107 90.3799L259.574 89.4292L259.987 89.4102L260.543 90.0377L260.615 90.5701L261.298 90.9124L262.159 91.2737L262.124 91.749L261.441 91.8061L261.639 92.4146L260.92 92.8329Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M164.333 119.25L165.159 118.984L165.805 119.041L166.2 119.327V119.422L165.626 119.707H165.32L164.656 120.182L164.297 119.669L162.735 120.106L161.98 120.144L161.837 124.499L160.849 124.537L160.741 128.093L160.544 132.599L159.646 133.227L159.125 133.322L158.515 133.094L158.066 132.998L157.922 132.485L157.563 132.143L157.06 132.751L156.36 131.82L156.001 130.945L155.821 129.747L155.606 128.872L155.319 126.99L155.337 125.525L155.229 124.86L154.852 124.347L154.349 123.339L153.846 121.875L153.649 121.114L152.859 119.916L152.805 118.984L153.29 118.756L153.9 118.547L154.546 118.585L155.139 119.136L155.283 119.041L159.359 119.003L160.041 119.574L162.465 119.745L164.333 119.25Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M155.787 69.9564L156.075 71.858L156.47 72.1812L156.488 72.5615L156.919 72.9799L156.703 73.5123L156.38 75.9843L156.344 77.5816L155.087 78.7225L154.674 80.3388L155.105 80.7951V81.5748L155.769 81.5938L155.662 82.1832L155.392 82.2403L155.356 82.6396L155.177 82.6586L154.477 81.3276L154.225 81.2705L153.453 81.9551L152.663 81.5938L152.124 81.5367L151.837 81.7079L151.244 81.6698L150.652 82.1832L150.131 82.2213L148.91 81.5938L148.425 81.879L147.904 81.86L147.527 81.4036L146.522 80.9472L145.426 81.0994L145.175 81.3466L145.031 82.0501L144.744 82.5445L144.672 83.6474L143.9 82.9438H143.541L143.2 83.3051L143.218 82.4685L142.051 82.1832L142.015 81.5938L141.458 80.7951L141.314 80.2437L141.404 79.6542L142.051 79.5972L142.41 79.1598L143.792 79.0647L144.69 78.8746L144.762 78.114L145.319 77.2963L145.301 74.4821L146.701 73.9496L149.574 71.5537L152.95 69.2148L154.53 69.7473L155.105 70.4128L155.787 69.9564Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M155.358 82.6377L155.771 83.1131L155.663 83.3412L155.609 83.7406L154.765 84.6913L154.514 85.4709L154.37 86.0984L154.155 86.3837L153.957 87.2394L153.418 87.7338L153.275 88.3422L153.041 88.8366L152.952 89.3501L152.251 89.7684L151.677 89.255L151.3 89.274L150.689 89.9966H150.402L149.917 91.1755L149.665 92.0502L148.606 92.4876L148.229 92.4305L147.834 92.6967L147.026 92.6777L146.469 91.8981L146.128 91.0234L145.41 90.2248H144.656H143.758L143.812 88.2662L143.776 87.4866L143.973 86.726L144.279 86.3456L144.781 85.585L144.674 85.2618L144.871 84.7674L144.638 84.0448L144.674 83.6455L144.745 82.5426L145.033 82.0482L145.176 81.3446L145.428 81.0974L146.523 80.9453L147.529 81.4017L147.906 81.858L148.426 81.8771L148.911 81.5918L150.132 82.2193L150.653 82.1813L151.246 81.6679L151.838 81.7059L152.125 81.5348L152.664 81.5918L153.454 81.9531L154.226 81.2686L154.478 81.3256L155.178 82.6567L155.358 82.6377Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M57.21 79.5542L57.1202 79.6873L57.0304 79.9535L57.1023 80.3908L56.8329 80.8092L56.6893 81.3036L56.5995 81.836L56.6354 82.1593L56.6174 82.7107L56.4558 82.8248L56.3301 83.3572L56.3661 83.6805L56.1506 83.9847L56.1685 84.308L56.3122 84.5172L56.0608 84.7834L55.7555 84.6883L55.6119 84.4411L55.2887 84.346L55.0552 84.4981L54.4088 84.1749L54.2472 84.327L53.924 83.9467L53.4751 83.4523L53.2775 83.053L52.8825 82.6537L52.4336 82.1022L52.5593 81.9121L52.7029 82.1022L52.7927 82.0262L53.1159 81.9691L53.2596 81.6839H53.4032L53.4392 81.0754L53.6726 81.0564H53.8881L54.1395 80.7331L54.4088 80.9803L54.5165 80.8282L54.732 80.6761L55.1091 80.3528L55.145 80.0866L55.2348 80.1056L55.3964 79.8204L55.5041 79.7824L55.6657 79.9725L55.8633 80.0105L56.0967 79.8584H56.3481L56.7072 79.7063L56.8688 79.5352L57.21 79.5542Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M163.884 15.2871L162.735 15.6865L162.16 15.7815L162.304 15.059L161.263 14.6596L160.203 15.0019L160.006 15.7625L159.395 16.2189L158.551 15.9717L157.6 16.0097L156.684 15.4773L156.289 15.7435L155.822 15.7815L155.84 16.4661L154.403 16.2949L154.296 16.8844H153.577L153.164 17.626L152.554 18.7859L151.53 20.2881L151.853 20.6685L151.62 21.0868L150.848 21.0678L150.417 22.0946L150.597 23.5588L151.153 24.1102L151.01 25.4223L150.399 26.1829L150.076 26.8294L149.483 26.1448L147.939 27.4379L146.844 27.7041L145.676 27.1336L145.353 25.9357L144.994 23.3686L145.712 22.6651L147.741 21.7333L149.196 20.6114L150.489 19.1282L152.087 17.0936L153.236 16.314L155.086 15.0209L156.612 14.5646L157.815 14.6216L158.749 13.7849L160.078 13.823L161.334 13.6328L163.795 14.3744L162.915 14.6406L163.884 15.2871Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M157.226 7.24727L155.861 7.60856L154.64 7.39939L155.035 7.17121L154.568 6.88598L155.879 6.71484L156.22 7.0381L157.226 7.24727Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M152.628 5.62507L154.89 6.27159L153.346 6.61386L153.131 7.26038L152.592 7.43152L152.43 8.19213L151.64 8.23016L150.114 7.67872L150.653 7.35546L149.629 7.08925L148.246 6.34765L147.672 5.68212L149.342 5.37787L149.755 5.6631H150.653L150.832 5.37787L151.766 5.33984L152.628 5.62507Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M157.007 5.05682L158.336 5.34205L157.546 5.79842L155.732 5.89349L153.811 5.74137L153.631 5.51319H152.715L151.943 5.13288L153.829 4.9047L154.798 5.09485L155.355 4.84766L157.007 5.05682Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M227.684 63.8529L227.72 64.3663L227.99 65.1459L227.972 65.6213L227.146 65.6403L225.907 65.3551L225.134 65.241L224.452 64.6325L223.069 64.4614L221.669 63.7768L220.627 63.1873L219.586 62.731L219.748 61.5901L220.25 61.0196L220.591 60.7344L221.453 61.1147L222.603 61.9133L223.195 62.0845L223.644 62.6739L224.452 62.9021L225.35 63.4536L226.517 63.7198L227.684 63.8529Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M194.43 77.5463L194.035 76.6906L193.102 74.675L196.028 73.458L196.495 71.0241L195.957 70.1494V69.655L196.19 69.1606L196.154 68.6662L196.585 68.419L196.388 68.2479V67.4492H196.89L197.429 68.2859L198.022 68.7232L198.758 68.8944L199.368 69.1035L199.889 69.8071L200.194 70.2064L200.553 70.3776L200.589 70.6438L200.284 71.3664L200.158 71.7086L199.763 72.108L199.458 72.9446L199.009 72.8686L198.83 73.1728L198.704 73.7813L198.901 74.599L198.812 74.7511H198.363L197.77 75.2074L197.716 75.7969L197.501 76.0631L196.872 76.0441L196.513 76.3484L196.549 76.8428L196.082 77.185L195.526 77.0709L194.879 77.4893L194.43 77.5463Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M196.654 66.4778L196.42 66.0595L196.672 65.6602L196.798 65.7552L196.762 66.2686L196.654 66.4778Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M215.584 54.5357L214.902 55.5625L213.878 55.7526L212.352 55.4484L211.993 55.9808L212.585 57.0457L213.106 57.8823L214.022 58.4718L213.34 59.1754L213.519 60.0501L212.819 61.2861L212.424 62.5221L211.616 63.7961L210.449 63.701L209.569 64.994L210.287 65.5265L210.538 66.4772L211.167 67.0857L211.49 68.1316H209.317L208.743 68.9492L207.989 68.645L207.594 67.7703L206.714 66.8385L204.918 67.0667L203.302 67.0857L201.937 67.2569L202.135 65.8497L203.482 65.2032L203.32 64.6518L202.835 64.4426L202.656 63.3778L201.632 62.8453L201.129 62.1037L200.555 61.4572L202.278 62.0847L203.23 61.8946L203.841 62.0467L204.002 61.7805L204.703 61.8946L205.888 61.3812L205.744 60.3543L206.157 59.6508H206.893L206.929 59.3275L207.647 59.1564L208.025 59.2705L208.348 58.9282L208.15 58.1866L208.402 57.464L208.958 57.1408L208.402 56.3421L209.335 56.3801L209.497 55.9428L209.353 55.4674L209.712 54.954L209.461 54.3455L209.12 53.8321L209.551 53.2997L210.503 53.0525L211.562 52.9004L211.993 52.6912L212.514 52.5391L213.358 53.1095L213.878 54.0603L215.584 54.5357Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M62.5383 87.3006L62.4126 87.4717L62.6101 88.1943L62.4126 88.5556L62.0894 88.4605L61.9278 89.05L61.6045 88.7077L61.425 88.0421L61.6764 87.7189L61.425 87.6428L61.2634 87.2435L60.7606 86.9012L60.3296 86.9773L60.0962 87.3956L59.6652 87.6999L59.4498 87.7379L59.342 88.0041L59.7909 88.6696L59.5036 88.8218L59.36 88.9929L58.8752 89.069L58.7315 88.3274L58.5879 88.5365L58.2646 88.4605L58.0851 87.9851L57.6721 87.89L57.4027 87.7569H56.9718L56.9359 88.0231L56.8281 87.833L56.882 87.5858L56.9897 87.3386L56.9538 87.1294L57.1154 86.9773L56.9179 86.8062L56.9359 86.3118L57.3309 86.1977L57.6721 86.635L57.6362 86.9012L58.0312 86.9583L58.1389 86.8442L58.4083 87.1484L58.9111 87.0534L59.36 86.7491L59.9885 86.5019L60.3476 86.1406L60.9042 86.2167L60.8683 86.3308L61.425 86.3688L61.8559 86.597L62.1791 86.9583L62.5383 87.3006Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M69.9342 103.121L69.0184 103.064L68.8747 103.254L68.0487 103.483L66.9175 104.319L66.8636 104.89L66.6122 105.308L66.7379 105.974L66.1274 106.316L66.1633 106.848L65.894 107.058L66.3608 108.16L66.9534 108.902L66.7738 109.434L67.4562 109.491L67.8692 110.157L68.767 110.176L69.5571 109.472L69.575 111.317L70.0419 111.45L70.6165 111.241L71.6041 113.218L71.4066 113.618V114.492L71.4604 115.519L71.1193 116.128L71.3348 116.584L71.1372 117.002L71.658 118.029L71.1372 119.341L70.9397 119.969L70.4369 120.273L69.3775 119.57L69.2338 119.075L67.133 117.858L65.2116 116.508L64.3677 115.767L63.8649 114.759L64.0085 114.397L63.0389 112.8L61.8897 110.556L60.8123 108.122L60.3813 107.552L60.0222 106.658L59.1962 105.86L58.46 105.365L58.7653 104.833L58.2266 103.654L58.5318 102.798L59.3219 102.037L59.4476 102.551L59.1603 102.836L59.2142 103.273L59.6272 103.178L60.0402 103.312L60.4891 103.939L61.0457 103.426L61.2073 102.608L61.8178 101.543L63.0209 101.068L64.1163 99.7747L64.4215 98.9951L64.2779 98.0633L64.5472 97.9492L65.2296 98.5197L65.5528 99.1091L66.0197 99.4134L66.6481 100.687L67.4023 100.859L67.9589 100.535L68.336 100.744L68.9465 100.63L69.7366 101.201L69.1082 102.456L69.4134 102.475L69.9342 103.121Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M269.257 87.6041L269.419 88.4217L269.526 89.1063L269.239 90.2091L268.79 88.9732L268.359 89.6007L268.736 90.4944L268.485 91.0648L267.246 90.3613L266.905 89.4676L267.174 88.8971L266.492 88.3076L266.205 88.821L265.738 88.764L265.019 89.4485L264.84 89.0872L265.163 88.0604L265.774 87.7181L266.294 87.2618L266.689 87.8132L267.444 87.49L267.569 86.9385L268.287 86.9005L268.144 85.9688L269.024 86.5392L269.149 87.1477L269.257 87.6041Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M266.633 85.3201L266.309 85.7194L266.058 86.499L265.771 86.8603L265.07 86.0236L265.25 85.6814L265.483 85.3391L265.519 84.5975L266.076 84.5214L265.986 85.3391L266.633 84.1602V85.3201Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M261.191 86.4944L259.916 87.6543L260.347 86.7986L261.029 86.038L261.568 85.2014L261.981 83.9844L262.268 84.9922L261.64 85.6577L261.191 86.4944Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M264.338 83.3594L264.984 83.7397H265.613L265.649 84.2341L265.236 84.7665L264.625 85.1278L264.535 84.5573L264.553 83.9298L264.338 83.3594Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M267.943 83.0144L268.374 84.3835L267.566 84.0603L267.62 84.4786L267.943 85.2202L267.476 85.5054L267.369 84.6307L267.045 84.5737L266.83 83.8321L267.423 83.9272L267.369 83.4708L266.65 82.5391L267.62 82.5581L267.943 83.0144Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M263.812 81.9168L263.65 82.9816L263.166 82.3732L262.537 81.4414L263.399 81.4794L263.812 81.9168Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M262.645 75.2773L263.327 75.6386L263.578 75.3154L263.722 75.6196L263.65 76.133L264.117 77.0077L264.009 78.0155L263.489 78.4149L263.471 79.4037L263.83 80.3734L264.368 80.5065L264.799 80.3734L266.146 81.039L266.128 81.7045L266.505 82.0087L266.451 82.5602L265.607 81.9707L265.158 81.3242L264.943 81.7806L264.225 81.039L263.327 81.2291L262.788 80.9629L262.77 80.4495L263.058 80.1452L262.716 79.86L262.645 80.2974L262.052 79.5938L261.819 79.0614L261.621 77.9014L262.088 78.3008L261.89 76.3802L262.034 75.2773H262.645Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M299.35 106.199L299.063 106.332L298.65 105.857L298.255 105.077L298.111 104.145L298.255 104.031L298.345 104.393L298.632 104.678L299.063 105.438L299.512 105.857L299.35 106.199Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M295.503 104.558L294.964 104.653L294.785 104.995L294.21 105.299L293.671 105.585H293.115L292.307 105.223L291.75 104.881L291.858 104.501L292.756 104.691L293.33 104.596L293.51 104.006L293.671 103.968L293.725 104.615L294.3 104.539L294.623 104.12L295.216 103.683L295.144 102.96L295.754 102.941L295.952 103.132L295.88 103.816L295.503 104.558Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M284.049 109.01L284.336 105.017L284.516 101.043L286.24 101.88L288.089 102.583L288.753 103.211L289.292 103.819L289.4 104.542L291.052 105.302L291.249 105.949L290.316 106.082L290.477 106.9L291.321 107.698L291.86 108.991L292.452 108.953L292.345 109.486L293.117 109.695L292.794 109.923L293.817 110.437L293.656 110.798L292.973 110.874L292.758 110.57L291.914 110.417L290.908 110.246L290.19 109.467L289.687 108.782L289.238 107.717L287.963 107.185L287.083 107.527L286.419 107.945L286.473 108.839L285.647 109.258L285.09 109.048L284.049 109.01Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M296.746 103.368L296.423 103.691L296.261 102.968L296.064 102.512L295.615 102.113L295.058 101.58L294.34 101.219L294.627 100.934L295.166 101.276L295.507 101.542L295.92 101.827L296.297 102.341L296.674 102.74L296.746 103.368Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M157.817 31.8855L158.877 32.0186L160.457 31.9996L160.906 32.1327L161.157 32.494L161.265 33.0074L161.57 33.4448L161.642 33.9012L161.139 34.1483L161.48 34.6808L161.57 35.2132L162.145 36.24L162.091 36.5633L161.678 36.6964L160.995 37.6852L161.283 38.2176L161.085 38.1416L160.187 37.6852L159.559 37.8563L159.128 37.7422L158.625 37.9894L158.14 37.5711L157.799 37.7422L157.745 37.6662L157.278 37.0767L156.614 37.0197L156.488 36.6393L155.878 36.5062L155.77 36.8105L155.267 36.5633L155.303 36.24L154.639 36.1449L154.19 35.7646L153.759 35.0231L153.795 34.6047L153.526 33.9772L153.184 33.5779L153.4 33.2546L153.148 32.6652L153.705 32.3229L154.98 31.7905L156.021 31.4102L156.883 31.6003L156.991 31.8855H157.817Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M262.036 46.164L262.287 46.3732L261.892 46.2971L261.712 46.7154L261.659 47.1147L262.161 47.9894L261.82 48.2557L261.766 48.4648L261.605 48.8261L261.084 49.0353L260.833 49.3585L261.066 49.872L261.012 50.0051L261.479 50.2142L262.269 50.7467V51.0319L261.91 51.1079L261.264 51.184L261.156 51.7164L260.707 51.6784V51.7925L260.132 51.5643L260.114 51.7925L259.881 51.8876L259.755 51.6594L259.45 51.5453L259.109 51.3551L259.127 50.8227L259.288 50.6706L259.109 50.4614L259.037 49.7959L258.875 49.6057L258.265 49.4726L257.654 49.1494L258.031 48.3698L258.732 47.7232L258.929 46.8485L259.576 47.2288L260.402 47.2859L259.899 46.6394L261.048 46.126V45.4414L262.036 46.164Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M82.8678 122.511L83.2269 123.177L83.2987 124.831L84.3581 125.078L84.7532 124.831L85.4535 125.173L85.669 125.535L85.8665 126.657L86.0101 127.113L86.3872 127.17L86.7463 126.98L87.1234 127.189L87.1773 127.873L87.1234 128.596L86.9977 129.3L86.9439 130.364L86.1717 131.315L85.4176 131.505L84.2863 131.315L83.2448 130.992L83.999 129.129L83.8015 128.596L82.7421 128.121L81.4312 127.208L80.6053 127.018L78.5762 125.04L78.8455 123.576L78.8096 122.911L79.1867 121.846L80.9105 121.484L81.8442 121.503L82.8139 122.131L82.8678 122.511Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M175.483 58.3201L175.555 59.0807L175.447 59.442L174.998 59.5941L175.016 59.2709L175.25 59.0997L174.98 58.9666L175.106 58.168L175.483 58.3201Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M191.971 67.8025L191.701 67.8976L191.378 67.6504L191.234 66.7567L191.432 66.1292L191.701 65.9961L192.024 66.3764L192.114 67.08L191.971 67.8025Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M164.819 39.1719L165.106 39.305L165.429 39.6473L165.788 40.1417L166.399 40.8642L166.506 41.3776L166.47 41.8911L166.704 42.4425L167.135 42.6707L167.548 42.4615L167.979 42.6707L168.051 42.9939L167.638 43.2411L167.35 43.127L167.279 44.5912L166.722 44.4581L166.004 44.0208L164.944 44.306L164.531 44.6102L163.167 44.5342L162.448 44.363L162.107 44.4391L161.784 43.9447L161.604 43.7355L161.784 43.5264L161.55 43.3933L161.281 43.6595L160.724 43.2982L160.599 42.8038L160.024 42.5376L159.88 42.1383L159.342 41.6819L160.042 41.4537L160.509 40.636L160.85 39.8374L161.371 39.5902L161.73 39.324L162.305 39.4571H162.879L163.328 39.7613L163.615 39.5712L164.262 39.4571L164.441 39.1719H164.819Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M171.981 99.2539L172.376 99.9385L172.323 100.661L172.035 100.813L171.479 100.737L171.173 101.441L170.545 101.346L170.653 100.661L170.796 100.566L170.832 99.8434L171.12 99.5011L171.371 99.6342L171.981 99.2539Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M132.5 64.1172L132.482 64.1933L132.464 64.4214L132.428 66.2849L129.196 66.2089L129.16 69.3464L128.226 69.4415L127.957 70.069L128.118 71.8374H124.222L123.988 72.2367L124.042 71.7233H124.06L126.305 71.6282L126.43 71.1909L126.861 70.6394L127.22 68.9471L128.639 67.635L129.124 66.0948L129.447 65.9997L129.788 65.0489L130.614 64.9158L130.973 65.087H131.422L131.745 64.8017L132.356 64.7637L132.338 64.1172H132.5Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M186.656 62.3515L187.554 62.4656L187.859 63.055L188.559 63.017L189.044 64.0819L189.565 64.3481L189.781 64.7854L190.499 65.2988L190.624 65.7932L190.553 66.2116L190.714 66.6109L191.037 66.9532L191.199 67.3525L191.379 67.6567L191.702 67.9039L191.971 67.8088L192.205 68.2842L192.259 68.5504L192.743 69.8054L195.778 70.4139L195.958 70.1477L196.496 71.0224L196.029 73.4564L193.102 74.6733L190.247 75.1487L189.35 75.7002L188.721 76.9742L188.254 77.1834L187.985 76.784L187.608 76.8411L186.62 76.708L186.423 76.5939L185.273 76.6129L185.004 76.727L184.573 76.4228L184.34 77.0122L184.483 77.5256L184.052 77.925L183.891 77.3925L183.568 77.0312L183.478 76.5368L182.921 76.0995L182.329 75.0727L181.987 74.0839L181.251 73.2472L180.802 73.038L180.066 71.8781L179.905 71.0414V70.3189L179.258 68.9498L178.755 68.4744L178.217 68.2272L177.84 67.5236L177.875 67.2574L177.552 66.6109L177.247 66.3447L176.798 65.4319L176.116 64.4622L175.559 63.6255H175.074L175.164 62.96L175.182 62.5226L175.254 62.0282L176.367 62.2374L176.744 61.8571L176.942 61.4197L177.678 61.2486L177.804 60.8303L178.091 60.6401L177.014 59.4041L178.881 58.7956L179.043 58.6055L180.264 58.9477L181.808 59.8034L184.825 62.2564L186.656 62.3515Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M177.764 80.2609L177.638 81.3068L177.279 82.5238L176.686 83.1132L176.273 84.064L176.184 84.5584L175.717 84.9007L175.447 86.1747V86.3268L175.304 86.2888L175.322 85.6803L175.178 85.2619L174.657 84.7866L174.496 83.9119L174.604 82.9991L174.137 82.9231L174.065 83.1893L173.454 83.2653L173.724 83.6076L173.813 84.3492L173.275 85.0147L172.79 85.8894L172.269 86.0226L171.407 85.319L171.03 85.5662L170.94 85.9085L170.42 86.1557L170.384 86.4029H169.378L169.235 86.1557L168.498 86.0986L168.139 86.3078L167.852 86.2127L167.331 85.4901L167.152 85.1669L166.415 85.338L166.146 85.8894L165.913 86.9923L165.553 87.2205L165.248 87.3536L165.158 87.2966L164.817 86.9353L164.745 86.555L164.889 86.0606V85.5472L164.297 84.7866L164.171 84.2732V83.9689L163.794 83.6076L163.776 82.9041L163.542 82.4287L163.201 82.5047L163.291 82.0484L163.542 81.554L163.417 81.0406L163.74 80.6603L163.524 80.375L163.758 79.6334L164.207 78.7207L165.069 78.8158L164.871 73.9669V73.4535H166.02L165.931 71.0195H169.935H173.795H177.764L178.141 72.2175L177.925 72.4267L178.141 73.7007L178.59 75.1458L178.985 75.4501L179.559 75.9064L179.075 76.591L178.356 76.8002L178.051 77.1805L177.997 77.9791L177.638 79.7856L177.764 80.2609Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M175.449 86.3295L175.485 87.2803L175.342 87.6416L174.803 87.6796L174.462 88.3641L175.09 88.4592L175.629 89.0487L175.808 89.5431L176.275 89.8283L176.904 91.1594L176.221 91.958L175.611 92.6806L174.982 93.2511H174.264L173.456 93.5363L172.81 93.2511L172.397 93.5933L171.481 92.7757L171.229 92.2623L170.673 92.5095L170.206 92.4334L169.937 92.6426L169.47 92.4904L168.841 91.4826L168.68 91.1023L167.908 90.6079L167.656 89.8854L167.225 89.3529L166.525 88.7254L166.507 88.3261L165.95 87.8317L165.25 87.3563L165.555 87.2232L165.914 86.995L166.148 85.8922L166.417 85.3407L167.153 85.1696L167.333 85.4928L167.854 86.2154L168.141 86.3105L168.5 86.1013L169.236 86.1584L169.38 86.4056H170.386L170.421 86.1584L170.942 85.9112L171.032 85.5689L171.409 85.3217L172.271 86.0253L172.792 85.8922L173.277 85.0175L173.815 84.3519L173.725 83.6103L173.456 83.2681L174.067 83.192L174.138 82.9258L174.605 83.0018L174.498 83.9146L174.659 84.7893L175.18 85.2647L175.324 85.683L175.306 86.2915L175.449 86.3295Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M128.747 80.036L128.783 80.7966L128.98 81.5002L129.339 81.8425L129.429 82.2988L129.375 82.6791L129.231 82.7552L128.675 82.6601L128.603 82.7932L128.387 82.8123L127.651 82.527L127.166 82.508L125.299 82.451L125.03 82.6031L124.688 82.5651L124.15 82.7552L124.006 81.8235L124.922 81.8425L125.173 81.6713H125.353L125.73 81.3861L126.161 81.6333L126.592 81.6713L127.041 81.3861L126.843 81.0438L126.502 81.234H126.197L125.802 80.9297L125.479 80.9488L125.245 81.253L124.15 81.272L123.737 80.3213L123.252 79.9029L123.701 79.6557L124.204 78.8L124.455 78.1725L124.814 77.7922L125.299 77.8873L125.802 77.6211H126.358L126.843 77.9634L127.49 78.2866L128.1 79.1994L128.747 80.036Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M130.633 87.6133L130.166 88.1837L129.699 88.8302L129.645 89.1915L129.394 89.5909L129.124 89.4958L128.406 89.0014L127.867 88.3549L127.706 87.8985L127.58 87.0048L128.137 86.4533L128.244 86.1301L128.424 85.8639L128.711 85.8258L128.945 85.5977H129.753L130.04 86.035L130.256 86.5484L130.22 86.9097L130.381 87.233L130.363 87.6703L130.633 87.6133Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M52.3371 81.5357L52.2114 81.821L51.6189 81.8019L51.2597 81.6879L50.8647 81.4407L50.326 81.3646L50.0566 81.0984L50.1105 80.9273L50.4696 80.623L50.6851 80.4899L50.6312 80.3378L50.8826 80.2617L51.1699 80.3758L51.3675 80.604L51.6548 80.8132L51.6727 80.9653L52.1216 80.8322L52.3371 80.9082L52.4628 81.0413L52.3371 81.5357Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M161.785 43.9331L161.587 44.1994L161.713 44.6557L162.216 45.1691L161.892 45.5494L161.785 45.9297L161.892 46.0819L161.767 46.234L161.336 46.272L161.03 46.3291L160.977 46.234L161.084 46.1009L161.156 45.7966L161.03 45.8157L160.833 45.5875L160.671 45.5304L160.528 45.3403L160.348 45.2642L160.204 45.0931L160.043 45.1691L159.953 45.5685L159.738 45.6445L159.809 45.5494L159.432 45.3022L159.127 45.1691L158.965 44.998L158.714 44.7888L158.912 44.7318L159.001 44.1803L158.517 43.705L158.714 43.1725L158.373 43.1915L158.678 42.7352L158.373 42.3929L158.104 41.9175L158.768 41.6133L159.343 41.6703L159.881 42.1267L160.025 42.526L160.599 42.7922L160.725 43.2866L161.282 43.6479L161.551 43.3817L161.785 43.5148L161.605 43.724L161.785 43.9331Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M86.1862 90.854L85.6295 91.8998L85.6834 92.7365L86.0784 93.4591L85.8809 93.9725L85.7911 94.5429L85.5218 95.0564L84.9472 94.7901L84.4624 94.9233L84.0494 94.8092L83.9416 95.1705L84.1212 95.3986L84.0135 95.6649L83.4568 95.5508L82.8642 94.4859L82.7385 93.8014H82.4153L81.9844 92.9267L82.1819 92.2801L82.128 91.9949L82.7565 91.6907L82.9361 90.5878L84.1571 90.835L84.2648 90.6068L85.0908 90.5117L86.1862 90.854Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M161.082 38.1447L160.866 38.4679L160.741 38.9433L160.561 39.0574L159.573 38.6961L159.286 38.7722L159.107 39.0574L158.694 39.2095L158.586 39.1335L158.173 39.3046L157.832 39.3426L157.778 39.5898L157.042 39.7229L156.7 39.6088L156.216 39.2856L156.09 38.8863L156.144 38.7341L156.251 38.4679L156.646 38.487L156.934 38.3729L156.952 38.2588L157.113 38.2017L157.149 37.9355L157.347 37.8785L157.472 37.6693H157.742L157.796 37.7454L158.137 37.5742L158.622 37.9926L159.124 37.7454L159.555 37.8594L160.184 37.6883L161.082 38.1447Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M156.003 41.2269L155.303 41.5502L155.249 42.0256L154.944 42.1587L154.962 42.4819L154.603 42.4629L154.279 42.2728L154.136 42.4629L153.489 42.4249L153.687 42.3298L153.436 41.8164L153.507 41.2269L154.262 41.322L154.692 41.0368L155.483 41.0178L155.644 40.8086L155.788 40.8276L156.003 41.2269Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M159.31 18.9977L158.053 19.3019L157.424 20.0435L157.658 20.7091L156.544 21.5648L155.144 22.5155L154.767 24.0558L155.431 24.8354L156.293 25.4629L155.7 26.7179L154.874 26.9841L154.767 28.8856L154.39 29.9695L153.366 29.8554L152.971 30.7681L151.983 30.8252L151.642 29.7413L150.834 28.4293L150.08 26.832L150.403 26.1855L151.014 25.4249L151.157 24.1128L150.601 23.5614L150.421 22.0972L150.852 21.0704L151.624 21.0894L151.858 20.671L151.535 20.2907L152.558 18.7885L153.169 17.6286L153.582 16.887H154.3L154.408 16.2975L155.844 16.4687L155.826 15.7841L156.293 15.7461L157.37 16.2595L158.663 16.9631L158.986 18.5794L159.31 18.9977Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M172.504 129.412L172.612 129.964L172.666 130.515L172.414 131.048L171.84 131.181L171.283 130.515L171.301 130.097L171.606 129.64L171.714 129.279L172.019 129.203L172.504 129.412Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M178.481 57.1225L176.739 58.4346L175.608 57.9402H175.59L175.697 57.75L175.626 57.2557L175.787 56.5901L176.272 56.1147L176.057 55.6394L175.608 55.5823L175.41 54.6506L175.59 54.1372L175.823 53.8709L176.039 53.6047L176.003 52.9392L176.344 53.1674L177.349 52.8251L177.888 53.0533H178.678L179.702 52.5969L180.222 52.6159L181.282 52.4258L180.905 53.1864L180.42 53.4906L180.635 54.3844L180.456 55.8485L178.481 57.1225Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M164.875 73.9668L165.073 78.8157L164.211 78.7206L163.762 79.6334L163.528 80.3749L163.744 80.6602L163.421 81.0405L163.546 81.5539L163.295 82.0483L163.205 82.5047L163.546 82.4286L163.78 82.904L163.798 83.6075L164.175 83.9688V84.2731L163.528 84.4822L163.026 84.9766L162.307 86.3077L161.374 86.8782L160.386 86.8021L160.099 86.9162L160.206 87.3345L159.686 87.7719L159.255 88.2473L157.98 88.7036L157.728 88.4374L157.549 88.3994L157.369 88.7226L156.543 88.8177L156.687 88.4754L156.364 87.6388L156.22 87.1444L155.771 86.9352L155.161 86.2126L155.376 85.6422L155.843 85.7563L156.13 85.6802H156.705L156.13 84.5773L156.166 83.7597L156.076 82.961L155.663 82.1814L155.771 81.5919L155.107 81.5729V80.7933L154.676 80.3369L155.089 78.7206L156.346 77.5797L156.382 75.9824L156.705 73.5104L156.92 72.978L156.489 72.5597L156.471 72.1794L156.076 71.8561L155.789 69.9546L156.777 69.2891L160.817 71.6279L164.875 73.9668Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M141.926 84.4409L141.801 85.0874L142.106 85.4487L142.465 85.867L142.501 86.4755L142.716 86.7227L142.663 89.537L142.914 90.3736L142.106 90.6399L141.872 90.2025L141.603 89.4229L141.513 88.8144L141.747 87.7305L141.495 87.2742L141.388 86.3234V85.4297L140.975 84.8022L141.046 84.4219L141.926 84.4409Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M247.168 80.4563L246.216 80.2852L244.941 80.5134L244.384 81.5212L244.761 83.0044L243.81 82.4339L242.948 82.4719L243.002 81.5022H242.122L242.158 82.8522L241.763 84.6397L241.511 85.7236L241.637 86.5983L242.301 86.6363L242.786 87.7582L243.02 88.804L243.63 89.5076L244.241 89.6407L244.797 90.2872L244.492 90.7816L243.828 90.9337L243.72 90.3062L242.858 89.7738L242.696 89.983L242.283 89.5266L242.068 88.9181L241.493 88.2336L240.973 87.6441L240.847 88.3667L240.614 87.6821L240.685 86.9215L240.901 85.7616L241.296 84.5066L241.763 83.3657L241.278 82.2438L241.242 81.6733L241.062 80.9888L240.29 80.019L239.967 79.4105L240.29 79.1823L240.542 78.1365L240.021 77.3188L239.285 76.4251L238.656 75.3602L239.051 75.1321L239.321 73.82L240.021 73.763L240.524 73.2305L241.062 72.9453L241.547 73.3256L241.709 74.0672L242.391 74.1243L242.319 75.3983L242.499 76.5012L243.451 75.7786L243.792 75.9878L244.366 75.9497L244.51 75.5314L245.282 75.6074L246.18 76.5962L246.413 77.8132L247.365 78.8781L247.437 79.9049L247.168 80.4563Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M207.573 48.7692L207.322 49.1305L206.244 48.9404L206.352 49.6249L207.339 49.5298L208.614 49.9292L210.338 49.739L210.895 50.8799L211.164 50.7468L211.829 51.032L211.918 51.5074L212.242 52.192H211.272L210.59 52.0969L210.141 52.6483L209.746 52.7624L209.476 53.0286L208.991 52.6293L208.83 51.6025L208.525 51.5455L208.543 51.1652L207.95 50.8989L207.645 51.3173L207.681 51.8117L207.573 51.9828L206.998 51.9638L206.837 52.5152L206.46 52.2871L205.849 52.6674L205.526 52.5342L205.759 51.2983L205.328 50.3855L204.574 50.1003L204.682 49.5679L205.472 49.6249L205.741 48.9594L205.831 48.1798L206.998 47.8945L206.962 48.465L207.196 48.7882L207.573 48.7692Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M204.217 52.2678L203.93 52.2298L203.409 51.9065L203.356 52.3248L202.601 52.5721L202.637 53.5418L202.17 53.9221L201.452 54.0933L201.38 54.6447L200.68 54.8158L199.621 54.3405L199.315 53.3327L198.597 53.2756L197.286 52.2108L196.514 52.0777L195.329 51.4502L194.629 51.3361L194.27 51.5642L193.623 51.5262L193.084 52.2298L192.294 52.458L191.953 51.6023L191.845 50.3283L191.019 49.9099L191.091 49.0923L190.463 49.0162L190.445 47.9894L191.397 48.2936L192.133 47.9133L191.289 47.1717L190.858 46.4872L190.176 46.7914L190.283 47.6851L189.816 46.9055L190.14 46.4872L191.145 46.24L191.845 46.5822L192.707 47.533L193.174 47.476L194.234 47.4569L193.928 46.8485L194.611 46.4301L195.221 45.7266L196.64 46.3731L196.981 47.3238L197.394 47.571L198.382 47.514L198.759 47.7422L199.531 48.9972L200.806 49.8339L201.56 50.4043L202.691 50.9938L204.074 51.5262L204.217 52.2678Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M267.851 109.334L267.869 108.973L267.779 108.725L267.923 108.44L268.803 108.174L269.521 108.117L269.844 107.965L270.221 108.117L269.826 108.459L268.731 108.992L267.851 109.334Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M152.124 57.4232L152.106 58.3549L151.639 58.6972L151.352 59.0965L150.706 59.5719L150.813 60.0663L150.742 60.5987L150.275 60.8649L149.808 58.6782L149.197 58.1838L149.179 57.8986L148.371 57.157L148.264 56.2442L148.838 55.5597L149.036 54.5519L148.856 53.3919L149.036 52.7644L150.059 52.2891L150.724 52.4222V53.0497L151.514 52.5933L151.586 52.8215L151.137 53.43L151.155 53.9814L151.496 54.2857L151.406 55.3505L150.778 55.959L150.993 56.6245L151.496 56.6436L151.747 57.233L152.124 57.4232Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M179.688 47.1905L180.676 47.1335L181.682 47.742L181.915 48.1603L181.933 48.7498L182.687 49.054L183.118 49.3963L182.526 49.7576L183.046 51.1457L182.921 51.526L183.603 52.4958L183.172 52.7049L182.795 52.4007L181.664 52.2296L181.287 52.4197L180.227 52.6099L179.706 52.5908L178.683 53.0472H177.893L177.354 52.819L176.349 53.1613L176.007 52.9331L176.043 53.5987L175.828 53.8649L175.594 54.1311L175.181 53.5796L175.487 53.1233L174.912 53.2374L174.086 52.9521L173.511 53.6557L172.075 53.7888L171.231 53.1423L170.207 53.1043L170.028 53.5987L169.381 53.7508L168.412 53.1043L167.37 53.1233L166.688 51.9063L165.934 51.2408L166.293 50.29L165.646 49.7005L166.562 48.5406L167.999 48.5026L168.286 47.5708L170.082 47.742L171.087 46.9623L172.129 46.6201L173.655 46.582L175.415 47.4377L176.833 47.9131L177.875 47.7229L178.701 47.837L179.688 47.1905Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M165.357 48.066L165.572 47.9329L165.77 47.1723L165.285 46.8491L166.183 46.4688L167.009 46.6209L167.171 47.0963L168.032 47.4766L167.907 47.7808L166.793 47.8378L166.434 48.2182L165.734 48.8647L165.375 48.3132L165.357 48.066Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M261.602 70.0497L261.351 71.0575L260.633 70.0117L260.363 69.118L260.704 67.92L261.297 66.9883L261.836 67.3496L261.818 68.0912L261.602 70.0497Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M173.453 99.1284L173.418 99.87L173.22 100.726L173.507 101.201L173.956 100.916L174.549 100.84L174.675 100.992L175.267 100.688L174.854 100.269L175.195 99.7179L175.698 99.1664L179.379 101.657L179.433 102.361L180.887 103.578L180.385 105.099L180.439 105.784L181.067 106.221L181.103 106.544L180.798 107.286L180.852 107.647L180.78 108.237L181.103 108.997L181.498 110.214L181.857 110.48L181.031 111.184L179.918 111.659L179.307 111.64L178.93 112.002L178.23 112.04L177.961 112.192L176.757 111.85L176.362 111.888L176.38 111.869L176.057 111.412L176.003 110.119L175.483 109.473L175.411 109.701L175.231 109.378L174.244 109.149L173.669 108.788L173.023 108.579L172.627 108.37L172.574 108.332L172.089 107.077L172.017 106.335L171.209 105.499L171.46 105.042L171.263 104.548L171.299 104.034L171.119 103.863L171.173 103.331L171.281 103.312L171.64 102.874L172.053 102.228L172.304 101.981V101.581L172.089 101.296L172.035 100.821L172.322 100.669L172.376 99.9461L171.981 99.2615L172.34 99.1094L173.453 99.1284Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M175.608 92.6758L176.093 93.5315L176.219 94.14L176.686 95.5471L176.309 96.4408L175.806 97.2394L175.518 97.7338V97.7909L175.483 97.7148L174.944 97.4676L174.513 97.7719L173.866 97.943L173.4 98.6466L173.453 99.1219L172.34 99.1029L171.981 99.2551L171.371 99.6354L171.119 99.5023L171.137 98.5895L171.371 98.1141L171.424 97.1444L171.64 96.5739L172.035 95.9464L172.412 95.6041L172.753 95.1858L172.34 95.0147L172.394 93.5885L172.807 93.2462L173.453 93.5315L174.262 93.2462H174.98L175.608 92.6758Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M171.698 35.6514L172.111 36.1648L172.129 36.393L173.332 36.8113L173.978 36.6212L174.624 37.1726L175.145 37.1536L176.528 37.5339L176.6 37.8952L176.366 38.5037L176.689 39.1692L176.636 39.5685L175.774 39.6446L175.379 39.9869L175.45 40.5003L174.75 40.5953L174.211 40.9947L173.385 41.0517L172.667 41.5081L172.847 42.2497L173.35 42.5349L174.265 42.4588L174.158 42.8962L173.188 43.1054L172.057 43.7899L171.5 43.5427L171.626 42.9913L170.566 42.63L170.692 42.4018L171.518 42.0025L171.213 41.7363L169.758 41.432L169.615 40.9756L168.807 41.1278L168.573 41.7933L167.981 42.668L167.55 42.4588L167.137 42.668L166.706 42.4398L166.921 42.3067L167.029 41.9074L167.226 41.5081L167.119 41.2989L167.298 41.2038L167.406 41.375L167.945 41.413L168.178 41.3179L167.999 41.2038L168.034 41.0137L167.675 40.7094L167.478 40.215L167.119 40.0249L167.137 39.6256L166.67 39.3023L166.311 39.2453L165.592 38.884L165.018 38.9981L164.82 39.1692H164.443L164.264 39.4544L163.617 39.5685L163.33 39.7587L162.881 39.4544H162.306L161.732 39.3213L161.373 39.5875L161.283 39.2643L160.744 38.941L160.87 38.4656L161.085 38.1424L161.283 38.2184L160.996 37.686L161.678 36.6972L162.091 36.5641L162.145 36.2409L161.57 35.214L161.983 35.157L162.414 34.8527L163.096 34.8147L163.976 34.9098L165 35.195L165.7 35.214L166.041 35.3852L166.347 35.176L166.616 35.4612L167.388 35.4042L167.765 35.5183L167.711 34.9288L167.945 34.6626L168.681 34.6055L169.004 34.6436L169.184 34.3774L169.453 34.4344L170.333 34.3203L171.015 34.9858L170.854 35.233L170.997 35.5943L171.698 35.6514Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M89.5462 139.101L89.2589 139.881L88.2892 140.547L87.5351 140.299L87.0323 140.432L86.0447 139.919L85.3983 139.957L84.698 139.273L84.6261 138.493L84.7877 138.227L84.5723 137.01L84.6441 135.755L84.7339 134.766L85.3444 134.633L86.4756 135.584L86.8168 135.546L87.9481 136.325L88.81 137.01L89.4923 137.827L89.1691 138.417L89.5462 139.101Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M206.801 46.3174L207.106 46.4315L206.567 47.2111L207.393 47.6675L207.968 47.3633L209.261 48.0098L208.309 48.8845L207.573 48.7704L207.196 48.7894L206.962 48.4661L206.998 47.8957L205.831 48.1809L205.741 48.9605L205.472 49.6261L204.682 49.569L204.574 50.1015L205.328 50.3867L205.759 51.2994L205.526 52.5354L204.754 52.2692H204.215L204.071 51.5276L202.689 50.9952L201.558 50.4057L200.803 49.8352L199.528 48.9986L198.756 47.7436L198.379 47.5154L197.392 47.5724L196.979 47.3252L196.637 46.3745L195.219 45.7279L194.608 46.4315L193.926 46.8498L194.231 47.4583L193.172 47.4774L192.059 43.0278L194.213 42.3242L194.411 42.4193L196.063 43.275L196.925 43.7313L198.11 44.8152L199.133 44.6441L200.678 44.549L202.042 45.4237L202.312 46.6407L202.779 46.6597L203.228 47.6485L204.431 47.6865L204.844 48.257H205.203L205.364 47.3823L206.334 46.5456L206.801 46.3174Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M80.3867 87.6553L79.5427 88.3779L79.4529 88.8153L79.7762 89.2716L79.5248 89.4998L78.8963 89.69V90.2604L78.609 90.6027L79.2734 91.5154L79.3991 91.8577L79.022 92.3331L77.8728 92.7895L77.1366 92.9796L76.8313 93.2648L76.0233 92.9606L75.2871 92.8085L75.0895 92.9226L75.5384 93.2268L75.4846 94.0445L75.6103 94.8241L76.4722 94.9192L76.526 95.1854L75.7898 95.5277L75.6641 96.0411L75.2332 96.2502L74.479 96.5355L74.2815 96.9158L73.4914 96.9918L72.9348 96.3453L72.6475 95.1283L72.3781 94.691L72.019 94.4248L72.5397 93.8163L72.5038 93.5501L72.2345 93.1888L72.0369 92.3711L72.1447 91.4964L72.3781 91.0781L72.5936 90.4316L72.2345 90.2224L71.6599 90.3555L70.9236 90.2985L70.5106 90.4316L69.8283 89.3667L69.2357 89.2146L67.9249 89.3287L67.7094 88.9103L67.4581 88.8153L67.4401 88.5491L67.5658 88.0927L67.5119 87.6173L67.2964 87.3321L67.1887 86.7806L66.668 86.7046L66.9912 85.982L67.1528 85.1073L67.476 84.6509L67.889 84.3087L68.1763 83.7002L68.8407 83.491L68.8048 83.7762L68.1943 83.9284L68.4995 84.4798L68.4457 85.1263L67.9608 85.8299L68.302 86.7997L68.7509 86.7236L69.0203 85.8299L68.715 85.4115V84.4798L70.0079 83.9854L69.9001 83.4149L70.2772 83.0156L70.5825 83.8903L71.3007 83.9093L71.9112 84.5749L71.9472 84.9932H72.845L73.9403 84.8791L74.497 85.4115L75.2511 85.5637L75.8437 85.1834L75.8617 84.8791L77.1366 84.8031L78.3396 84.784L77.4598 85.1453L77.783 85.7348L78.591 85.8109L79.3452 86.4194L79.4709 87.3891L79.9916 87.3701L80.3867 87.6553Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M248.779 71.5691L247.612 72.5959L246.948 73.7558L246.84 74.6115L247.792 75.8855L248.959 77.4828L249.983 78.2434L250.719 79.2132L251.437 81.476L251.509 83.6247L250.737 84.4234L249.641 85.222L248.887 86.2298L247.702 87.3707L247.289 86.5911L247.505 85.7544L246.714 85.0699L247.54 84.5755L248.6 84.4804L248.097 83.7578L249.713 82.8071L249.695 81.3429L249.372 80.5252L249.408 79.3083L249.049 78.4526L248.169 77.5969L247.379 76.532L246.355 75.0869L245.045 74.3453L245.26 73.9079L245.853 73.5847L245.314 72.5198H244.093L243.464 71.4169L242.746 70.4472L243.231 70.1429L244.021 70.1619L244.973 70.0098L245.709 69.3633L246.266 69.8196L247.217 70.0478L247.163 70.7514L247.72 71.2458L248.779 71.5691Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M194.428 77.5432L193.71 77.8664L193.548 78.4179V78.8362L192.578 79.3496L190.998 79.9201L190.154 80.7758L189.705 80.8518L189.4 80.7758L188.826 81.2892L188.197 81.5174L187.353 81.5744L187.102 81.6505L186.904 81.9737L186.635 82.0688L186.491 82.373L185.988 82.335L185.683 82.5062L184.965 82.4491L184.678 81.7265V81.061L184.498 80.6997L184.265 79.806L183.941 79.3116L184.139 79.2355L184.013 78.6841L184.121 78.4559L184.049 77.9235L184.48 77.5242L184.336 77.0108L184.57 76.4213L185.001 76.7255L185.27 76.6114L186.419 76.5924L186.617 76.7065L187.605 76.8396L187.982 76.7826L188.251 77.1819L188.718 76.9727L189.346 75.6987L190.244 75.1473L193.099 74.6719L194.033 76.6875L194.428 77.5432Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M172.576 108.329L172.63 108.367L173.025 108.576L173.671 108.785L174.246 109.147L174.713 109.698L174.946 110.725L174.767 111.048L174.533 112.037L174.695 113.064L174.372 113.482L174.012 114.623L174.533 114.927L171.445 115.935L171.516 116.81L170.744 116.981L170.152 117.456L170.008 117.875L169.649 117.989L168.733 118.978L168.159 119.776L167.817 119.795L167.494 119.662L166.381 119.529L166.201 119.434V119.339L165.806 119.054L165.16 118.997L164.334 119.263L163.687 118.502L163.041 117.513L163.185 113.615L165.286 113.634L165.214 113.216L165.375 112.76L165.214 112.189L165.339 111.6L165.232 111.219L165.573 111.238L165.627 111.619L166.112 111.6L166.74 111.714L167.081 112.265L167.871 112.436L168.5 112.056L168.715 112.683L169.487 112.855L169.847 113.387L170.242 114.053H171.014L170.978 112.741L170.69 112.969L169.99 112.493L169.721 112.265L169.882 111.048L170.08 109.603L169.864 109.071L170.17 108.291L170.439 108.139L171.822 107.93L171.983 107.987L171.929 108.253L172.271 108.348L172.486 108.595L172.666 108.538L172.576 108.329Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M172.093 125.046L171.572 124.913L171.231 125.065L170.746 124.856H170.351L169.741 124.304L168.969 124.114L168.699 123.335L168.717 122.897L168.304 122.764L167.209 121.433L166.922 120.73L166.724 120.501L166.383 119.532L167.496 119.665L167.819 119.798L168.161 119.779L168.735 118.98L169.651 117.991L170.01 117.877L170.154 117.459L170.746 116.984L171.518 116.812L171.554 117.269L172.398 117.25L172.865 117.497L173.063 117.801L173.547 117.896L174.05 118.277L173.978 119.836L173.745 120.673L173.673 121.585L173.817 121.947L173.655 122.669L173.512 122.783L173.206 123.658L172.093 125.046Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M183.351 99.9248L182.759 98.917L182.723 94.4674L183.603 93.0983L183.872 92.699L184.518 92.68L185.416 91.8243L186.727 91.7673L189.528 88.0973L188.666 88.1164L185.308 86.6712L184.913 86.2338L184.518 85.6444L184.123 84.9598L184.339 84.5415L184.68 83.876L185.021 84.1041L185.237 84.6175L185.721 85.131H186.224L187.158 84.8077L188.253 84.6746L189.133 84.2943L189.636 84.2182L189.995 83.99L190.57 83.952L190.893 83.914L191.342 83.7428L191.88 83.6097L192.329 83.1914H192.724L192.76 83.5337L192.688 84.2372L192.724 84.8838L192.527 85.3211L192.275 86.6522L191.845 88.0023L191.252 89.5615L190.426 91.3489L189.582 92.718L188.397 94.3914L187.391 95.3802L185.883 96.5972L184.931 97.5099L183.818 98.9931L183.585 99.6396L183.351 99.9248Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M161.028 46.3336L160.813 46.3907L160.292 46.5808L160.274 46.828L160.148 46.809L160.041 46.3717L159.807 46.2386L159.592 45.9153L159.735 45.6491L159.951 45.573L160.041 45.1737L160.202 45.0977L160.346 45.2688L160.526 45.3449L160.669 45.535L160.831 45.5921L161.028 45.8202L161.154 45.8012L161.082 46.1055L160.974 46.2386L161.028 46.3336Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M172.092 125.038L172.487 126.749L172.685 127.624L172.433 128.974L172.505 129.411L172.02 129.202L171.715 129.278L171.607 129.639L171.302 130.096L171.284 130.514L171.841 131.18L172.415 131.047L172.667 130.514H173.403L173.098 131.408L172.918 132.416L172.613 132.967L171.895 133.595L171.697 133.766L171.23 134.393L170.907 135.021L170.278 135.896L169.075 137.151L168.339 137.873L167.567 138.444L166.508 138.9L166.023 138.976L165.861 139.318L165.287 139.128L164.802 139.356L163.778 139.128L163.186 139.28L162.791 139.204L161.749 139.699L160.923 139.889L160.295 140.345L159.864 140.383L159.487 139.946L159.163 139.927L158.768 139.375L158.715 139.546L158.607 139.223L158.661 138.501L158.391 137.683L158.715 137.455L158.732 136.523L158.14 135.382L157.709 134.355V134.336L157.062 132.758L157.565 132.15L157.924 132.492L158.068 133.005L158.517 133.1L159.127 133.328L159.648 133.233L160.546 132.606L160.744 128.099L160.995 128.289L161.534 129.449L161.426 130.191L161.623 130.628L162.342 130.495L162.844 129.944L163.329 129.582L163.599 128.993L164.101 128.727L164.514 128.86L164.963 129.202L165.771 129.259L166.418 128.993L166.526 128.613L166.741 128.023L167.28 127.928L167.603 127.472L167.962 126.654L168.896 125.741L170.35 124.848H170.745L171.23 125.057L171.571 124.905L172.092 125.038ZM168.447 135.154L168.644 134.774L169.201 134.583L169.399 134.184L169.74 133.595L169.434 133.214L169.039 132.834L168.555 133.1L167.998 133.576L167.423 134.336L168.088 135.287L168.447 135.154Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M302.601 147.806L302.457 148.301L303.462 147.806L303.373 148.32L302.996 148.833L302.241 149.385L300.966 150.278L300.123 150.773L300.015 151.343L299.297 151.362L298.165 151.819L297.321 152.598L295.849 153.815L294.718 154.348L293.999 154.69L293.173 154.671L292.904 154.272L291.988 154.196L292.168 153.739L293.335 152.864L295.382 151.666L296.154 151.438L297.16 150.982L298.417 150.354L299.44 149.727L300.518 148.833L301.074 148.529L301.703 147.844L302.744 147.293L302.601 147.806Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M307.807 141.998L307.735 143.291L308.256 142.455L308.489 142.797L308.058 143.71L308.579 144.109L309.154 144.204L309.998 143.748L310.393 143.881L309.459 144.965L308.705 145.668L308.005 145.649L307.502 146.011L307.232 146.543L306.945 146.752L306.119 147.418L305.06 148.235L303.982 148.73L304.072 148.407L303.803 148.235L305.042 147.247L305.203 146.562L304.521 146.087L304.844 145.649L305.796 145.231L306.55 144.28L306.999 143.501L307.107 142.683L307.25 142.474L307.089 141.96L306.963 140.896L307.035 140.021L307.43 139.926L307.592 140.61L308.166 140.915L307.807 141.998Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M81.5355 161.785L82.6129 164.371H83.5108L84.0494 164.409L83.9597 164.865L83.3851 165.227L82.9541 165.189L82.3975 165.094L81.6433 164.751L80.6736 164.58L79.3269 163.934L78.1777 163.325L76.418 162.013L77.244 162.26L78.7882 163.04L80.099 163.458L80.3145 162.926L80.2606 162.127L80.8712 161.633L81.5355 161.785Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M74.2244 125.638L74.386 125.942L74.1705 127.216L73.1649 127.806L73.4522 129.84L73.3086 130.239L73.6677 130.715L73.0751 131.475L72.6083 132.616L72.4467 133.738L72.7519 134.917L72.3748 136.172L73.2547 138.283L73.542 138.511L73.7934 139.633L73.5061 140.812L73.7575 141.839L73.2188 142.637L73.5061 143.74L74.0987 144.938L73.6498 145.376L73.6857 146.459L73.8293 147.695L74.4219 149.179L74.1166 149.426L74.781 150.814L75.3376 151.27L75.194 151.784L75.6968 152.012L75.9482 152.468L75.625 152.696L75.9482 153.4L76.1457 154.978L76.02 156.005L76.3432 156.614L76.3253 157.355L75.8404 157.888L76.3971 159.124L76.8639 159.561L77.4206 159.485L77.7618 160.36L78.3902 161.044L80.563 161.196L81.4428 161.386H80.6707L80.3654 161.672L79.7549 162.09L80.0602 163.174L79.719 163.193L78.5878 162.832L77.241 162.014L75.8763 161.348L75.3017 160.607L75.2479 159.922L74.4937 159.124L73.5959 157.108L73.56 155.967L74.1705 155.054L72.6801 154.693L73.1649 153.647L72.8058 151.651L73.973 152.069L73.6498 149.578L72.9315 149.255L73.1111 150.757L72.4826 150.586L72.2132 148.874L71.8541 146.631L72.0516 145.794L71.4591 144.615L71.0281 143.246L71.4231 143.189L71.5309 141.23L71.7464 139.272L71.7643 137.465L71.1718 135.621L71.2795 134.613L70.9024 133.111L71.2256 131.628L71.064 129.27V126.722L71.082 124.002L70.8126 122.006L70.4355 120.275L70.9383 119.971L71.1359 119.344L71.7105 120.18L71.9259 121.055L72.5005 121.569L72.303 122.747L72.9674 124.117L73.5241 125.809L74.2244 125.638Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M146.432 36.1365L145.929 35.8513L145.372 35.3378L144.564 35.585L143.918 35.49L144.367 35.1667L145.085 33.4553L146.252 32.9609L146.971 32.999L147.132 33.3983L146.971 34.4631L146.755 34.9005H146.234L146.432 36.1365Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M133.937 52.5909L133.542 52.8952L133.039 52.724L132.554 52.8571L132.716 51.9064L132.662 51.1648L132.231 51.0507L132.033 50.5943L132.123 49.7957L132.518 49.3583L132.608 48.8639L132.823 48.1414V47.6279L132.662 47.1906L132.626 46.7723L132.967 46.468L133.362 46.2969L133.577 46.8863H134.116L134.278 46.7342L134.834 46.7723L135.068 47.3807L134.637 47.704L134.583 48.6548L134.439 48.8259L134.386 49.4154L133.972 49.5104L134.332 50.233L134.044 51.0317L134.368 51.393L134.224 51.7162L133.865 52.1726L133.937 52.5909Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M267.28 36.1823L269.74 38.274L268.142 37.8937L268.806 39.6051L270.53 40.822L271.069 41.6587L269.902 40.9361L269.92 41.8679L269.076 40.8601L268.393 39.7001L267.388 38.4261L266.957 37.5134L265.808 35.9541L264.371 34.7942L263.15 33.1969L263.491 32.6645L262.701 32.1321L262.935 31.9609L263.814 32.7215L265.053 33.8434L265.987 35.0034L267.28 36.1823Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M160.45 31.9927L158.87 32.0117L157.811 31.8786L157.936 31.3842L159.067 31.0039L159.983 31.2131L160.378 31.3842L160.342 31.7075L160.45 31.9927Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M241.939 11.6236L240.879 11.6426L239.281 11.5285L239.102 11.4715L239.227 11.0912L239.981 10.9961L241.49 11.3764L241.939 11.6236Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M244.203 9.8139L244.005 10.1942L242.766 10.1181L240.917 9.73784L240.594 9.43359L242.084 9.5667L244.203 9.8139Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M239.626 9.35665L240.182 10.0792L237.615 10.0412L236.789 10.2694L234.544 9.64187L233.934 8.99536L234.562 8.82422L236.394 8.86225L239.626 9.35665Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M182.754 14.0981L182.359 14.1742L179.935 14.0411L179.522 13.6037L178.103 13.3375L177.744 12.7861L178.373 12.5769L178.085 12.0445L179.055 11.2078L178.337 11.0937L179.54 10.238L179.091 9.8007L180.312 9.3063L182.161 8.69782L184.262 8.52668L185.16 8.1844L186.363 8.07031L187.117 8.4316L186.884 8.71683L184.837 9.19221L183.059 9.62956L181.497 10.5423L180.994 11.4931L180.402 12.4438L180.958 13.2615L182.754 14.0981Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M262.289 46.3792L262.038 46.17L261.697 45.5425L262.145 45.5235L261.445 44.0973L260.601 43.0705L261.122 42.6522L262.361 42.8614L262.253 41.6824L261.75 40.3894L261.804 39.952L261.571 38.8681L260.332 39.2294L259.865 39.6858H258.5L257.423 38.5829L255.807 37.7272L254.011 37.3469L252.898 36.206L252.09 35.4834L251.407 34.97L250.025 33.7911L248.947 33.3727L247.403 33.0115L246.29 33.0495L245.374 33.2587L245.069 33.8481L245.733 34.1143L246.182 34.7609L245.949 35.1412L245.985 36.3772L246.326 36.9096L245.536 37.6512L244.207 37.1948L243.201 37.3089L242.501 36.9096L241.891 36.7765L241.1 37.6131L240.041 37.8033L239.395 38.1075L238.174 37.9174H237.348L236.468 37.3089L235.283 36.7575L234.313 36.5863L233.289 36.7384L232.571 36.9666L231.045 36.4722L230.398 35.5975L229.195 35.2933L228.333 35.1412L227.077 34.6658L226.843 35.8828L227.561 36.5673L227.13 37.404L225.694 37.0997L224.796 37.0617L223.934 36.5103L223 36.4912L222.049 36.13L220.989 36.6814L219.786 37.6892L218.942 37.8984L218.637 37.9934L217.847 37.2709L216.77 37.442L216.177 36.9286L215.459 36.7004L214.723 36.0159L214.13 35.8067L213.017 36.1109L211.508 35.4454L211.311 36.0539L208.025 33.0875L206.516 32.1938L206.66 31.8135L205.008 32.9164L204.218 32.9734L204.02 32.3459L202.746 31.9466L201.973 32.2318L201.183 31.0339L199.549 30.7867L198.993 31.2621L197.035 31.6994L196.73 31.9846L193.678 32.3839L193.426 32.7833L194.342 33.5819L193.624 33.8862L193.893 34.1904L193.265 34.7609L194.952 35.5785L194.917 36.13L193.66 36.0729L193.516 36.4342L192.205 35.8257L190.823 35.8447L190.032 36.3391L188.847 35.8637L186.693 35.0461L185.328 35.0841L183.873 36.3581L183.981 37.2138L182.904 36.5293L182.509 37.8413L182.832 38.0695L182.527 38.9822L183.478 39.7809L184.125 39.7429L184.897 40.5415L184.933 41.15L185.436 41.3591L185.184 42.0627L184.358 42.2529L183.712 43.4889L184.789 44.6488L184.861 45.4474L186.172 46.8736L185.723 47.368L185.615 47.6722L185.184 47.5771L184.412 46.8545L184.143 46.8165L183.496 46.5313L183.119 46.0369L182.203 45.7897L181.683 45.9798L181.467 45.7517L180.103 45.1622L178.72 44.972L177.894 44.7629L177.822 44.915L176.457 43.8882L175.344 43.4318L174.428 42.7282L175.075 42.5381L175.649 41.5493L175.057 41.0739L176.296 40.5795L176.224 40.3133L175.452 40.5035L175.38 39.99L175.775 39.6478L176.637 39.5717L176.691 39.1724L176.368 38.5069L176.601 37.8984L176.529 37.5371L175.147 37.1568L174.626 37.1758L173.979 36.6243L173.333 36.8145L172.13 36.3962L172.112 36.168L171.699 35.6546L170.999 35.5975L170.855 35.2362L171.017 34.989L170.334 34.3235L169.454 34.4376L169.185 34.3806L169.005 34.6468L168.682 34.6087L168.323 33.8481L168.054 33.4678L168.197 33.3537L168.898 33.3918L169.185 33.1446L168.88 32.8403L168.269 32.6311V32.422L167.892 32.2128L167.21 31.4522L167.336 31.148L167.138 30.5965L166.276 30.3303L165.845 30.4634L165.684 30.1782L164.732 29.893L164.355 29.2084L164.175 28.657L163.726 28.4098L164.014 28.0485L163.583 26.9836L164.049 26.3371L163.888 26.1469L164.696 25.5194L163.726 24.987L165.163 23.5799L165.773 22.9334L165.935 22.3819L164.606 21.6403L164.768 20.9178L163.888 20.1191L164.193 19.2064L163.026 18.0084L163.547 17.2098L162.236 16.5062L162.164 15.7836L162.739 15.6886L163.888 15.2892L164.552 14.928L165.935 15.5364L168.036 15.7836L171.214 16.9626L171.95 17.457L172.22 18.1605L171.555 18.712L170.388 18.9972L166.761 18.1986L166.24 18.3317L167.695 19.1113L167.874 19.6057L168.215 20.7086L169.311 21.0318L169.993 21.3171L169.957 20.7847L169.347 20.3283L169.724 19.91L171.807 20.5945L172.381 20.3283L171.609 19.5296L173.064 18.5028L173.8 18.5599L174.626 18.9212L174.823 18.1986L173.979 17.5711L174.123 16.9436L173.351 16.2971L175.56 16.6393L176.206 17.2098L175.29 17.3429L175.506 17.9324L176.242 18.2937L177.319 18.0655L177.247 17.3999L178.63 16.8865L180.857 16.0118L181.431 16.0499L180.982 16.6774L181.952 16.7915L182.329 16.4302L183.712 16.4111L184.61 15.9738L185.759 16.6013L186.262 15.9167L185.184 15.3273L185.4 14.985L187.734 15.2892L188.919 15.6125L192.259 16.7915L192.457 16.259L191.397 15.7076L191.253 15.4984L190.302 15.3843L190.266 14.9089L189.422 14.1103L189.224 13.787L189.997 12.8933L189.889 11.9806L190.284 11.7904L192.331 12.0567L192.852 12.6081L192.69 13.4067L193.354 13.73L194.037 14.4336L194.719 15.8407L195.922 16.4682L196.012 17.1718L195.383 18.6549L196.335 18.8071L196.425 18.4268L197.107 18.1605L197.017 17.6471L197.359 17.1337L196.569 16.5443L196.497 15.8597L195.635 15.7836L195.114 15.2132L195.042 14.1864L193.57 13.3687L194.414 12.7032L193.749 11.9996L194.091 11.9806L194.845 12.513L195.222 13.4828L196.12 13.673L195.294 12.9504L196.209 12.5511L197.664 12.494L199.388 13.0645L198.149 12.2468L197.269 11.201L198.328 11.0108L200.034 11.0488L201.435 10.9157L200.429 10.4213L200.663 9.79384L201.417 9.75581L202.297 9.29945L203.967 9.16634L203.931 8.90013L205.601 8.82406L206.373 9.03323L207.342 8.53884L208.599 8.55785L208.33 8.13952L208.492 7.75921L209.605 7.37891L211.095 7.68315L210.467 7.91133L212.155 8.04444L212.891 8.50081L213.232 8.27262L215.189 8.29164L217.272 8.748L218.26 9.09028L218.709 9.58467L218.278 9.8699L217.093 10.4023L216.895 10.6876L217.901 10.8207L219.194 11.0679L219.625 10.8777L220.666 11.5052L220.702 11.258L221.636 11.1059L224.078 11.258L224.76 11.7144L227.885 11.8665L227.023 11.1249L228.729 11.296L229.824 11.277L231.602 11.7904L232.679 12.4179L232.751 12.8363L234.564 13.6349L236.18 14.0342L235.642 12.9884L237.33 13.4258L238.227 13.1595L239.987 13.4638L240.167 13.1976L241.531 13.3307L239.844 12.3989L240.221 11.9806L247.475 12.6271L248.894 13.2166L251.82 13.9772L254.478 13.787L256.148 13.9582L257.333 14.3765L258.249 15.1181L259.56 15.4033L260.26 15.1942L261.517 15.1752L263.187 15.3653L264.426 15.2512L266.994 16.1639L267.443 15.8407L265.916 15.1942L265.593 14.7378L268.34 15.023L269.777 14.966L272.614 15.4414L274.32 15.8977L280.281 20.1001L279.922 20.5755L278.809 20.4994L280.281 21.0699L281.915 21.9636L282.67 22.2488L283.352 22.7052L283.532 22.9904L281.736 22.7622L280.551 23.5799L280.012 23.713L279.725 24.4926L279.366 25.1772L279.671 25.6906L277.606 24.911L276.511 25.7857L275.667 25.3673L275.415 25.8617L274.158 25.6906L274.715 26.4322L274.912 27.5351L275.433 27.9914L276.654 28.2386L278.288 29.893L277.552 29.95L278.163 30.9008L279.007 31.3952L278.109 31.9846L279.078 33.3157L278.055 33.6009L278.863 34.7799L278.558 35.8828L277.534 35.0651L275.649 33.3727L272.74 30.7867L271.573 29.2084L271.591 28.5239L271.088 27.9914L272.111 27.7442L272.075 26.3181L272.201 25.1772L272.65 24.2835L271.465 22.7242L270.621 22.8193L271.195 23.732L270.549 24.949L268.34 23.5799L266.706 23.9602V25.8237L268.089 26.5082L266.563 26.8125L265.413 26.9266L264.641 26.1089L263.205 25.9378L262.756 26.4892L260.045 26.2991L257.674 26.6223L257.046 28.8471L256.148 31.5473L257.62 31.6994L258.644 32.422L259.685 32.6692L259.757 32.0987L260.763 32.1748L263.061 33.4488L263.905 34.4376L264.157 35.6165L265.144 37.0237L266.096 38.9062L265.916 40.6366L266.15 41.4542L265.791 42.8614L265.413 44.2495L265.252 44.953L264.426 45.6566L263.869 45.6756L262.936 45.0861L262.199 45.9798L262.289 46.3792Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M209.386 6.84633L206.136 7.1886L205.902 6.02867L206.297 5.93359L206.854 5.99064L209.117 6.48504L209.386 6.84633Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M173.062 4.94096L172.29 5.03604L171.769 5.1121V5.24521L171.122 5.37831L170.314 5.18816L170.512 4.92195L169.111 4.90293L170.243 4.75081H171.176L171.446 4.95998L171.679 4.76983L172.182 4.63672L173.223 4.80786L173.062 4.94096Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M205.436 6.32627L204.161 6.44037L202.06 6.19317L200.606 5.86991L199.421 5.26142L198.361 5.1093L199.331 4.55786L200.444 4.38672L202.168 4.76702L204.628 5.56566L205.436 6.32627Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M139.269 44.9345L139.628 45.3908L141.334 45.9423L141.675 45.6761L142.716 46.2275L143.776 46.0754L143.848 46.779L142.968 47.5776L141.783 47.8438L141.693 48.2431L141.118 48.9087L140.759 49.8975L141.118 50.601L140.58 51.1334L140.364 51.9321L139.646 52.1793L138.981 53.111L137.76 53.13L136.863 53.111L136.252 53.5294L135.875 53.9857L135.408 53.8907L135.067 53.4723L134.816 52.7878L133.936 52.5976L133.864 52.1793L134.223 51.7229L134.367 51.3997L134.043 51.0384L134.331 50.2397L133.972 49.5171L134.385 49.4221L134.438 48.8326L134.582 48.6615L134.636 47.7107L135.067 47.3874L134.833 46.779L134.277 46.7409L134.115 46.893H133.577L133.361 46.3036L132.966 46.4747L132.625 46.779L132.715 45.9233L132.355 45.4099L133.684 44.5352L134.798 44.7443H136.037L137.006 44.9535L137.778 44.8774L139.269 44.9345Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M149.883 46.4565L149.614 47.3883L149.183 47.1411L148.949 46.3424L149.111 45.8861L149.685 45.4297L149.883 46.4565Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M146.058 37.6237L146.255 37.7187L146.507 37.6997L146.938 38.004L148.231 38.2322L147.8 39.0308L147.728 39.8865L147.494 40.0956L147.081 39.9816L147.117 40.2858L146.471 40.9513V41.5028L146.902 41.3126L147.225 41.826L147.207 42.1683L147.476 42.6247L147.171 42.986L147.44 43.9177L147.943 44.0698L147.853 44.5832L147.045 45.2678L145.214 44.9445L143.885 45.3439L143.777 46.0664L142.718 46.2186L141.676 45.6671L141.335 45.9333L139.629 45.3819L139.27 44.9255L139.755 44.2029L139.935 41.807L139.019 40.552L138.354 39.9435L136.99 39.4872L136.918 38.6125L138.085 38.3653L139.576 38.6695L139.306 37.3194L140.15 37.8328L142.197 36.9201L142.467 35.9503L143.221 35.7031L143.364 36.1215L143.759 36.1405L144.19 36.6159L144.819 37.1673L145.268 37.0722L146.058 37.6237Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M60.7816 39.4322L59.6863 39.8125L58.8423 40.2879L58.0163 40.8013L57.9265 40.9724L58.9501 40.7252L59.3272 41.1245L60.1531 40.8393L61.033 40.44L62.0027 40.0407L61.446 40.6682L61.8949 40.8203L62.3438 41.2767L63.2596 41.0105L64.1754 40.9154L64.2293 41.2577L64.4986 41.2957L64.7141 41.3337L64.9834 41.8091L64.1395 41.9232H64.1215L63.4571 41.7901L62.6491 42.0183L61.9847 42.1324L61.1407 42.912L60.6021 43.3493L60.6739 43.4824L61.6615 42.7028H61.7872L60.9432 43.6346L60.4225 44.4712L59.9736 45.1558L59.8658 45.7452L59.7222 46.0305L59.6145 46.3537L59.6324 46.9812L59.6863 47.0763L60.0095 47.0573L60.2968 46.9242L60.5482 46.7721L61.1407 46.1826L61.464 45.384L61.446 44.6424L61.6974 44.129L62.1643 43.5395L62.5413 43.1211L63.0262 42.8359L62.9543 43.2352L63.3494 42.6458L63.5828 42.5317L63.8881 42.0753L64.5704 42.3225L65.0732 42.7789L64.9295 43.3303L64.6423 43.8818L63.9599 44.3571L63.8881 44.6614H64.0676L64.8398 44.148L65.1271 44.2621L65.0373 44.9656L64.9116 45.46L64.2472 46.1256L63.8881 46.5439L63.4033 47.0003L63.8881 47.2475L64.337 47.3235L65.0552 47.1524L65.7196 46.8291L66.2583 46.658L67.0843 46.3157L68.1258 45.5931L68.1438 45.479L68.1976 45.1177L68.6824 44.9656L69.3828 45.0227L70.101 45.1177L70.927 44.7184L71.0347 44.243L70.9988 44.0719L72.2199 43.2352L72.7047 43.0261L74.1053 43.0071H75.7752L75.9727 42.7218L76.278 42.6648L76.7269 42.4746L77.2297 41.9232L77.8043 40.9914L78.7919 40.0977L78.9894 40.402L79.6538 40.2118L79.9411 40.5541L79.4204 42.1704L79.8154 42.8549L79.8513 43.2543L78.7021 43.8247L77.6247 44.243L76.5474 44.6043L75.8291 45.3269L75.5957 45.5931L75.3802 46.2396L75.5059 46.8671L75.883 46.9052L75.9189 46.4678L76.1164 46.734L75.9368 47.0763L75.2545 47.2665L74.8056 47.2475L74.0514 47.4566L73.6384 47.5137L73.0818 47.5707L72.1839 47.932L73.6384 47.7038L73.8359 47.932L72.4174 48.2933H71.8248L71.8966 48.1412L71.5196 48.4834L71.771 48.5405L71.322 49.4152L70.3704 50.3469L70.3883 50.0237L70.1908 49.9666L69.9753 49.6624V50.3279L70.1549 50.5371L70.0471 50.9935L69.6162 51.4688L68.8081 52.4386L68.7363 52.4006L69.2571 51.5639L68.8979 51.1075L69.0775 50.0807L68.7363 50.6131V51.3928L68.1617 51.2026L68.7004 51.5829L68.431 52.7429L68.6824 52.8379V53.2563L68.5029 54.4732L67.6769 55.367L66.5815 55.7283L65.7915 56.4508L65.2887 56.5269L64.6782 56.9833L64.4447 57.3826L63.2057 58.1812L62.5234 58.7707L61.8949 59.4933L61.5537 60.349V61.2046L61.6615 62.2505L61.9308 63.1062L61.8411 63.6386L62.0745 65.0457L61.8949 65.8824L61.7872 66.3578L61.428 67.0994L61.1048 67.2515L60.638 67.0994L60.5661 66.5669L60.2429 66.2817L59.8838 65.2359L59.5965 64.3041L59.5247 63.8287L59.8838 63.0111L59.7401 62.3456L59.1835 61.3187L58.8423 61.1286L57.747 61.699L57.5854 61.623L57.2262 61.0525L56.6876 60.7483L55.5383 60.9194L54.7123 60.7673L53.9402 60.8624L53.4913 61.0525L53.599 61.3758L53.4734 61.8702L53.617 62.1174L53.4015 62.2695L53.0783 62.0984L52.6653 62.3265L51.965 62.2885L51.3725 61.642L50.4926 61.7941L49.8462 61.5089L49.2177 61.604L48.3199 61.8892L47.2245 62.7829L46.1292 63.3153L45.4648 63.8858L45.1236 64.4372L44.944 65.2929L44.8722 65.8634L44.98 66.2817L44.5849 66.3197L43.9385 66.0535L43.2382 65.6732L43.0766 65.1028L43.0407 64.2471L42.6097 63.5625L42.4481 62.84L42.1608 62.0033L41.5862 61.5089L40.7782 61.5469L39.9163 62.4977L39.198 62.1364L38.785 61.7751L38.7132 61.0905L38.5695 60.463L38.1386 59.9306L37.7615 59.5313L37.528 59.0939H35.8401L35.6965 59.6074H34.9244H32.9851L31.0278 58.7517L29.7709 58.1622L29.9325 57.915L28.6576 58.0481L27.5263 58.1432L27.5802 57.5347L27.2031 56.8311L26.8081 56.679L26.826 56.3367L26.3053 56.2607L26.0898 55.9374L25.2279 55.8233L25.0663 55.6142L25.2099 54.9486L24.761 53.7317L24.6712 52.0393L24.8329 51.7541L24.5994 51.3547L24.3301 50.3279L24.6533 49.3391L24.4917 48.6736L25.192 47.6658L25.6948 46.639L25.8923 45.7072L26.8799 44.5663L27.5981 43.4824L28.3164 42.3986L29.0885 40.7823L29.4117 39.7745L29.4836 39.223L29.735 38.9758L30.7764 39.3942L30.5969 40.5161L30.9919 40.1928L31.4408 39.223L31.7281 38.2532H34.26H36.8996H37.7615H40.4729H43.1125H45.77H48.4456H51.4622H54.5148H56.3464L56.5798 37.7969H56.8851L56.7235 38.4434L56.903 38.6335L57.4956 38.7096L58.3216 38.8998L59.0219 39.2611L59.812 39.1089L60.7816 39.4322Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M13.2834 28.8096L12.0265 29.247L11.8828 28.9427L12.2958 28.4103L13.445 28.011L14.0735 27.8398L14.5404 27.9159V28.2772L13.2834 28.8096Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M6.28007 25.6496L5.57977 25.8208L5.27451 25.6116L5.13086 25.3073L6.15437 25.1172L6.69307 25.2313L6.28007 25.6496Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M6.49805 21.3867L6.71353 21.5769L7.342 21.4818L7.62931 21.767L8.22187 21.9001L8.00639 22.0332L7.12653 22.2614L6.82127 22.0142L6.7674 21.8241L5.99527 21.8811L5.94141 21.786L6.49805 21.3867Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M37.5259 15.1231L33.1087 19.0022L26.7162 25.2202L27.4704 25.2582L27.9731 25.5624L28.0629 26.0568L28.1168 26.7794L29.4815 26.1519L30.6486 25.7906L30.5409 26.3801L30.6846 26.8365L30.9719 27.3499L30.7743 28.1485L30.5229 29.4606L31.3489 30.1831L30.7743 30.9057L29.8586 31.4572L29.7508 31.0388L29.3019 30.6585L29.8945 29.6697L29.6072 28.738L30.092 27.6731L29.3558 27.5971L28.0809 27.5781L27.3985 27.2358L26.806 26.0759L26.2134 25.8667L25.1899 25.4674L23.9689 25.5624L22.8915 25.049L22.4066 24.5737L21.2754 24.8018L20.6469 25.5815L20.1262 25.6575L18.9411 25.8857L17.8278 26.266L16.6785 26.5132L17.2532 25.8477L18.7615 24.7448L19.9825 24.4025L20.0544 24.1363L18.3664 24.7448L17.0377 25.4864L15.0266 26.285L15.0625 26.8365L13.4464 27.6351L12.0637 28.1105L10.8786 28.4718L10.1604 28.9662L8.25699 29.5556L7.44895 30.0881L5.97652 30.5825L5.4917 30.5064L4.3784 30.8107L3.12145 31.21L2.02611 31.5903L0.230469 31.9326L0.302293 31.7234L1.77472 31.191L2.95984 30.8297L4.5041 30.2022L5.67126 30.0881L6.56908 29.6127L8.43655 28.9281L8.84955 28.7L9.87306 28.3006L10.9145 27.445L12.0278 26.7794L10.717 27.1217L10.6631 26.9125L9.78328 27.3309L9.85511 26.7604L9.20868 27.1597L9.49598 26.6083L8.18516 27.0456H7.68238L8.34677 26.3801L8.93933 25.9618L8.8675 25.5624L7.57464 25.7906L7.46691 25.2582L7.23347 24.992L7.95173 24.3645L7.8799 23.8891L8.93933 23.2616L10.322 22.6341L11.2737 22.0827L12.0099 22.0066L12.3331 22.1777L13.608 21.6453L14.0569 21.7404L15.0625 21.3981L15.5114 20.9037L15.3139 20.7136L16.3912 20.2952L15.8885 20.3142L14.7752 20.5424L14.2544 20.7896L13.9312 20.5424L12.6922 20.6755L11.8662 20.4093L12.0817 19.972L11.9021 19.3635L13.5541 18.9071L15.9244 18.3937H16.5529L15.7807 18.9261L17.4327 18.8881L17.6482 18.2226L17.2352 17.8232L17.3788 17.2908L17.2532 16.8535L16.6606 16.5302L17.8278 15.9788L19.1745 15.9407L20.7547 15.4844L21.6166 14.99L23.0351 14.4956L23.897 14.3815L25.9081 13.9251L26.4648 14.0012L28.3323 13.4688L29.1223 13.6779L29.0326 14.1343L29.6251 13.9441L30.7564 14.0012L30.4152 14.2294L31.2951 14.4005L32.1749 14.3054L33.2882 14.6097L34.5811 14.7238L34.9761 14.8378L36.1613 14.6857L36.8975 14.99L37.5259 15.1231Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M85.5254 95.0617L85.7947 94.5293L85.8845 93.9779L86.0641 93.4645L85.687 92.7419L85.6331 91.9052L86.1898 90.8594L86.531 90.9925L87.2672 91.2777L88.3266 92.3045L88.4702 92.7989L87.8597 93.9208L87.5365 94.8145L87.1415 95.2899L86.6566 95.366L86.513 95.0237L86.2796 94.9857L85.9743 95.3089L85.5254 95.0617Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M70.365 82.7034L70.2753 82.6655L70.1855 82.5708L70.2035 82.457L70.2394 82.5139L70.3111 82.5897L70.365 82.6845V82.7034Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M77.7821 75.6385H77.7461L77.8 75.5625H77.854L77.818 75.6195L77.7821 75.6385Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M78.9518 76.9709L79.0594 77.0278L79.0235 77.0846H78.9877L78.8621 77.1036L78.8262 77.0846V76.9899L78.88 76.9709L78.898 76.9141H78.9338L78.9518 76.9709Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M78.948 76.2578H78.9839L79.0198 76.2957L79.0377 76.3715L79.0198 76.4284L78.9839 76.4474L78.9659 76.4094L78.9121 76.3715V76.2768L78.948 76.2578Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M190.889 65.8242L190.943 65.8432L190.979 65.8242L191.051 65.9573L191.033 65.9954L191.051 66.1665V66.2996L191.015 66.3757L190.997 66.2996L190.889 66.1475L190.907 66.0714L190.871 65.9383V65.8623L190.889 65.8242Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M68.1238 72.0451L68.0519 72.1402L68.016 72.2353L67.9083 72.2923H67.8185L67.8005 72.2733L67.7287 72.3113L67.6389 72.3303L67.5312 72.2923L67.4594 72.3113L67.4414 72.2162L67.4953 72.1782L67.5312 72.1212L67.603 72.0831L67.6569 72.0071H67.7287L67.7826 71.969L67.8185 72.0261L67.9083 72.0641L67.9981 72.0261L68.1238 71.8359H68.1776V71.874L68.1238 72.0451Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M68.159 71.7256L68.123 71.6117L68.2309 71.5547L68.2849 71.6117V71.6497L68.2309 71.6687L68.159 71.7256Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M68.2361 70.4833L68.2721 70.4643L68.3621 70.5214H68.4341L68.5061 70.5404L68.5601 70.5784V70.6355L68.5241 70.6545L68.4341 70.5784H68.3621L68.3441 70.5594L68.2541 70.5974L68.1641 70.5594V70.5404L68.2001 70.4453L68.2361 70.4833Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M67.5351 70.1445L67.4991 70.2206V70.3537L67.4811 70.4298L67.4091 70.4868L67.3731 70.5629L67.3011 70.6199L67.1751 70.677L67.1571 70.715L67.1211 70.677L67.1391 70.6389L67.2111 70.6199L67.2471 70.5819V70.5439L67.3191 70.5248L67.3551 70.4488L67.4271 70.4298L67.4811 70.3537L67.4451 70.2967H67.3731L67.3371 70.2586L67.4091 70.1635L67.4271 70.1445H67.5351Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M67.1908 70.0951L67.2087 70.1141H67.2805L67.3523 70.1521L67.2805 70.2282L67.2626 70.1902H67.2267L67.1549 70.1711L67.0831 70.1331L67.0293 70.019L67.0831 70L67.1549 70.019L67.1908 70.0951Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M65.5382 68.9688L65.6459 69.1014L65.6997 69.1393L65.7535 69.2341L65.6997 69.2152L65.6818 69.1772L65.6279 69.1583L65.5561 69.0825L65.5203 69.0635L65.4844 68.9877L65.5382 68.9688Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M66.2016 68.9688L66.2556 69.0828L66.2916 69.1779V69.254L66.3276 69.292L66.3636 69.4251V69.5963L66.3996 69.6533L66.4896 69.6913L66.5616 69.8054V69.9575L66.4896 69.8244V69.7864L66.4356 69.7103L66.3276 69.6723L66.3636 69.6343L66.3096 69.5772V69.5202L66.3456 69.4631L66.3276 69.3681L66.2736 69.292L66.2916 69.273L66.2376 69.1969L66.2196 69.0828L66.1836 69.1019L66.2016 68.9688Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M66.7274 68.9671L66.6735 69.0051L66.6195 68.9861L66.6016 68.9481L66.7095 68.9102L66.7274 68.9671Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M65.2536 68.609L65.2356 68.59L65.1816 68.457H65.2176L65.2536 68.609Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M67.1318 68.5083L67.0601 68.622H66.9883L67.0242 68.5651L67.0421 68.4514L67.1139 68.3945L67.1318 68.4704V68.5083Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M63.8157 68.2807L63.7618 68.2997L63.7258 68.3567L63.6719 68.3377L63.7798 68.2617L63.8157 68.2807Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M63.849 68.4162L63.9208 68.4542L63.9567 68.4162L63.9746 68.3211L64.0105 68.3021L64.0464 68.4162V68.5113L64.0284 68.5683L64.0464 68.6824V68.7395L63.9746 68.8916L63.9387 68.9106L63.8669 68.8726L63.9028 68.8155L63.9746 68.7775L63.9567 68.7585L63.849 68.8345L63.8131 68.7965L63.8849 68.7395H63.8131L63.7772 68.7585L63.7413 68.7204V68.5873L63.7593 68.5493L63.6875 68.4542V68.4162L63.7593 68.3782L63.7772 68.3211L63.831 68.3021L63.849 68.2641L63.9567 68.207L63.9746 68.2831L63.8849 68.3592L63.849 68.4162Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M66.278 68.3043L66.296 68.3994L66.26 68.3804L66.17 68.3994L66.098 68.4184L66.08 68.3804L66.134 68.3423L66.206 68.2853V68.2473L66.134 68.2092L66.098 68.0951L66.08 67.9811L66.008 67.905V67.867L65.918 67.7719L65.972 67.7148L66.044 67.7909V67.886L66.08 67.943L66.098 68.0381L66.152 68.1332L66.224 68.1902L66.242 68.2473L66.278 68.3043Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M64.4247 67.2539L64.4785 67.2918L64.3708 67.3487L64.317 67.3297L64.2811 67.3676L64.1914 67.3487L64.2273 67.2918L64.2991 67.2539H64.4247Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M63.6692 67.1547L63.7411 67.1167L63.7949 67.1737L63.777 67.2117L63.7949 67.2498L63.759 67.3258L63.8129 67.3829L63.8488 67.554L63.8847 67.6111L63.9565 67.7061L63.9206 67.8392L63.9386 67.9533L63.9027 68.0104L63.8488 68.0294L63.777 68.1055L63.7231 68.1435H63.6692L63.6154 68.1815H63.5615V68.1055L63.5076 68.0674L63.5256 67.9533L63.4717 68.0104L63.4358 67.9914L63.3281 67.9153L63.2742 67.8583L63.2383 67.8012L63.364 67.7442L63.4538 67.8773L63.4717 67.7632L63.4178 67.7442L63.3999 67.6871L63.4178 67.6301L63.5256 67.516L63.5615 67.4399L63.5435 67.4209L63.5974 67.3449V67.2498L63.5615 67.1167L63.5794 67.0977H63.6333L63.6692 67.1547Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M65.123 66.6641L65.1409 66.7021L65.1948 66.7781L65.3385 66.9113L65.4282 66.9303L65.4462 66.9493L65.4821 67.0254L65.536 67.1014L65.6258 67.1775V67.2155L65.5898 67.3676L65.5719 67.4057V67.4627L65.5539 67.5578L65.518 67.6148L65.5001 67.7479L65.4821 67.7669L65.4462 67.6529L65.3744 67.5958L65.3923 67.5578L65.4821 67.5768L65.518 67.5388L65.5001 67.5007L65.518 67.4247L65.5719 67.3486L65.5898 67.2535V67.1965L65.5001 67.1204L65.4282 66.9873L65.3744 66.9493L65.2666 66.8922L65.2128 66.8352L65.105 66.7972L65.0332 66.8352L65.105 66.6641H65.123Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M63.5462 65.2435L63.636 65.2815H63.6539L63.7796 65.3006L63.8155 65.2625L63.8514 65.2815H63.9412L64.0131 65.2435H64.0849L64.1388 65.2055L64.1567 65.3006L64.1388 65.3386H64.0849H64.0131L63.8155 65.3766H63.7617L63.4923 65.4527L63.3666 65.5287H63.2948L63.2589 65.5097L63.205 65.4527L63.1152 65.3386L63.223 65.3956L63.2409 65.4337H63.3307L63.4205 65.3956L63.4923 65.2815L63.4384 65.2625L63.4744 65.2055L63.4923 65.1484L63.5462 65.2435Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M64.3183 64.9961L64.4619 65.0341L64.4979 65.0151L64.5697 65.0722L64.7313 65.2623L64.7672 65.3764L64.839 65.3954L64.9647 65.4905V65.5285L64.9288 65.6236L64.9647 65.7567H64.8929L64.8031 65.8328L64.7852 65.8708L64.7313 66.0609L64.7133 66.2321L64.6774 66.2701L64.6236 66.2321L64.6056 66.156L64.5338 66.137L64.5876 66.0419H64.6236L64.7133 65.9659L64.6954 65.8898L64.7313 65.8138V65.7567L64.7672 65.6997V65.5856L64.8031 65.5666L64.839 65.5095L64.857 65.4525L64.8031 65.4334L64.7133 65.4144L64.6954 65.3574V65.3194L64.6236 65.2813V65.2243L64.5697 65.0912L64.5338 65.0722L64.4799 65.0912L64.3901 65.0722H64.3362L64.2285 64.9961H64.3183Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M77.9646 76.0392L77.9473 75.9844L77.9992 76.0026L77.9646 76.0392Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M78.3431 58.351H78.2891L78.2712 58.37L78.2891 58.408L78.2172 58.446L78.1992 58.427L78.2352 58.408H78.2532L78.2712 58.351L78.3251 58.332L78.3431 58.351Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M80.8916 81.9316L80.7836 81.8936L80.7656 81.7985V81.6464L80.8016 81.5703L80.8376 81.6083L80.8736 81.7224L80.9636 81.7795L80.9816 81.8555L80.8916 81.9316Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M185.34 112.988L185.178 112.969L185.143 112.893V112.836L185.232 112.855L185.358 112.95L185.34 112.988Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M186.01 112.621L186.046 112.811V112.944L186.028 112.982L185.992 112.925L185.92 112.868L185.902 112.83L185.848 112.811L185.74 112.735L185.758 112.716L185.848 112.754L185.902 112.735L185.938 112.659V112.621L185.992 112.602L186.01 112.621Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M184.984 112.435L184.894 112.358L184.84 112.339L184.786 112.301L184.75 112.187L184.768 112.13V112.092L184.804 111.864L184.786 111.845L184.822 111.769L184.912 111.75L184.948 111.807L184.912 112.035L184.93 112.092L184.966 112.168L184.984 112.263L185.02 112.378L184.984 112.435Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M116.14 79.7523L116.104 79.8093L116.068 79.7713V79.7143L116.122 79.6953L116.14 79.7523Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M116.482 79.7659L116.446 79.7849L116.375 79.7659L116.321 79.7091L116.303 79.6522L116.339 79.5764L116.428 79.5195H116.5L116.536 79.6522L116.518 79.728L116.482 79.7659Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M117.109 79.1836L117.145 79.2026V79.2406L117.181 79.2787L117.252 79.3737H117.288L117.324 79.4308L117.36 79.5259L117.396 79.5639L117.342 79.659L117.288 79.678L117.199 79.659L117.145 79.64L117.091 79.5829V79.5449L117.055 79.5259L117.037 79.4498L117.055 79.4118V79.3547L117.091 79.2787L117.055 79.1836H117.109Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M117.666 79.1836L117.72 79.2025L117.738 79.3163L117.72 79.3921L117.648 79.43L117.576 79.3542L117.612 79.2784L117.594 79.2405L117.666 79.1836Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M118.026 78.0926L118.079 78.0547L118.169 78.0926L118.187 78.1305V78.2632L118.115 78.32L118.062 78.358H118.008L117.918 78.32V78.2253L117.954 78.1874V78.0736L117.972 78.0547L118.026 78.0926Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M116.585 77.5609L116.657 77.5419L116.711 77.58H116.783L116.837 77.618L116.855 77.656H116.765L116.639 77.599L116.603 77.618L116.549 77.7321L116.495 77.618L116.477 77.599L116.459 77.5229L116.513 77.5039L116.585 77.5609Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M117.986 77.468L118.004 77.487L117.986 77.6011L117.95 77.6201V77.5251L117.914 77.468V77.411L117.896 77.3539L117.968 77.2969L118.004 77.3349L117.986 77.449V77.468Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M115.956 77.2188L115.992 77.2756L116.01 77.3325L115.885 77.3893L115.831 77.3514L115.795 77.3135L115.867 77.2377L115.956 77.2188Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M115.815 76.875L115.869 76.894V76.932L115.923 76.9891L115.887 77.0652L115.779 77.1222L115.707 77.1983L115.581 77.2173V77.1983V77.1032L115.545 77.0652V77.0271L115.581 76.9891H115.617L115.653 76.9511L115.779 76.875H115.815Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M71.4683 83.1762H71.4143L71.3423 83.1191L71.2883 83.1001L71.2343 83.043L71.2163 83.005L71.1623 82.986L71.1263 82.9099L71.0723 82.8529L71.0903 82.7578L71.1803 82.8149L71.1983 82.9099L71.2703 82.986L71.3963 83.024L71.4323 83.0811L71.4863 83.1571L71.4683 83.1762Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M59.5593 74.2951L59.6132 74.3141L59.649 74.2383L59.7208 74.2572H59.8105L59.8285 74.2951L59.7926 74.3331L59.7567 74.3141L59.6849 74.3331L59.649 74.352H59.5234L59.5593 74.2951Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M61.0165 73.8086L60.8906 73.8656L60.9266 73.8086H61.0165Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M61.1215 73.8338L61.1035 73.8148L61.2474 73.7578L61.2114 73.8148L61.1215 73.8338Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M173.674 55.0664L173.692 55.1043L173.745 55.1801L173.674 55.1612H173.62L173.548 55.1991L173.494 55.1422V55.0854L173.548 55.0664L173.584 55.0854L173.674 55.0664Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M173.371 55.1613V55.1803L173.335 55.2183L173.317 55.3324L173.299 55.3704H173.245L173.209 55.4085L173.12 55.4465L173.084 55.4655L172.976 55.5226L172.904 55.5035L172.814 55.5226L172.76 55.5986L172.724 55.5416L172.671 55.5606H172.635L172.581 55.5035L172.509 55.5606H172.419L172.329 55.5226L172.24 55.5035L172.168 55.4465L172.114 55.3324L172.06 55.2754L172.024 55.1422L171.988 55.0852L172.006 55.0282L172.096 55.0852L172.168 55.0662L172.204 55.0091L172.222 54.9521L172.276 54.9331L172.311 54.9521L172.347 54.9141H172.383L172.401 54.9901L172.491 55.0282L172.509 55.0662H172.617L172.724 54.9711L172.796 54.9901L172.85 54.9521L172.904 54.9711L172.976 55.0091L173.012 54.9521H173.066L173.12 55.0282V55.1422L173.173 55.1042L173.227 55.1422L173.245 55.1232L173.371 55.1613Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M79.1916 78.8388L79.2816 78.8578L79.3176 78.9529V79.067L79.2996 79.2191L79.2816 79.2571L79.2456 79.2762L79.1736 79.3142L79.1916 79.2381L79.1736 79.2001L79.1556 79.067L79.1016 78.9719V78.9149L79.1196 78.8578V78.8008H79.1556L79.1916 78.8388Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M89.1344 161.459L89.2064 161.44V161.516L89.0625 161.459L89.1164 161.402L89.1524 161.383L89.1344 161.459Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M89.0059 161.188L89.0418 161.225L89.1138 161.244L89.1317 161.32L89.0778 161.339L89.0598 161.263L89.0238 161.225L89.0059 161.188Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M90.1188 161.039L90.1548 161.058L90.1368 161.133L90.0828 161.115L90.0469 161.058L90.1008 161.02L90.1188 161.039Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M87.9497 160.864V160.902L87.9677 160.959L87.8959 160.978L87.842 160.959L87.8062 160.921L87.7523 160.902L87.7344 160.826H87.7703L87.7882 160.788L87.842 160.77L87.8779 160.788L87.8241 160.845L87.8779 160.864L87.9318 160.807L87.9497 160.864Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M88.4691 160.611L88.3973 160.573L88.3075 160.516L88.1639 160.459L88.1818 160.383L88.0561 160.364L88.0023 160.345L87.9484 160.269L87.9843 160.25L88.128 160.307L88.2716 160.383L88.3614 160.402L88.4332 160.421L88.4871 160.364L88.5051 160.307L88.541 160.326L88.6128 160.288L88.6307 160.326H88.7205V160.383H88.7744L88.936 160.345L88.954 160.383H89.0078L89.0797 160.364L89.0258 160.326L89.0078 160.269H89.0797L89.1874 160.307L89.2053 160.383L89.1335 160.478L89.1515 160.535L89.1156 160.573H89.0437L88.9899 160.725L88.936 160.782L88.8821 160.897L88.8642 160.954L88.7744 161.011L88.7564 160.973H88.6846V161.03L88.541 161.011L88.523 161.03L88.5769 161.106L88.5589 161.125L88.523 161.201H88.4512L88.3973 161.277L88.3434 161.296H88.3075L88.2716 161.239L88.1998 161.182V161.144H88.11L88.2177 161.22H88.1459L88.0561 161.163L88.0202 161.144L87.9484 161.106L87.8945 161.068V161.03L88.0202 161.068L88.128 161.03L88.0382 160.992L88.0202 160.973H88.1818L88.2537 160.992L88.3075 161.03V160.992L88.3794 160.973L88.3973 160.916L88.3255 160.878L88.2896 160.782L88.3075 160.744H88.4153L88.4512 160.763L88.523 160.744L88.5051 160.687H88.3614V160.706L88.2896 160.744H88.1818L88.092 160.687V160.63L88.2177 160.668L88.3255 160.63H88.3794L88.4691 160.611L88.541 160.649V160.63L88.4691 160.611Z",
      "fill": "#EBECED"
    }
  }), _c('path', {
    attrs: {
      "d": "M88.4691 160.611L88.3973 160.573L88.3075 160.516L88.1639 160.459L88.1818 160.383L88.0561 160.364L88.0023 160.345L87.9484 160.269L87.9843 160.25L88.128 160.307L88.2716 160.383L88.3614 160.402L88.4332 160.421L88.4871 160.364L88.5051 160.307L88.541 160.326L88.6128 160.288L88.6307 160.326H88.7205V160.383H88.7744L88.936 160.345L88.954 160.383H89.0078L89.0797 160.364L89.0258 160.326L89.0078 160.269H89.0797L89.1874 160.307L89.2053 160.383L89.1335 160.478L89.1515 160.535L89.1156 160.573H89.0437L88.9899 160.725L88.936 160.782L88.8821 160.897L88.8642 160.954L88.7744 161.011L88.7564 160.973H88.6846V161.03L88.541 161.011L88.523 161.03L88.5769 161.106L88.5589 161.125L88.523 161.201H88.4512L88.3973 161.277L88.3434 161.296H88.3075L88.2716 161.239L88.1998 161.182V161.144H88.11L88.2177 161.22H88.1459L88.0561 161.163L88.0202 161.144L87.9484 161.106L87.8945 161.068V161.03L88.0202 161.068L88.128 161.03L88.0382 160.992L88.0202 160.973H88.1818L88.2537 160.992L88.3075 161.03V160.992L88.3794 160.973L88.3973 160.916L88.3255 160.878L88.2896 160.782L88.3075 160.744H88.4153L88.4512 160.763L88.523 160.744L88.5051 160.687H88.3614V160.706L88.2896 160.744H88.1818L88.092 160.687V160.63L88.2177 160.668L88.3255 160.63H88.3794L88.4691 160.611ZM88.4691 160.611L88.541 160.649V160.63L88.4691 160.611Z",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M88.7598 160.25H88.8137L88.8677 160.307L88.8137 160.326H88.7598V160.25Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M88.573 160.258H88.5212L88.5039 160.203L88.573 160.221V160.258Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M88.3234 160.222L88.431 160.203L88.4669 160.26L88.4131 160.336L88.3772 160.317L88.3234 160.336L88.2695 160.298L88.3234 160.26L88.3772 160.298L88.3951 160.26L88.3054 160.241L88.3234 160.222Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M89.6164 160.241H89.7242L89.7421 160.222L89.8319 160.203L89.9037 160.241L89.9756 160.298L89.9935 160.355V160.374L89.9037 160.393L89.8678 160.336L89.8319 160.317L89.814 160.374L89.8499 160.393L89.8678 160.45L89.9217 160.412L89.9576 160.431L89.9756 160.507L90.0294 160.526L90.0474 160.507L90.1372 160.564L90.1551 160.488L90.0115 160.45L90.0294 160.355L90.0833 160.317L90.3527 160.298L90.4783 160.412L90.5143 160.431V160.507L90.4065 160.488L90.3167 160.45L90.209 160.488L90.2629 160.526L90.3347 160.545L90.4963 160.564L90.5502 160.583L90.5681 160.621L90.5322 160.717H90.4424L90.4245 160.736L90.2988 160.755L90.209 160.793L90.2629 160.831L90.1013 160.907L90.0294 160.888L89.9397 160.907H89.814L89.7062 160.869L89.5985 160.793V160.85L89.6523 160.888L89.7601 160.926L89.814 160.983L89.8499 160.964L89.9217 160.983L89.9935 161.04L89.9576 161.059L89.9935 161.154H89.9576L89.9037 161.097L89.8319 161.078L89.7421 161.154L89.7062 161.097L89.6523 161.059H89.5985L89.5087 161.021L89.4728 161.04L89.5087 161.116H89.5626L89.5985 161.154L89.5626 161.173L89.6883 161.287L89.6523 161.306L89.5805 161.268H89.5267L89.4728 161.211L89.4189 161.192L89.365 161.173L89.3471 161.287L89.4369 161.306V161.363L89.4189 161.401L89.3471 161.382L89.3291 161.344L89.2394 161.306L89.2214 161.268H89.1855L89.1137 161.173L89.1675 161.097V161.059L89.0957 160.964V160.926L89.1855 160.888L89.1675 160.85L89.2573 160.831L89.2394 160.774L89.3471 160.698L89.4548 160.659L89.5267 160.736V160.812L89.5805 160.793L89.4907 160.679L89.5087 160.621L89.401 160.583L89.3291 160.526L89.3471 160.488L89.4189 160.526L89.4369 160.431L89.3112 160.393L89.3291 160.336L89.365 160.355L89.4189 160.317H89.4728L89.5087 160.26L89.4548 160.203H89.5267L89.6164 160.241Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M88.7238 160.164H88.8494L88.8852 160.202L88.9211 160.164L88.957 160.183L88.9929 160.24L88.957 160.259L88.8852 160.24L88.8135 160.202L88.6699 160.183L88.6879 160.145L88.7238 160.164Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M87.4984 159.948L87.4082 159.929L87.4263 159.891L87.4984 159.948Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M135.493 23.7461L135.565 23.784H135.619L135.637 23.8219V23.8977L135.673 23.9546L135.655 23.9925L135.547 23.9167L135.511 23.8409L135.475 23.803L135.439 23.7461H135.493Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M135.55 23.4486L135.693 23.4865L135.729 23.5245L135.711 23.6003L135.693 23.6192L135.622 23.5245L135.532 23.5055L135.496 23.4297L135.55 23.4486Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M135.323 23.186L135.337 23.2165H135.391V23.2735H135.319L135.283 23.3115L135.175 23.2735L135.139 23.2545L135.104 23.1974L135.193 23.1784L135.211 23.1594L135.311 23.1771L135.265 23.1404L135.301 22.9883L135.391 23.0073L135.445 23.1024V23.1214L135.552 23.1594L135.606 23.2545L135.66 23.2925L135.642 23.4066L135.552 23.3306L135.517 23.2925L135.481 23.2735L135.463 23.2355L135.427 23.1974H135.337L135.323 23.186Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M135.976 23.0613L135.941 23.0248L135.993 22.9883L135.976 23.0613Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M135.544 23.155L135.472 23.117L135.418 23.0599L135.4 23.0029L135.418 22.9839L135.49 22.9648H135.544L135.652 23.0409L135.634 23.0789L135.652 23.117L135.759 23.155V23.193L135.687 23.2501L135.544 23.155Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M135.947 23.0434L135.893 23.1192L135.839 23.0813H135.785L135.821 23.0245L135.803 22.9486L135.821 22.9297L135.857 23.0055L135.947 23.0434Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M135.787 23.047H135.751L135.715 22.971L135.733 22.9141L135.769 22.99L135.787 23.047Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M306.763 91.3885L306.727 91.4455L306.637 91.4265V91.3885L306.727 91.3125L306.763 91.3885Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M301.697 89.3672H301.769L301.822 89.4051L301.84 89.4809L301.804 89.4999L301.822 89.5378L301.804 89.5757H301.697L301.661 89.5378V89.4999L301.625 89.443V89.3861L301.697 89.3672Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M281.106 86.2176L281.124 86.2745H281.07L281.016 86.3692L280.998 86.3503L281.052 86.1986L281.124 86.1797L281.106 86.2176Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M78.6822 83.165L78.6105 83.2218L78.5746 83.2029L78.5566 83.1081L78.5925 83.0133L78.6464 82.9375H78.7002L78.7181 82.9944L78.7002 83.127L78.6822 83.165Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M287.267 81.4581L287.249 81.5342V81.6483L287.231 81.7053H287.177L287.141 81.6483L287.123 81.5532V81.4581L287.231 81.3631L287.249 81.325L287.267 81.2299L287.303 81.2109L287.321 81.249L287.393 81.268L287.357 81.3631L287.267 81.4581Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M78.1657 76.989H78.1117L78.0938 76.951L78.1297 76.875H78.1657L78.1837 76.913L78.1657 76.989Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M78.0329 76.6965L78.015 76.7535H77.979L77.9071 76.7155L77.8711 76.6775L77.925 76.6016L78.015 76.6775L78.0329 76.6965Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M79.4893 81.1355L79.4533 81.0975L79.3813 81.0595L79.3633 81.0215V80.9074L79.3813 80.8693L79.5073 80.6602L79.5613 80.6982V80.8313L79.5433 80.9834L79.5253 81.0595L79.4893 81.1355Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M77.7831 75.8414L77.7109 75.8223L77.747 75.7652L77.8011 75.7461L77.7831 75.8414Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M215.816 92.7331V92.7696L215.781 92.7514L215.816 92.7148V92.7331Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M154.944 54.1204L154.908 54.1772L154.819 54.1393L154.729 54.0825V53.9877L154.711 53.9688H154.819L154.89 54.0256L154.926 54.0635L154.944 54.1204Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M154.658 53.9002L154.568 53.8812V53.8432L154.64 53.8242L154.712 53.8812L154.658 53.9002Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M287.568 80.6268L287.55 80.6458L287.514 80.6268L287.496 80.5888L287.586 80.5508L287.622 80.5888L287.568 80.6268Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M287.842 79.6553H287.806L287.752 79.5414L287.77 79.4844H287.824V79.5414L287.86 79.5794L287.842 79.6553Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M287.93 79.352L287.894 79.3899L287.912 79.4468H287.84V79.3141L287.858 79.2762L287.93 79.2383L287.912 79.3331L287.93 79.352Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M287.589 77.9232H287.537L287.52 77.8867H287.589V77.9232Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M287.246 75.8356L287.229 75.7976V75.7026L287.282 75.6836L287.318 75.7406L287.246 75.8356Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M287.031 75.0133L286.959 74.9942V74.937L286.995 74.918L287.031 74.9561V75.0133Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M78.5032 77.3516L78.5391 77.4275V77.4845L78.5032 77.5225L78.4672 77.5035L78.4492 77.4465L78.5032 77.3516Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M198.72 122.399L198.792 122.57L198.756 122.684L198.684 122.76L198.702 122.817L198.648 122.874L198.558 122.912H198.469L198.361 122.893L198.343 122.912L198.289 122.855L198.325 122.817L198.343 122.741L198.361 122.608L198.397 122.532L198.487 122.456L198.505 122.418L198.54 122.323L198.612 122.266L198.684 122.285L198.72 122.399Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M204.437 122.005L204.383 121.948L204.455 121.91L204.509 121.891L204.545 121.91L204.527 121.948L204.437 122.005Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M307.808 125.459L307.772 125.478L307.736 125.554L307.664 125.516L307.7 125.421L307.718 125.383L307.772 125.402L307.808 125.459Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M308.598 123.984L308.58 124.003L308.616 124.079H308.67L308.742 124.041L308.724 124.156L308.688 124.194L308.67 124.27L308.58 124.327L308.508 124.289V124.27L308.454 124.213L308.472 124.175L308.436 124.137L308.454 124.06L308.436 123.984H308.454L308.526 124.003L308.598 123.984Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M308.113 123.159L308.077 123.254V123.33L308.041 123.387L308.095 123.425L308.131 123.444L308.149 123.482L308.131 123.52L308.185 123.596H308.149L308.113 123.691L308.077 123.729L308.023 123.71L307.987 123.653L307.969 123.615L307.861 123.596L307.807 123.501V123.463L307.789 123.406H307.843L307.897 123.368L307.969 123.311L307.987 123.254L307.915 123.216L307.843 123.235L307.879 123.159L307.933 123.14L307.969 123.159L308.041 123.102L308.113 123.159Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M307.497 122.852L307.444 122.965L307.426 123.022H307.479L307.39 123.117L307.354 123.155L307.336 123.117L307.39 123.041L307.426 122.946L307.497 122.852Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M307.503 122.857L307.467 122.781H307.539L307.557 122.857H307.503Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M305.005 122.402L305.041 122.421L305.131 122.592L305.185 122.65L305.239 122.631L305.275 122.573L305.436 122.669L305.49 122.764L305.616 122.878L305.67 122.954L305.688 123.011L305.76 123.087L305.778 123.125H305.813L305.867 123.182L306.029 123.22L306.047 123.277V123.353L306.101 123.429L306.173 123.448L306.119 123.543L306.137 123.581L306.209 123.676H306.226L306.298 123.771L306.28 123.848L306.406 123.886L306.478 123.981H306.532L306.586 124.019L306.675 124.095L306.657 124.152H306.711L306.783 124.247L306.891 124.323V124.361L306.945 124.38L306.999 124.437V124.475L307.052 124.589L307.124 124.665L307.142 124.646L307.214 124.76L307.304 124.779L307.358 124.836V124.912L307.376 124.988L307.394 125.007L307.358 125.122L307.232 125.198L307.214 125.141L307.16 125.16L307.106 125.217L306.999 125.064H306.927L306.909 125.026H306.873L306.837 125.083L306.675 124.912H306.639L306.568 124.817L306.586 124.665H306.532H306.46L306.406 124.627L306.388 124.589L306.352 124.57H306.298V124.513L306.262 124.418L306.191 124.437L306.047 124.342L306.029 124.304V124.247L305.975 124.285L305.867 124.228L305.849 124.152L305.778 124.095L305.742 124L305.652 123.981L305.688 123.943L305.634 123.886L305.58 123.867L305.526 123.733V123.657L305.49 123.6H305.436L305.4 123.486L305.418 123.448L305.293 123.372L305.239 123.334L305.167 123.22L305.221 123.182L305.185 123.144L305.149 123.087V122.992L305.059 122.935V122.821L305.023 122.764H305.077L305.095 122.707L305.077 122.669H304.97L304.934 122.612L305.023 122.478L304.97 122.421L305.005 122.402Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M305.203 122.462L305.148 122.443L305.166 122.367L305.203 122.462Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M304.79 122.002L304.754 122.04L304.736 121.964L304.772 121.926L304.79 122.002Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M310.999 98.5353H310.965L310.947 98.4805H310.999V98.5353Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M277.73 88.6117L277.694 88.6878L277.712 88.7068L277.676 88.8209L277.694 88.8589L277.604 88.897L277.568 88.7639L277.622 88.7258L277.586 88.6878L277.64 88.5737L277.694 88.5547L277.73 88.6117Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M72.9154 75.8223L72.8613 75.7842L72.8794 75.7461H72.9335L72.9515 75.7652L72.9154 75.8223Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M75.5394 75.7371H75.5035L75.342 75.794H75.2344L75.2703 75.7561L75.342 75.7182L75.4138 75.6992L75.5215 75.7182L75.5394 75.7371Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M73.8338 75.2768L73.9415 75.2958H74.0493L74.1031 75.3149L74.2109 75.2958L74.2647 75.3149L74.3366 75.2958L74.3725 75.3149L74.4623 75.2958L74.5341 75.3149H74.588L74.7316 75.3529V75.3149L74.8394 75.3529L74.8573 75.3339L75.001 75.3529L75.0369 75.3909H75.0728L75.1805 75.448L75.2164 75.4289L75.1985 75.5621L75.2344 75.6191L75.0728 75.6762L75.0189 75.7522L74.9651 75.8663L74.9112 75.9043L74.8573 75.9233H74.7855L74.6778 75.9424L74.6239 75.9804L74.4982 75.9614L74.4623 75.9233L74.3725 75.9614L74.3186 75.9043L74.1929 75.9424L74.0313 75.9233L73.9774 75.9424L73.8697 75.9614L73.8338 75.9804L73.7979 75.9424L73.7261 75.9233L73.6722 75.9614L73.5645 75.9424L73.6183 75.8093V75.7332L73.6542 75.6571L73.6183 75.543L73.5824 75.524L73.5645 75.448L73.6363 75.4099L73.6722 75.3909V75.2958L73.744 75.2578L73.8338 75.2768Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M309.889 112.012L309.943 112.05L309.925 112.125H309.979V112.163H309.835L309.781 112.069L309.817 112.012H309.889Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M303.01 111.901H303.046L303.226 112.053L303.315 112.11L303.477 112.244L303.459 112.301H303.423L303.387 112.339L303.351 112.282H303.333L303.297 112.244L303.279 112.168L303.208 112.149V112.091L303.154 112.072L303.136 112.091H303.1L302.938 112.015L302.902 111.939L302.956 111.863L303.01 111.901Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M309.641 111.612L309.605 111.669L309.551 111.631V111.593L309.605 111.555L309.641 111.612Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M309.227 110.871L309.245 110.89H309.299L309.281 110.966L309.191 111.004H309.137L309.065 111.023L308.993 111.137L308.975 111.08L308.921 111.099L308.885 111.061V111.004L308.975 110.985V110.947L309.029 110.871L309.155 110.89L309.227 110.871Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M304.5 110.351L304.553 110.332L304.661 110.389L304.751 110.484L304.805 110.541H304.841L304.877 110.579H304.913L304.966 110.636L305.02 110.617L305.092 110.636L305.128 110.674H305.2L305.254 110.655L305.29 110.712L305.326 110.864L305.379 110.922V111.017L305.344 111.055L305.361 111.112L305.29 111.074L305.236 111.112L305.182 111.093L305.092 111.036H305.056L304.948 110.998L304.877 110.979L304.841 110.922L304.787 110.883L304.733 110.864L304.697 110.807L304.625 110.769L304.661 110.693L304.643 110.617V110.541L304.607 110.522L304.5 110.484L304.446 110.503L304.428 110.465L304.446 110.408L304.464 110.351H304.5Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M305.218 109.695L305.2 109.733V109.866L305.164 109.828V109.733L305.218 109.695Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M304.705 109.355L304.759 109.527L304.795 109.603V109.679L304.813 109.774L304.777 109.831L304.705 109.698L304.687 109.755L304.633 109.66L304.651 109.47L304.669 109.432V109.374L304.705 109.355Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M303.191 109.396H303.245L303.299 109.377L303.371 109.396L303.389 109.377H303.478H303.622L303.658 109.434L303.712 109.453L303.748 109.51H303.784L303.82 109.529L303.891 109.605V109.719H303.927L303.999 109.757L304.017 109.814V109.929L303.999 109.948L303.874 109.986L303.838 110.005L303.766 109.986L303.694 109.948H303.622L303.604 109.91L303.514 109.853H303.407L303.317 109.872H303.227L303.137 109.853L303.083 109.814L303.03 109.834L302.976 109.757L302.922 109.719L302.868 109.567L302.832 109.491L302.868 109.453L302.85 109.415V109.282L302.868 109.225L302.976 109.168L303.047 109.206L303.119 109.301L303.137 109.358L303.191 109.396Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M303.604 108.934L303.694 109.029L303.64 109.086L303.586 109.048V109.029L303.604 108.934Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M303.604 108.935L303.568 109.011H303.551L303.479 108.954L303.425 108.973L303.389 108.954L303.371 108.916L303.425 108.897L303.461 108.859L303.551 108.878L303.604 108.935Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M302.418 108.84L302.436 108.878L302.472 108.897L302.436 108.973L302.365 109.011L302.311 108.935L302.418 108.84Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M300.893 108.499L300.929 108.556L300.911 108.613L300.768 108.537L300.857 108.48L300.893 108.499Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M301.507 108.64L301.453 108.602L301.471 108.545L301.525 108.488V108.583L301.543 108.621L301.507 108.64Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M301.344 108.307L301.38 108.288H301.452V108.326L301.38 108.383L301.416 108.421V108.478L301.344 108.554L301.308 108.573L301.254 108.554L301.182 108.478L301.2 108.364L301.254 108.345L301.29 108.269L301.344 108.25V108.307Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M300.694 108.335L300.658 108.354L300.622 108.449L300.694 108.544L300.604 108.506V108.468L300.586 108.411L300.514 108.335V108.297L300.586 108.259L300.604 108.202L300.676 108.145L300.73 108.183V108.259L300.694 108.335Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M303.012 108.238L303.048 108.276L303.03 108.314L302.994 108.295L302.887 108.2L302.923 108.124L302.976 108.105L303.012 108.143L302.994 108.2L303.012 108.238Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M304.184 108.073L304.256 108.225L304.364 108.377V108.434L304.292 108.472V108.567V108.624L304.31 108.662H304.346L304.382 108.719L304.472 108.795L304.489 108.89L304.507 108.947L304.543 108.985L304.507 109.023L304.561 109.08L304.543 109.099L304.561 109.195L304.525 109.233L304.579 109.29L304.597 109.385L304.633 109.48V109.594L304.615 109.613L304.561 109.556L304.507 109.461V109.404L304.454 109.328L304.382 109.271L304.328 109.214L304.238 109.099L304.166 109.042L304.112 108.871L304.076 108.681L304.041 108.548V108.453L304.023 108.377L304.094 108.301L304.076 108.244L303.987 108.111L303.969 108.054L303.987 108.035L304.059 108.054L304.094 108.073L304.148 108.016L304.184 108.073Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M300.461 108.02L300.425 107.944L300.371 107.887H300.443L300.461 108.02Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M300.443 107.832L300.515 107.851L300.533 107.87L300.551 107.965H300.515L300.479 107.889L300.443 107.832Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M301.003 107.871L300.985 107.928H301.021H301.111L301.183 108.061V108.099L301.219 108.156L301.237 108.251L301.201 108.289V108.347L301.093 108.309L301.057 108.27H301.003L300.931 108.213L300.913 108.175L300.895 108.118L300.967 108.137L300.913 107.985L300.895 107.947L300.806 107.966L300.77 107.985H300.698L300.644 108.061L300.572 108.023V107.909L300.608 107.871H300.68V107.795L300.752 107.681L300.824 107.624L300.878 107.586L300.949 107.643L300.985 107.719L300.967 107.852L301.003 107.871Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M299.941 107.87H299.923L299.887 107.719L299.905 107.662V107.586L299.941 107.605L299.958 107.681V107.813L299.941 107.87Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M300.554 107.776L300.5 107.814L300.482 107.795H300.41L300.356 107.738L300.338 107.681L300.32 107.624L300.338 107.567L300.392 107.491L300.482 107.453L300.518 107.491L300.572 107.586V107.7L300.554 107.776Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M300.012 107.113L300.084 107.208V107.227L300.21 107.303L300.192 107.36L300.084 107.494V107.551L300.03 107.57V107.494H299.994V107.418L299.958 107.341L299.905 107.303L299.887 107.246L299.905 107.189L299.941 107.151L299.976 107.113H300.012Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M301.859 107.132L301.913 107.17L301.877 107.189L301.788 107.208L301.77 107.151L301.806 107.113L301.859 107.132Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M302.024 107.123L302.06 107.104L302.15 107.161L302.204 107.18L302.24 107.219L302.293 107.314L302.347 107.333L302.401 107.39V107.447L302.491 107.466V107.523L302.545 107.542L302.599 107.523L302.617 107.542L302.689 107.58L302.706 107.618L302.76 107.599L302.814 107.618L302.832 107.675L302.904 107.732L302.958 107.789L303.03 107.846L303.209 108.036L303.155 108.112L303.209 108.207L303.227 108.321L303.173 108.302L303.119 108.226L302.994 108.074L302.922 108.055L302.832 107.979L302.724 107.96L302.706 107.903L302.599 107.865L302.509 107.77H302.473L302.329 107.656L302.24 107.599V107.561L302.168 107.523L302.132 107.485L302.096 107.409L302.024 107.352L302.006 107.314V107.238L301.934 107.142L301.898 107.123V107.066L302.024 107.123Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M301.756 107.012L301.792 107.05L301.828 107.031L301.882 107.069L301.864 107.107L301.81 107.088L301.756 107.012Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M300.945 106.906H301.036L300.999 106.944L300.945 106.925V106.906Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M301.716 106.906L301.68 107.002L301.662 106.963L301.716 106.906Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M301.233 106.97L301.143 106.989L301.107 106.951L301.161 106.875L301.215 106.894L301.233 106.97Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M298.986 106.809L299.022 106.866L298.986 106.904L298.932 106.885L298.914 106.866L298.986 106.809Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M299.263 106.447L299.317 106.485L299.299 106.542L299.173 106.58L299.119 106.523L299.173 106.41L299.209 106.391L299.263 106.447Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M299.567 106.273V106.369L299.531 106.331V106.292L299.567 106.273Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M300.089 105.991L300.143 106.01L300.215 106.105L300.269 106.143L300.322 106.162L300.376 106.219L300.52 106.295L300.592 106.39V106.466L300.61 106.58L300.646 106.618L300.699 106.675H300.735L300.753 106.751L300.879 106.808L300.951 106.789L300.969 106.808V106.865L300.915 106.884L300.879 106.941L300.789 106.903L300.646 106.827H300.556L300.502 106.751L300.376 106.675L300.269 106.485L300.161 106.295L300.071 106.238L299.945 106.105V106.01V105.972L299.999 105.934L300.053 105.953L300.089 105.991Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M147.76 97.7782H147.724L147.688 97.8353H147.652L147.634 97.7592L147.598 97.6071V97.55L147.67 97.455L147.724 97.4359L147.778 97.3789L147.85 97.3979L147.886 97.474L147.904 97.531L147.886 97.6071L147.85 97.6641L147.796 97.7402L147.76 97.7782Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M148.592 95.9145L148.574 95.9714L148.538 95.9903L148.484 95.9714V95.9145L148.52 95.8956V95.8387L148.556 95.8008L148.61 95.8197L148.592 95.9145Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M77.78 75.8542V75.8724L77.7109 75.8542V75.8359L77.78 75.8542Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M188.18 109.335L188.126 109.373H188.036L187.964 109.411H187.893V109.373H187.982L188.054 109.354L188.126 109.297H188.162L188.18 109.335Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M188.094 109.285L188.058 109.304H187.986V109.266L188.094 109.285Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M197.409 103.514L197.481 103.59L197.445 103.647L197.409 103.59L197.355 103.552L197.391 103.457L197.409 103.514Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M69.4304 71.2109H69.556L69.6099 71.2868H69.556L69.5022 71.2678L69.4125 71.2868L69.3945 71.2299L69.4304 71.2109Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M68.9542 71.1914L69.008 71.2672L69.1157 71.2483L69.0798 71.2862H68.9722L68.9004 71.2483L68.9542 71.1914Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M69.3423 71.0737V71.1687L69.2524 71.1307L69.2344 71.0737L69.2524 71.0547L69.3423 71.0737Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M79.329 84.6328L79.293 84.7279L79.2392 84.8039L79.2033 84.823L79.1853 84.899L79.2212 85.0131L79.1853 85.0321V85.1652L79.2212 85.2223L79.2571 85.2603L79.2212 85.2983L79.2033 85.3554V85.4885L79.1674 85.5075L79.0955 85.5455L79.0057 85.5646H78.9519L78.8621 85.5836L78.7723 85.5646L78.7005 85.5836L78.6466 85.5646L78.5568 85.6026L78.485 85.5646H78.3773L78.3234 85.6026L78.2695 85.5836L78.3593 85.5455L78.4132 85.4885L78.485 85.4695L78.5568 85.4124L78.5927 85.3554L78.7005 85.3744L78.7543 85.2983L78.7184 85.1462L78.7543 85.0702V84.9751V84.9371L78.7005 84.861L78.6466 84.842L78.5748 84.823L78.5568 84.8039L78.6287 84.7469L78.8262 84.7279L78.8621 84.6899H79.0596L79.0776 84.6708L79.293 84.6328H79.329Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M79.7589 84.0273L79.741 84.1224L79.6871 84.1414L79.6154 84.1985H79.5795L79.4539 84.2745L79.418 84.2365L79.4718 84.1795L79.5974 84.0844L79.7589 84.0273Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M79.217 81.8239L79.1991 81.8429L79.1094 81.786V81.7102L79.1453 81.6534L79.1812 81.5586H79.2529L79.2709 81.6344L79.2529 81.786L79.217 81.8239Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M76.3298 75.351L76.2579 75.389H76.2399L76.1859 75.427L76.168 75.408L76.1859 75.351L76.2938 75.332L76.3298 75.351Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M76.0463 76.1902L76.1001 76.2471L75.9027 76.285L75.8848 76.1902L76.0104 76.1523L76.0463 76.1902Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M76.1708 75.4721L76.1348 75.5101H76.0449V75.4721L76.0989 75.4531L76.1708 75.4721Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M75.9143 75.4297L75.9861 75.4866L75.9502 75.5245L75.8964 75.4866H75.8066L75.8425 75.4486L75.9143 75.4297Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M310.787 122.586L310.697 122.548L310.733 122.472L310.823 122.453L310.859 122.529L310.841 122.567L310.787 122.586Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M310.573 121.864H310.537L310.483 121.845L310.411 121.75L310.393 121.674V121.598L310.429 121.56L310.447 121.484L310.501 121.465H310.573L310.537 121.522V121.617L310.663 121.712L310.609 121.769L310.573 121.864Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M310.571 120.742H310.625L310.643 120.781L310.553 120.8L310.571 120.857L310.643 120.895L310.661 120.952L310.643 121.028L310.571 121.047L310.499 120.99H310.428L310.392 120.952L310.338 120.914L310.356 120.838V120.781L310.392 120.685L310.446 120.609H310.535L310.571 120.628L310.553 120.704L310.571 120.742Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M310.032 119.296L310.14 119.277L310.158 119.296L310.193 119.41L310.229 119.467L310.247 119.487L310.176 119.601L310.032 119.639L309.978 119.582L309.96 119.487L309.906 119.467L309.834 119.525L309.816 119.506L309.852 119.429L309.924 119.372L309.996 119.277L310.032 119.296Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M310.447 118.559L310.43 118.504H310.482L310.447 118.559Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M310.158 118.102L310.176 118.197V118.235L310.248 118.254L310.284 118.349H310.374V118.425L310.356 118.444L310.302 118.387L310.248 118.368L310.14 118.406L310.087 118.387L310.069 118.349L310.051 118.273L310.087 118.178L310.123 118.121L310.158 118.102Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M310.324 118.063H310.306L310.289 118.008H310.324V118.063Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M310.355 117.793L310.319 117.831H310.211L310.157 117.85L310.121 117.812L310.049 117.793L309.959 117.717L309.977 117.679L310.067 117.641L310.139 117.622L310.211 117.565L310.229 117.508H310.265L310.283 117.565V117.679L310.373 117.755L310.355 117.793Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M309.515 117.55L309.551 117.607L309.659 117.683L309.785 117.817L309.803 117.836V117.912L309.839 117.969L309.785 118.007L309.713 118.083V118.045L309.659 118.026H309.587L309.551 118.045V118.083L309.48 118.121L309.426 118.102V117.969L309.408 117.855L309.426 117.74L309.444 117.645L309.408 117.55L309.3 117.607L309.264 117.569L309.246 117.512V117.455L309.3 117.398V117.322L309.318 117.265L309.372 117.246L309.48 117.303L309.462 117.341L309.497 117.436L309.48 117.474L309.515 117.55Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M309.404 117.086H309.35L309.26 117.029V117.01L309.296 116.953L309.332 116.934L309.422 116.953L309.404 117.029V117.086Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M309.314 116.905L309.386 116.848L309.404 116.867L309.422 116.924H309.332L309.314 116.905Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M310.341 117.397L310.305 117.378L310.323 117.149L310.305 117.092L310.323 116.997L310.377 116.845L310.395 116.75L310.431 116.864L310.413 116.921V117.035V117.225L310.395 117.339L310.341 117.397Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M310.107 116.771H309.982L309.928 116.752V116.714L310.089 116.58L310.179 116.542L310.269 116.523V116.561L310.215 116.638L310.179 116.695L310.107 116.771Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M310.447 116.638V116.676H310.393L310.411 116.619L310.447 116.372V116.353L310.465 116.125L310.501 116.144L310.483 116.391L310.501 116.448L310.483 116.543L310.447 116.638Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M309.31 116.902L309.149 116.883L309.041 116.94L309.023 116.978H308.987L308.969 116.864L308.933 116.845L308.861 116.655L308.933 116.503V116.427L308.915 116.389V116.122L308.897 116.065V115.97L308.933 115.913V115.856L308.969 115.799V115.761L309.023 115.742L309.041 115.837L309.077 115.913L309.113 115.97L309.131 116.218L309.113 116.37V116.389L309.22 116.37L309.274 116.313L309.31 116.161V116.122L309.364 116.084L309.418 116.103L309.4 116.18V116.351L309.454 116.37V116.465L309.418 116.484L309.472 116.56L309.436 116.598V116.693L309.472 116.788L309.454 116.826H309.4L309.31 116.902Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M310.071 115.133L310.143 115.19L310.125 115.265L310.071 115.322L310.035 115.36H309.928V115.284L309.946 115.209L309.982 115.152L310.071 115.133Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M310.174 114.768L310.12 114.806L310.084 114.825V114.863L310.048 114.882V114.825L310.012 114.787L309.994 114.73L310.012 114.655L310.048 114.636L310.12 114.598L310.138 114.636L310.156 114.711V114.73L310.174 114.768Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M309.278 113.977L309.26 113.958L309.278 113.863L309.314 113.901L309.278 113.977Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M72.0042 83.186H71.9682L71.9502 83.091L71.9682 83.0339L71.9502 82.9769L71.8782 82.9578L71.8242 82.9008L71.8422 82.8438L72.0582 82.9578L72.0402 82.9959V83.0719L72.0042 83.11V83.186Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M77.8002 76.5365L77.7656 76.5548V76.5183L77.7829 76.5L77.8002 76.5365Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M77.5274 76.3653H77.5098L77.5274 76.3281L77.545 76.3467L77.5274 76.3653Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M79.545 79.8211V79.8592L79.617 79.8401L79.581 79.9352L79.617 79.9732V80.0113L79.653 80.0493L79.689 80.2204L79.635 80.2775L79.617 80.2014L79.599 80.2204L79.491 80.2014H79.419L79.383 80.1444L79.491 80.0493H79.419L79.347 79.9732L79.329 79.8782L79.293 79.7831L79.347 79.707L79.419 79.726L79.509 79.7831L79.545 79.8211Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M123.428 63.943L123.374 64.0378L123.302 64.1325L123.248 64.0567H123.177L123.141 64.0188L123.177 63.962L123.248 63.9809L123.32 63.9051L123.374 63.8672L123.41 63.8861L123.428 63.943Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M125.868 63.5034V63.5985L125.904 63.6745L125.868 63.8076L125.886 63.8647L125.814 63.9407L125.724 63.9788L125.689 64.0168L125.581 63.9788L125.491 63.8837L125.455 63.8076V63.6935L125.563 63.6175L125.581 63.5224V63.4844L125.689 63.5034H125.76L125.814 63.5224L125.868 63.5034Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M124.09 63.6571H124.055L124.001 63.6192L123.965 63.5624L123.983 63.4865L124.001 63.4297H124.055H124.108L124.198 63.5055L124.216 63.5624L124.126 63.6571H124.09Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M125.19 62.9917V63.0297L125.083 63.0867L125.011 63.1818L124.957 63.2199V63.2959L124.885 63.429L124.867 63.5051L124.777 63.6192L124.76 63.6572H124.724L124.616 63.6952L124.598 63.6762L124.58 63.6002L124.526 63.5241L124.508 63.4861L124.472 63.429V63.372L124.4 63.2579L124.49 63.2008L124.544 63.2389L124.652 63.2008H124.724L124.813 63.1628L124.903 63.0867V63.0487L125.011 62.9917H125.119L125.173 62.9727L125.19 62.9917Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M127.019 63.5223L126.965 63.5984L126.893 63.6174L126.839 63.5984H126.768V63.5604H126.821L126.929 63.5223L127.001 63.4653L127.055 63.4082L127.073 63.3132L127.091 63.2561L127.127 63.161L127.181 63.085L127.234 62.9709L127.27 62.8188L127.306 62.7807L127.378 62.7617L127.432 62.8188L127.45 62.9138L127.432 63.0089L127.414 63.104V63.1991L127.396 63.2181L127.342 63.3512L127.288 63.4082L127.181 63.4273L127.055 63.4843L127.019 63.5223Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M123.501 62.6675L123.555 62.6484L123.591 62.7055L123.627 62.8006L123.591 62.8576L123.609 62.9337L123.501 63.1238L123.483 63.1048L123.465 63.0287L123.393 62.8576L123.375 62.8006L123.357 62.7625L123.393 62.6865L123.447 62.6484L123.501 62.6675Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M127.831 62.2899V62.3659L127.795 62.461L127.669 62.5561L127.58 62.5751L127.508 62.6702L127.418 62.6321V62.6131L127.454 62.5371V62.461L127.49 62.404L127.544 62.3659H127.598L127.651 62.3089H127.741L127.759 62.2899L127.795 62.1948L127.831 62.1758L127.867 62.2138L127.831 62.2899Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M186.599 113.32L186.635 113.377L186.725 113.415V113.472L186.689 113.51L186.707 113.548L186.653 113.663L186.671 113.701L186.617 113.72L186.581 113.663V113.606L186.617 113.568L186.581 113.434L186.563 113.415L186.545 113.377L186.599 113.32Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M196.438 123.352H196.51L196.581 123.39L196.635 123.447V123.504L196.653 123.599L196.707 123.637L196.743 123.675L196.761 123.713L196.725 123.827L196.707 123.903L196.671 123.941L196.599 123.96H196.438L196.402 123.922L196.258 123.846L196.204 123.751V123.694L196.15 123.58L196.168 123.504L196.204 123.466L196.24 123.39H196.258L196.348 123.352H196.438Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M79.3575 78.4952H79.3035L79.2676 78.4192L79.2856 78.3812L79.3395 78.3242L79.3935 78.3622L79.4114 78.4192V78.4572L79.3575 78.4952Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M79.0437 77.9974H79.0977V78.0355V78.0545L79.0617 78.0735V78.2256V78.3017L79.0257 78.3397L78.9177 78.3967V78.3587L78.8817 78.3207L78.8637 78.2256V78.1305L78.8457 78.0355V77.9784L78.8817 77.9214L78.9357 77.9023L79.0257 77.9594L79.0437 77.9974Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M79.2989 77.9201L79.3707 77.9391L79.4604 78.0152L79.2272 78.0722L79.1733 78.0912L79.1016 78.0342L79.1195 77.9201L79.1554 77.9011L79.1375 77.787L79.1554 77.749L79.2092 77.7109L79.2631 77.787V77.8631L79.2989 77.9201Z",
      "fill": "#EBECED",
      "stroke": "#B0B5B7",
      "stroke-width": "0.0330279",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M65.0762 23.5547C70.599 23.5547 75.0762 19.0775 75.0762 13.5547C75.0762 8.03184 70.599 3.55469 65.0762 3.55469C59.5533 3.55469 55.0762 8.03184 55.0762 13.5547C55.0762 19.0775 59.5533 23.5547 65.0762 23.5547ZM64.0762 9.55469C64.0762 9.0024 64.5239 8.55469 65.0762 8.55469C65.6285 8.55469 66.0762 9.0024 66.0762 9.55469C66.0762 10.107 65.6285 10.5547 65.0762 10.5547C64.5239 10.5547 64.0762 10.107 64.0762 9.55469ZM64.0762 13.5547C64.0762 13.0024 64.5239 12.5547 65.0762 12.5547C65.6285 12.5547 66.0762 13.0024 66.0762 13.5547V17.5547C66.0762 18.107 65.6285 18.5547 65.0762 18.5547C64.5239 18.5547 64.0762 18.107 64.0762 17.5547V13.5547Z",
      "fill": "#07B53B"
    }
  }), _c('path', {
    attrs: {
      "d": "M83.8066 7.50098H80.9697V6.7832H83.8066C84.3991 6.7832 84.8799 6.6875 85.249 6.49609C85.6227 6.30013 85.8939 6.03581 86.0625 5.70312C86.2357 5.37044 86.3223 4.99674 86.3223 4.58203C86.3223 4.17643 86.2357 3.80273 86.0625 3.46094C85.8939 3.11914 85.6227 2.8457 85.249 2.64062C84.8799 2.43099 84.3991 2.32617 83.8066 2.32617H81.2637V11.5547H80.4229V1.60156H83.8066C84.5358 1.60156 85.1488 1.72689 85.6455 1.97754C86.1468 2.22819 86.5251 2.57682 86.7803 3.02344C87.0355 3.47005 87.1631 3.98503 87.1631 4.56836C87.1631 5.17904 87.0355 5.7054 86.7803 6.14746C86.5251 6.58496 86.1491 6.91992 85.6523 7.15234C85.1556 7.38477 84.5404 7.50098 83.8066 7.50098ZM88.3115 7.97266V7.74707C88.3115 7.20931 88.389 6.71257 88.5439 6.25684C88.6989 5.80111 88.9199 5.4069 89.207 5.07422C89.4987 4.74154 89.8473 4.48405 90.2529 4.30176C90.6585 4.11491 91.1097 4.02148 91.6064 4.02148C92.1077 4.02148 92.5612 4.11491 92.9668 4.30176C93.3724 4.48405 93.721 4.74154 94.0127 5.07422C94.3044 5.4069 94.5277 5.80111 94.6826 6.25684C94.8376 6.71257 94.915 7.20931 94.915 7.74707V7.97266C94.915 8.51042 94.8376 9.00716 94.6826 9.46289C94.5277 9.91406 94.3044 10.306 94.0127 10.6387C93.7256 10.9714 93.3792 11.2311 92.9736 11.418C92.568 11.6003 92.1169 11.6914 91.6201 11.6914C91.1188 11.6914 90.6654 11.6003 90.2598 11.418C89.8542 11.2311 89.5055 10.9714 89.2139 10.6387C88.9222 10.306 88.6989 9.91406 88.5439 9.46289C88.389 9.00716 88.3115 8.51042 88.3115 7.97266ZM89.125 7.74707V7.97266C89.125 8.37826 89.1797 8.76335 89.2891 9.12793C89.3984 9.48796 89.5579 9.80924 89.7676 10.0918C89.9772 10.3698 90.237 10.5885 90.5469 10.748C90.8568 10.9076 91.2145 10.9873 91.6201 10.9873C92.0212 10.9873 92.3743 10.9076 92.6797 10.748C92.9896 10.5885 93.2493 10.3698 93.459 10.0918C93.6686 9.80924 93.8258 9.48796 93.9307 9.12793C94.04 8.76335 94.0947 8.37826 94.0947 7.97266V7.74707C94.0947 7.34603 94.04 6.96549 93.9307 6.60547C93.8258 6.24544 93.6663 5.92415 93.4521 5.6416C93.2425 5.35905 92.9827 5.13574 92.6729 4.97168C92.363 4.80762 92.0075 4.72559 91.6064 4.72559C91.2054 4.72559 90.8499 4.80762 90.54 4.97168C90.2347 5.13574 89.9749 5.35905 89.7607 5.6416C89.5511 5.92415 89.3916 6.24544 89.2822 6.60547C89.1774 6.96549 89.125 7.34603 89.125 7.74707ZM101.416 10.1191V1.05469H102.236V11.5547H101.471L101.416 10.1191ZM96.2822 7.93164V7.78809C96.2822 7.21387 96.3483 6.69661 96.4805 6.23633C96.6126 5.77148 96.8018 5.375 97.0479 5.04688C97.2985 4.71419 97.5993 4.46126 97.9502 4.28809C98.3011 4.11035 98.6976 4.02148 99.1396 4.02148C99.5726 4.02148 99.9554 4.09212 100.288 4.2334C100.621 4.37467 100.906 4.57747 101.143 4.8418C101.384 5.10612 101.578 5.42057 101.724 5.78516C101.874 6.14974 101.983 6.55534 102.052 7.00195V8.82715C101.997 9.24642 101.897 9.63151 101.751 9.98242C101.605 10.3288 101.411 10.6318 101.17 10.8916C100.928 11.1468 100.637 11.3451 100.295 11.4863C99.9577 11.623 99.568 11.6914 99.126 11.6914C98.6885 11.6914 98.2943 11.6003 97.9434 11.418C97.5924 11.2357 97.2939 10.9782 97.0479 10.6455C96.8018 10.3083 96.6126 9.90951 96.4805 9.44922C96.3483 8.98893 96.2822 8.48307 96.2822 7.93164ZM97.1025 7.78809V7.93164C97.1025 8.36458 97.1458 8.76562 97.2324 9.13477C97.319 9.50391 97.4512 9.8252 97.6289 10.0986C97.8066 10.3721 98.0322 10.5863 98.3057 10.7412C98.5791 10.8962 98.9027 10.9736 99.2764 10.9736C99.7458 10.9736 100.14 10.8848 100.459 10.707C100.778 10.5247 101.033 10.2855 101.225 9.98926C101.416 9.68848 101.555 9.36035 101.642 9.00488V6.87891C101.587 6.63737 101.507 6.39128 101.402 6.14062C101.298 5.88997 101.154 5.65983 100.972 5.4502C100.794 5.236 100.566 5.0651 100.288 4.9375C100.015 4.80534 99.682 4.73926 99.29 4.73926C98.9118 4.73926 98.5859 4.81673 98.3125 4.97168C98.0391 5.12663 97.8112 5.3431 97.6289 5.62109C97.4512 5.89453 97.319 6.21582 97.2324 6.58496C97.1458 6.9541 97.1025 7.35514 97.1025 7.78809ZM109.257 4.1582H110.016V11.4248C110.016 12.0674 109.893 12.6188 109.646 13.0791C109.405 13.5394 109.061 13.8926 108.614 14.1387C108.172 14.3848 107.65 14.5078 107.049 14.5078C106.743 14.5078 106.429 14.46 106.105 14.3643C105.786 14.2731 105.483 14.1318 105.196 13.9404C104.914 13.7536 104.672 13.5212 104.472 13.2432L104.93 12.7441C105.23 13.1087 105.552 13.3753 105.894 13.5439C106.235 13.7171 106.604 13.8037 107.001 13.8037C107.47 13.8037 107.867 13.7103 108.19 13.5234C108.519 13.3366 108.767 13.0677 108.936 12.7168C109.109 12.3659 109.195 11.9443 109.195 11.4521V5.78516L109.257 4.1582ZM104.062 7.93164V7.78809C104.062 7.21387 104.125 6.69661 104.253 6.23633C104.385 5.77148 104.574 5.375 104.82 5.04688C105.066 4.71419 105.365 4.46126 105.716 4.28809C106.071 4.11035 106.472 4.02148 106.919 4.02148C107.347 4.02148 107.728 4.09212 108.061 4.2334C108.393 4.37467 108.68 4.57747 108.922 4.8418C109.163 5.10612 109.357 5.42057 109.503 5.78516C109.653 6.14974 109.763 6.55534 109.831 7.00195V8.82715C109.776 9.24642 109.676 9.63151 109.53 9.98242C109.384 10.3288 109.191 10.6318 108.949 10.8916C108.708 11.1468 108.416 11.3451 108.074 11.4863C107.737 11.623 107.347 11.6914 106.905 11.6914C106.463 11.6914 106.067 11.6003 105.716 11.418C105.365 11.2357 105.066 10.9782 104.82 10.6455C104.574 10.3083 104.385 9.90951 104.253 9.44922C104.125 8.98893 104.062 8.48307 104.062 7.93164ZM104.882 7.78809V7.93164C104.882 8.36458 104.925 8.76562 105.012 9.13477C105.098 9.50391 105.23 9.8252 105.408 10.0986C105.586 10.3721 105.812 10.5863 106.085 10.7412C106.358 10.8962 106.68 10.9736 107.049 10.9736C107.518 10.9736 107.912 10.8848 108.231 10.707C108.55 10.5247 108.803 10.2855 108.99 9.98926C109.177 9.68848 109.314 9.36035 109.4 9.00488V6.87891C109.35 6.63737 109.273 6.39128 109.168 6.14062C109.068 5.88997 108.926 5.65983 108.744 5.4502C108.566 5.236 108.339 5.0651 108.061 4.9375C107.787 4.80534 107.454 4.73926 107.062 4.73926C106.689 4.73926 106.363 4.81673 106.085 4.97168C105.812 5.12663 105.586 5.3431 105.408 5.62109C105.23 5.89453 105.098 6.21582 105.012 6.58496C104.925 6.9541 104.882 7.35514 104.882 7.78809ZM111.704 7.97266V7.74707C111.704 7.20931 111.782 6.71257 111.937 6.25684C112.091 5.80111 112.312 5.4069 112.6 5.07422C112.891 4.74154 113.24 4.48405 113.646 4.30176C114.051 4.11491 114.502 4.02148 114.999 4.02148C115.5 4.02148 115.954 4.11491 116.359 4.30176C116.765 4.48405 117.114 4.74154 117.405 5.07422C117.697 5.4069 117.92 5.80111 118.075 6.25684C118.23 6.71257 118.308 7.20931 118.308 7.74707V7.97266C118.308 8.51042 118.23 9.00716 118.075 9.46289C117.92 9.91406 117.697 10.306 117.405 10.6387C117.118 10.9714 116.772 11.2311 116.366 11.418C115.961 11.6003 115.509 11.6914 115.013 11.6914C114.511 11.6914 114.058 11.6003 113.652 11.418C113.247 11.2311 112.898 10.9714 112.606 10.6387C112.315 10.306 112.091 9.91406 111.937 9.46289C111.782 9.00716 111.704 8.51042 111.704 7.97266ZM112.518 7.74707V7.97266C112.518 8.37826 112.572 8.76335 112.682 9.12793C112.791 9.48796 112.951 9.80924 113.16 10.0918C113.37 10.3698 113.63 10.5885 113.939 10.748C114.249 10.9076 114.607 10.9873 115.013 10.9873C115.414 10.9873 115.767 10.9076 116.072 10.748C116.382 10.5885 116.642 10.3698 116.852 10.0918C117.061 9.80924 117.218 9.48796 117.323 9.12793C117.433 8.76335 117.487 8.37826 117.487 7.97266V7.74707C117.487 7.34603 117.433 6.96549 117.323 6.60547C117.218 6.24544 117.059 5.92415 116.845 5.6416C116.635 5.35905 116.375 5.13574 116.065 4.97168C115.756 4.80762 115.4 4.72559 114.999 4.72559C114.598 4.72559 114.243 4.80762 113.933 4.97168C113.627 5.13574 113.368 5.35905 113.153 5.6416C112.944 5.92415 112.784 6.24544 112.675 6.60547C112.57 6.96549 112.518 7.34603 112.518 7.74707ZM120.816 5.38184V11.5547H120.003V4.1582H120.796L120.816 5.38184ZM123.435 4.10352L123.414 4.85547C123.323 4.8418 123.234 4.8304 123.147 4.82129C123.061 4.81217 122.967 4.80762 122.867 4.80762C122.512 4.80762 122.2 4.8737 121.931 5.00586C121.666 5.13346 121.443 5.31348 121.261 5.5459C121.078 5.77376 120.939 6.04264 120.844 6.35254C120.748 6.65788 120.693 6.986 120.68 7.33691L120.379 7.45312C120.379 6.97005 120.429 6.52116 120.529 6.10645C120.63 5.69173 120.782 5.32943 120.987 5.01953C121.197 4.70508 121.459 4.46126 121.773 4.28809C122.092 4.11035 122.466 4.02148 122.895 4.02148C122.999 4.02148 123.102 4.0306 123.202 4.04883C123.307 4.0625 123.384 4.08073 123.435 4.10352ZM125.629 4.1582V11.5547H124.815V4.1582H125.629ZM124.672 2.01855C124.672 1.86361 124.72 1.73372 124.815 1.62891C124.916 1.51953 125.052 1.46484 125.226 1.46484C125.399 1.46484 125.535 1.51953 125.636 1.62891C125.741 1.73372 125.793 1.86361 125.793 2.01855C125.793 2.16895 125.741 2.29883 125.636 2.4082C125.535 2.51302 125.399 2.56543 125.226 2.56543C125.052 2.56543 124.916 2.51302 124.815 2.4082C124.72 2.29883 124.672 2.16895 124.672 2.01855ZM130.592 10.9873C130.938 10.9873 131.262 10.9235 131.562 10.7959C131.868 10.6637 132.118 10.4701 132.314 10.2148C132.515 9.95508 132.629 9.63835 132.656 9.26465H133.436C133.413 9.73405 133.269 10.1533 133.005 10.5225C132.745 10.887 132.403 11.1742 131.979 11.3838C131.56 11.5889 131.098 11.6914 130.592 11.6914C130.077 11.6914 129.621 11.598 129.225 11.4111C128.833 11.2243 128.505 10.9645 128.24 10.6318C127.976 10.2946 127.775 9.90267 127.639 9.45605C127.507 9.00488 127.44 8.51953 127.44 8V7.71289C127.44 7.19336 127.507 6.71029 127.639 6.26367C127.775 5.8125 127.976 5.42057 128.24 5.08789C128.505 4.75065 128.833 4.48861 129.225 4.30176C129.617 4.11491 130.07 4.02148 130.585 4.02148C131.114 4.02148 131.588 4.12858 132.007 4.34277C132.431 4.55697 132.768 4.86003 133.019 5.25195C133.274 5.64388 133.413 6.10872 133.436 6.64648H132.656C132.633 6.25 132.529 5.9082 132.342 5.62109C132.155 5.33398 131.909 5.11296 131.604 4.95801C131.298 4.80306 130.959 4.72559 130.585 4.72559C130.166 4.72559 129.808 4.80762 129.512 4.97168C129.215 5.13118 128.974 5.35221 128.787 5.63477C128.605 5.91276 128.47 6.23177 128.384 6.5918C128.297 6.94727 128.254 7.32096 128.254 7.71289V8C128.254 8.39648 128.295 8.77474 128.377 9.13477C128.464 9.49023 128.598 9.80697 128.78 10.085C128.967 10.363 129.209 10.584 129.505 10.748C129.806 10.9076 130.168 10.9873 130.592 10.9873ZM139.581 10.2285V6.41406C139.581 6.06315 139.508 5.76009 139.362 5.50488C139.216 5.24967 139.002 5.05371 138.72 4.91699C138.437 4.78027 138.089 4.71191 137.674 4.71191C137.291 4.71191 136.949 4.78027 136.648 4.91699C136.352 5.04915 136.118 5.22917 135.944 5.45703C135.776 5.68034 135.691 5.92871 135.691 6.20215L134.871 6.19531C134.871 5.91732 134.939 5.64844 135.076 5.38867C135.213 5.12891 135.407 4.89648 135.657 4.69141C135.908 4.48633 136.206 4.32454 136.553 4.20605C136.904 4.08301 137.289 4.02148 137.708 4.02148C138.237 4.02148 138.701 4.11035 139.103 4.28809C139.508 4.46582 139.825 4.73242 140.053 5.08789C140.281 5.44336 140.395 5.88997 140.395 6.42773V10.0029C140.395 10.2581 140.413 10.5225 140.449 10.7959C140.49 11.0693 140.547 11.2949 140.62 11.4727V11.5547H139.752C139.697 11.3906 139.654 11.1855 139.622 10.9395C139.595 10.6888 139.581 10.4518 139.581 10.2285ZM139.772 7.24805L139.786 7.87695H138.18C137.76 7.87695 137.384 7.91569 137.052 7.99316C136.724 8.06608 136.446 8.17546 136.218 8.32129C135.99 8.46257 135.814 8.63346 135.691 8.83398C135.573 9.03451 135.514 9.26237 135.514 9.51758C135.514 9.7819 135.58 10.0234 135.712 10.2422C135.849 10.4609 136.04 10.6364 136.286 10.7686C136.537 10.8962 136.833 10.96 137.175 10.96C137.631 10.96 138.032 10.8757 138.378 10.707C138.729 10.5384 139.018 10.3174 139.246 10.0439C139.474 9.77051 139.627 9.47201 139.704 9.14844L140.06 9.62012C140 9.84798 139.891 10.0827 139.731 10.3242C139.576 10.5612 139.374 10.7845 139.123 10.9941C138.872 11.1992 138.576 11.3678 138.234 11.5C137.897 11.6276 137.514 11.6914 137.086 11.6914C136.603 11.6914 136.181 11.6003 135.821 11.418C135.466 11.2357 135.188 10.9873 134.987 10.6729C134.791 10.3538 134.693 9.99382 134.693 9.59277C134.693 9.22819 134.771 8.90234 134.926 8.61523C135.081 8.32357 135.304 8.07747 135.596 7.87695C135.892 7.67188 136.247 7.51693 136.662 7.41211C137.081 7.30273 137.551 7.24805 138.07 7.24805H139.772ZM143.375 10.2627V11.2197C143.375 11.639 143.288 12.0423 143.115 12.4297C142.942 12.8216 142.707 13.152 142.411 13.4209L141.933 13.0654C142.074 12.874 142.192 12.6826 142.288 12.4912C142.384 12.3044 142.454 12.1084 142.5 11.9033C142.55 11.6982 142.575 11.4772 142.575 11.2402V10.2627H143.375ZM81.7217 14.6016H82.9111L84.668 22.7021L89.2275 14.6016H90.54L84.8867 24.5547H83.9092L81.7217 14.6016ZM81.291 14.6016H82.3916L81.5166 20.7129L80.8467 24.5547H79.5615L81.291 14.6016ZM89.8018 14.6016H90.9092L89.1797 24.5547H87.9014L88.585 20.6035L89.8018 14.6016ZM91.5518 20.9795L91.5723 20.8223C91.627 20.3255 91.75 19.847 91.9414 19.3867C92.1374 18.9264 92.3949 18.5163 92.7139 18.1562C93.0329 17.7962 93.4111 17.5137 93.8486 17.3086C94.2861 17.1035 94.7738 17.0078 95.3115 17.0215C95.8311 17.0306 96.2754 17.1423 96.6445 17.3564C97.0182 17.5706 97.319 17.8555 97.5469 18.2109C97.7793 18.5618 97.9411 18.9583 98.0322 19.4004C98.1234 19.8424 98.1462 20.2982 98.1006 20.7676L98.0869 20.9248C98.0277 21.4215 97.9001 21.8978 97.7041 22.3535C97.5081 22.8092 97.2484 23.2148 96.9248 23.5703C96.6058 23.9258 96.2275 24.2061 95.79 24.4111C95.3525 24.6117 94.8672 24.7051 94.334 24.6914C93.819 24.6823 93.3747 24.5729 93.001 24.3633C92.6318 24.1491 92.3333 23.8665 92.1055 23.5156C91.8776 23.1647 91.7181 22.7705 91.627 22.333C91.5358 21.8955 91.5107 21.4443 91.5518 20.9795ZM92.8027 20.8223L92.7891 20.9863C92.7572 21.2734 92.7549 21.5719 92.7822 21.8818C92.8141 22.1917 92.887 22.4788 93.001 22.7432C93.1195 23.0075 93.2904 23.224 93.5137 23.3926C93.737 23.5612 94.0264 23.6501 94.3818 23.6592C94.7601 23.6683 95.0928 23.5954 95.3799 23.4404C95.667 23.2809 95.9108 23.0667 96.1113 22.7979C96.3164 22.529 96.4782 22.2305 96.5967 21.9023C96.7197 21.5742 96.8018 21.2484 96.8428 20.9248L96.8564 20.7676C96.8883 20.4805 96.8883 20.182 96.8564 19.8721C96.8291 19.5576 96.7562 19.266 96.6377 18.9971C96.5238 18.7236 96.3551 18.5026 96.1318 18.334C95.9085 18.1608 95.6191 18.0697 95.2637 18.0605C94.8854 18.0469 94.5505 18.1221 94.2588 18.2861C93.9717 18.4456 93.7279 18.6621 93.5273 18.9355C93.3268 19.209 93.165 19.512 93.042 19.8447C92.9235 20.1729 92.8438 20.4987 92.8027 20.8223ZM101.218 18.8125L100.22 24.5547H98.9824L100.268 17.1582H101.437L101.218 18.8125ZM100.644 20.5762L100.138 20.5625C100.201 20.1204 100.318 19.6875 100.486 19.2637C100.66 18.8353 100.885 18.4502 101.163 18.1084C101.446 17.7666 101.781 17.4977 102.168 17.3018C102.56 17.1012 103.007 17.0078 103.508 17.0215C103.904 17.0306 104.235 17.1081 104.499 17.2539C104.768 17.3952 104.978 17.5889 105.128 17.835C105.278 18.0811 105.379 18.3659 105.429 18.6895C105.479 19.0085 105.483 19.348 105.442 19.708L104.636 24.5547H103.392L104.212 19.6875C104.244 19.3913 104.232 19.1247 104.178 18.8877C104.128 18.6462 104.014 18.4548 103.836 18.3135C103.663 18.1676 103.412 18.0902 103.084 18.0811C102.738 18.0719 102.425 18.138 102.147 18.2793C101.869 18.4206 101.626 18.6143 101.416 18.8604C101.211 19.1019 101.042 19.373 100.91 19.6738C100.783 19.9701 100.694 20.2708 100.644 20.5762ZM110.788 17.1582L110.617 18.1289H106.728L106.898 17.1582H110.788ZM108.525 15.3604H109.756L108.505 22.7363C108.491 22.8958 108.496 23.0394 108.519 23.167C108.541 23.2946 108.596 23.3971 108.683 23.4746C108.769 23.5475 108.901 23.5863 109.079 23.5908C109.179 23.5908 109.277 23.584 109.373 23.5703C109.473 23.5521 109.574 23.5361 109.674 23.5225L109.585 24.5615C109.439 24.6025 109.289 24.6322 109.134 24.6504C108.983 24.6732 108.833 24.6823 108.683 24.6777C108.304 24.6732 108.008 24.5775 107.794 24.3906C107.58 24.2038 107.434 23.9622 107.356 23.666C107.279 23.3698 107.256 23.0531 107.288 22.7158L108.525 15.3604ZM114.062 24.6914C113.557 24.6823 113.117 24.582 112.743 24.3906C112.374 24.1947 112.071 23.9326 111.834 23.6045C111.602 23.2718 111.435 22.8936 111.335 22.4697C111.235 22.0459 111.205 21.6016 111.246 21.1367L111.273 20.8428C111.319 20.3688 111.435 19.904 111.622 19.4482C111.809 18.988 112.057 18.5732 112.367 18.2041C112.682 17.835 113.051 17.5433 113.475 17.3291C113.903 17.1104 114.377 17.0078 114.896 17.0215C115.411 17.0306 115.84 17.14 116.182 17.3496C116.523 17.5592 116.79 17.8372 116.981 18.1836C117.177 18.5254 117.305 18.9105 117.364 19.3389C117.424 19.7627 117.428 20.1979 117.378 20.6445L117.303 21.2119H111.937L112.101 20.1797L116.195 20.1865L116.216 20.0771C116.261 19.749 116.243 19.4323 116.161 19.127C116.079 18.8216 115.929 18.571 115.71 18.375C115.496 18.1745 115.206 18.0697 114.842 18.0605C114.464 18.0469 114.135 18.1243 113.857 18.293C113.579 18.457 113.347 18.6803 113.16 18.9629C112.973 19.2409 112.825 19.5462 112.716 19.8789C112.611 20.207 112.538 20.5283 112.497 20.8428L112.47 21.1299C112.442 21.4215 112.451 21.7155 112.497 22.0117C112.543 22.3079 112.629 22.5791 112.757 22.8252C112.889 23.0667 113.071 23.265 113.304 23.4199C113.536 23.5703 113.823 23.6501 114.165 23.6592C114.58 23.6683 114.951 23.5794 115.279 23.3926C115.612 23.2012 115.915 22.9596 116.188 22.668L116.893 23.2695C116.678 23.584 116.423 23.8483 116.127 24.0625C115.831 24.2767 115.507 24.4362 115.156 24.541C114.805 24.6458 114.441 24.696 114.062 24.6914ZM120.372 18.8125L119.374 24.5547H118.137L119.422 17.1582H120.591L120.372 18.8125ZM119.798 20.5762L119.292 20.5625C119.356 20.1204 119.472 19.6875 119.641 19.2637C119.814 18.8353 120.039 18.4502 120.317 18.1084C120.6 17.7666 120.935 17.4977 121.322 17.3018C121.714 17.1012 122.161 17.0078 122.662 17.0215C123.059 17.0306 123.389 17.1081 123.653 17.2539C123.922 17.3952 124.132 17.5889 124.282 17.835C124.433 18.0811 124.533 18.3659 124.583 18.6895C124.633 19.0085 124.638 19.348 124.597 19.708L123.79 24.5547H122.546L123.366 19.6875C123.398 19.3913 123.387 19.1247 123.332 18.8877C123.282 18.6462 123.168 18.4548 122.99 18.3135C122.817 18.1676 122.566 18.0902 122.238 18.0811C121.892 18.0719 121.58 18.138 121.302 18.2793C121.024 18.4206 120.78 18.6143 120.57 18.8604C120.365 19.1019 120.197 19.373 120.064 19.6738C119.937 19.9701 119.848 20.2708 119.798 20.5762ZM128.773 24.6914C128.268 24.6823 127.828 24.582 127.454 24.3906C127.085 24.1947 126.782 23.9326 126.545 23.6045C126.312 23.2718 126.146 22.8936 126.046 22.4697C125.946 22.0459 125.916 21.6016 125.957 21.1367L125.984 20.8428C126.03 20.3688 126.146 19.904 126.333 19.4482C126.52 18.988 126.768 18.5732 127.078 18.2041C127.393 17.835 127.762 17.5433 128.186 17.3291C128.614 17.1104 129.088 17.0078 129.607 17.0215C130.122 17.0306 130.551 17.14 130.893 17.3496C131.234 17.5592 131.501 17.8372 131.692 18.1836C131.888 18.5254 132.016 18.9105 132.075 19.3389C132.134 19.7627 132.139 20.1979 132.089 20.6445L132.014 21.2119H126.647L126.812 20.1797L130.906 20.1865L130.927 20.0771C130.972 19.749 130.954 19.4323 130.872 19.127C130.79 18.8216 130.64 18.571 130.421 18.375C130.207 18.1745 129.917 18.0697 129.553 18.0605C129.174 18.0469 128.846 18.1243 128.568 18.293C128.29 18.457 128.058 18.6803 127.871 18.9629C127.684 19.2409 127.536 19.5462 127.427 19.8789C127.322 20.207 127.249 20.5283 127.208 20.8428L127.181 21.1299C127.153 21.4215 127.162 21.7155 127.208 22.0117C127.254 22.3079 127.34 22.5791 127.468 22.8252C127.6 23.0667 127.782 23.265 128.015 23.4199C128.247 23.5703 128.534 23.6501 128.876 23.6592C129.291 23.6683 129.662 23.5794 129.99 23.3926C130.323 23.2012 130.626 22.9596 130.899 22.668L131.604 23.2695C131.389 23.584 131.134 23.8483 130.838 24.0625C130.542 24.2767 130.218 24.4362 129.867 24.541C129.516 24.6458 129.152 24.696 128.773 24.6914ZM138.774 17.1582H139.909L138.672 24.3906C138.585 25.0059 138.387 25.5482 138.077 26.0176C137.772 26.487 137.371 26.8516 136.874 27.1113C136.382 27.3711 135.819 27.4941 135.186 27.4805C134.853 27.4714 134.527 27.4144 134.208 27.3096C133.889 27.2048 133.595 27.0566 133.326 26.8652C133.057 26.6738 132.832 26.4391 132.649 26.1611L133.36 25.4229C133.575 25.7282 133.827 25.9697 134.119 26.1475C134.415 26.3298 134.753 26.4277 135.131 26.4414C135.546 26.4505 135.912 26.373 136.231 26.209C136.555 26.0495 136.817 25.8193 137.018 25.5186C137.223 25.2178 137.357 24.8646 137.421 24.459L138.392 18.7236L138.774 17.1582ZM133.189 20.9932L133.21 20.8428C133.265 20.387 133.372 19.9313 133.531 19.4756C133.695 19.0199 133.914 18.6051 134.188 18.2314C134.461 17.8532 134.796 17.5547 135.192 17.3359C135.589 17.1126 136.051 17.0055 136.58 17.0146C137.059 17.0283 137.457 17.14 137.776 17.3496C138.095 17.5592 138.346 17.8372 138.528 18.1836C138.715 18.5254 138.84 18.9014 138.904 19.3115C138.973 19.7217 138.993 20.1341 138.966 20.5488L138.891 21.1777C138.813 21.6198 138.686 22.0527 138.508 22.4766C138.33 22.9004 138.1 23.2832 137.817 23.625C137.535 23.9622 137.198 24.2288 136.806 24.4248C136.418 24.6208 135.976 24.7119 135.479 24.6982C134.992 24.68 134.589 24.5547 134.27 24.3223C133.955 24.0898 133.711 23.7913 133.538 23.4268C133.365 23.0576 133.253 22.6611 133.203 22.2373C133.153 21.8089 133.148 21.3942 133.189 20.9932ZM134.454 20.8359L134.434 20.9863C134.402 21.2598 134.393 21.5469 134.406 21.8477C134.42 22.1484 134.472 22.4333 134.563 22.7021C134.655 22.9665 134.8 23.1852 135.001 23.3584C135.206 23.527 135.484 23.6159 135.835 23.625C136.209 23.6387 136.555 23.5566 136.874 23.3789C137.193 23.2012 137.466 22.9642 137.694 22.668C137.922 22.3717 138.086 22.0505 138.187 21.7041L138.453 20.043C138.467 19.7923 138.437 19.5508 138.364 19.3184C138.291 19.0859 138.182 18.8786 138.036 18.6963C137.895 18.514 137.722 18.3682 137.517 18.2588C137.312 18.1494 137.079 18.0924 136.819 18.0879C136.437 18.0742 136.106 18.1494 135.828 18.3135C135.55 18.473 135.315 18.6895 135.124 18.9629C134.937 19.2363 134.789 19.5371 134.68 19.8652C134.57 20.1934 134.495 20.5169 134.454 20.8359ZM142.787 18.375L141.714 24.5547H140.477L141.762 17.1582H142.965L142.787 18.375ZM145.187 17.0967L145.07 18.2861C144.975 18.2679 144.877 18.252 144.776 18.2383C144.681 18.2246 144.585 18.2178 144.489 18.2178C144.193 18.2132 143.926 18.2588 143.689 18.3545C143.457 18.4456 143.25 18.5755 143.067 18.7441C142.89 18.9128 142.737 19.111 142.609 19.3389C142.486 19.5667 142.388 19.8128 142.315 20.0771L141.926 20.2822C141.976 19.9131 142.058 19.5348 142.172 19.1475C142.29 18.7601 142.452 18.4023 142.657 18.0742C142.867 17.7461 143.129 17.4818 143.443 17.2812C143.762 17.0807 144.145 16.9873 144.592 17.001C144.692 17.001 144.79 17.0101 144.886 17.0283C144.986 17.0465 145.086 17.0693 145.187 17.0967ZM145.269 20.9795L145.289 20.8223C145.344 20.3255 145.467 19.847 145.658 19.3867C145.854 18.9264 146.112 18.5163 146.431 18.1562C146.75 17.7962 147.128 17.5137 147.565 17.3086C148.003 17.1035 148.491 17.0078 149.028 17.0215C149.548 17.0306 149.992 17.1423 150.361 17.3564C150.735 17.5706 151.036 17.8555 151.264 18.2109C151.496 18.5618 151.658 18.9583 151.749 19.4004C151.84 19.8424 151.863 20.2982 151.817 20.7676L151.804 20.9248C151.744 21.4215 151.617 21.8978 151.421 22.3535C151.225 22.8092 150.965 23.2148 150.642 23.5703C150.323 23.9258 149.944 24.2061 149.507 24.4111C149.069 24.6117 148.584 24.7051 148.051 24.6914C147.536 24.6823 147.091 24.5729 146.718 24.3633C146.349 24.1491 146.05 23.8665 145.822 23.5156C145.594 23.1647 145.435 22.7705 145.344 22.333C145.253 21.8955 145.228 21.4443 145.269 20.9795ZM146.52 20.8223L146.506 20.9863C146.474 21.2734 146.472 21.5719 146.499 21.8818C146.531 22.1917 146.604 22.4788 146.718 22.7432C146.836 23.0075 147.007 23.224 147.23 23.3926C147.454 23.5612 147.743 23.6501 148.099 23.6592C148.477 23.6683 148.81 23.5954 149.097 23.4404C149.384 23.2809 149.628 23.0667 149.828 22.7979C150.033 22.529 150.195 22.2305 150.313 21.9023C150.437 21.5742 150.519 21.2484 150.56 20.9248L150.573 20.7676C150.605 20.4805 150.605 20.182 150.573 19.8721C150.546 19.5576 150.473 19.266 150.354 18.9971C150.241 18.7236 150.072 18.5026 149.849 18.334C149.625 18.1608 149.336 18.0697 148.98 18.0605C148.602 18.0469 148.267 18.1221 147.976 18.2861C147.688 18.4456 147.445 18.6621 147.244 18.9355C147.044 19.209 146.882 19.512 146.759 19.8447C146.64 20.1729 146.561 20.4987 146.52 20.8223Z",
      "fill": "#484C57"
    }
  }), _c('path', {
    attrs: {
      "d": "M152 28.6562L152.484 28.4644L152.353 28.1359L152 28.1359L152 28.6562ZM155.416 44.2672C155.416 45.8 156.658 47.0425 158.191 47.0425C159.724 47.0425 160.966 45.8 160.966 44.2672C160.966 42.7345 159.724 41.492 158.191 41.492C156.658 41.492 155.416 42.7345 155.416 44.2672ZM56.1992 29.1767C63.828 29.1767 87.7782 29.1766 109.821 29.1766C120.843 29.1766 131.387 29.1766 139.177 29.1766C143.071 29.1766 146.277 29.1766 148.509 29.1766C149.625 29.1766 150.498 29.1766 151.092 29.1766C151.389 29.1766 151.616 29.1766 151.768 29.1766C151.845 29.1766 151.903 29.1766 151.942 29.1766C151.961 29.1766 151.976 29.1766 151.985 29.1766C151.99 29.1766 151.994 29.1766 151.996 29.1766C151.998 29.1766 151.998 29.1766 151.999 29.1766C152 29.1766 152 29.1766 152 28.6562C152 28.1359 152 28.1359 151.999 28.1359C151.998 28.1359 151.998 28.1359 151.996 28.1359C151.994 28.1359 151.99 28.1359 151.985 28.1359C151.976 28.1359 151.961 28.1359 151.942 28.1359C151.903 28.1359 151.845 28.1359 151.768 28.1359C151.616 28.1359 151.389 28.1359 151.092 28.1359C150.498 28.1359 149.625 28.1359 148.509 28.1359C146.277 28.1359 143.071 28.1359 139.177 28.1359C131.387 28.1359 120.843 28.1359 109.821 28.1359C87.7782 28.1359 63.828 28.1359 56.1992 28.1359L56.1992 29.1767ZM151.516 28.8481L157.707 44.4591L158.675 44.0754L152.484 28.4644L151.516 28.8481Z",
      "fill": "#07B53B"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }